// This file is auto-generated. Do not edit manually.
// Generated on 2025-10-17T03:15:12.511Z

interface ModelSpecificSettings {
    setting_id?: string;
    compatible_printers?: string[];
    [key: string]: any;
}

// Base settings types derived from available keys in source profiles
type BaseSettingKey = 'activate_air_filtration' | 'additional_cooling_fan_speed' | 'chamber_temperatures' | 'circle_compensation_speed' | 'close_fan_the_first_x_layers' | 'complete_print_exhaust_fan_speed' | 'cool_plate_temp' | 'cool_plate_temp_initial_layer' | 'counter_coef_1' | 'counter_coef_2' | 'counter_coef_3' | 'counter_limit_max' | 'counter_limit_min' | 'description' | 'diameter_limit' | 'during_print_exhaust_fan_speed' | 'eng_plate_temp' | 'eng_plate_temp_initial_layer' | 'fan_cooling_layer_time' | 'fan_max_speed' | 'fan_min_speed' | 'filament_adhesiveness_category' | 'filament_change_length' | 'filament_cost' | 'filament_density' | 'filament_deretraction_speed' | 'filament_diameter' | 'filament_end_gcode' | 'filament_extruder_id' | 'filament_extruder_variant' | 'filament_flow_ratio' | 'filament_flush_temp' | 'filament_flush_volumetric_speed' | 'filament_is_support' | 'filament_long_retractions_when_cut' | 'filament_long_retractions_when_ec' | 'filament_max_volumetric_speed' | 'filament_minimal_purge_on_wipe_tower' | 'filament_pre_cooling_temperature' | 'filament_prime_volume' | 'filament_printable' | 'filament_ramming_travel_time' | 'filament_ramming_volumetric_speed' | 'filament_retract_before_wipe' | 'filament_retract_restart_extra' | 'filament_retract_when_changing_layer' | 'filament_retraction_distances_when_cut' | 'filament_retraction_distances_when_ec' | 'filament_retraction_length' | 'filament_retraction_minimum_travel' | 'filament_retraction_speed' | 'filament_scarf_gap' | 'filament_scarf_height' | 'filament_scarf_length' | 'filament_scarf_seam_type' | 'filament_settings_id' | 'filament_shrink' | 'filament_soluble' | 'filament_start_gcode' | 'filament_type' | 'filament_wipe' | 'filament_wipe_distance' | 'filament_z_hop' | 'filament_z_hop_types' | 'full_fan_speed_layer' | 'hole_coef_1' | 'hole_coef_2' | 'hole_coef_3' | 'hole_limit_max' | 'hole_limit_min' | 'hot_plate_temp' | 'hot_plate_temp_initial_layer' | 'impact_strength_z' | 'instantiation' | 'long_retractions_when_ec' | 'nozzle_temperature' | 'nozzle_temperature_initial_layer' | 'nozzle_temperature_range_high' | 'nozzle_temperature_range_low' | 'overhang_fan_speed' | 'overhang_fan_threshold' | 'reduce_fan_stop_start_freq' | 'required_nozzle_HRC' | 'retraction_distances_when_ec' | 'slow_down_for_layer_cooling' | 'slow_down_layer_time' | 'slow_down_min_speed' | 'supertack_plate_temp' | 'supertack_plate_temp_initial_layer' | 'temperature_vitrification' | 'textured_plate_temp' | 'textured_plate_temp_initial_layer';
type BaseSettingPrimitive = string | number | boolean;
type BaseSettingValue = BaseSettingPrimitive | BaseSettingPrimitive[];
type BaseSettings = Partial<Record<BaseSettingKey, BaseSettingValue>>;

interface FilamentTypeSettings {
    filament_id: string;
    vendor: string;
    materialType: string;
    base_settings: BaseSettings;
    model_settings: {
        [printerModel: string]: ModelSpecificSettings;
    };
}

interface FilamentMapping {
    [materialType: string]: FilamentTypeSettings;
}

export const FILAMENT_MAPPINGS: FilamentMapping = {
  "GFA00": {
    "filament_id": "GFA00",
    "vendor": "Bambu Lab",
    "materialType": "PLA Basic",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "70"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "1"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "35"
      ],
      "cool_plate_temp_initial_layer": [
        "35"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "0"
      ],
      "eng_plate_temp_initial_layer": [
        "0"
      ],
      "fan_cooling_layer_time": [
        "100"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "100"
      ],
      "filament_cost": [
        "24.99"
      ],
      "filament_density": [
        "1.26"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.98"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "21"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PLA"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "30"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "55"
      ],
      "hot_plate_temp_initial_layer": [
        "55"
      ],
      "nozzle_temperature_range_low": [
        "190"
      ],
      "nozzle_temperature_range_high": [
        "240"
      ],
      "nozzle_temperature": [
        "220"
      ],
      "nozzle_temperature_initial_layer": [
        "220"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "50%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "45"
      ],
      "supertack_plate_temp_initial_layer": [
        "45"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "4"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "45"
      ],
      "textured_plate_temp": [
        "55"
      ],
      "textured_plate_temp_initial_layer": [
        "55"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "13.8"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "100"
      ],
      "filament_change_length": [
        "5"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSA00_04",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "pre_start_fan_time": [
          "2"
        ],
        "slow_down_layer_time": [
          "6"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSA00_02",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "pre_start_fan_time": [
          "2"
        ],
        "slow_down_layer_time": [
          "6"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSA00_12",
        "instantiation": "true",
        "additional_cooling_fan_speed": [
          "75"
        ],
        "counter_coef_2": [
          "0.003"
        ],
        "counter_coef_3": [
          "0.01"
        ],
        "counter_limit_max": [
          "0.088"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_flow_ratio": [
          "0.98",
          "0.98"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "25",
          "35"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "0.4",
          "0.4"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "1",
          "1"
        ],
        "filament_wipe_distance": [
          "1",
          "1"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "Spiral Lift",
          "Spiral Lift"
        ],
        "hole_coef_3": [
          "0.18"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "220",
          "220"
        ],
        "nozzle_temperature_initial_layer": [
          "220",
          "220"
        ],
        "pre_start_fan_time": [
          "2"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "X1": {
        "setting_id": "GFSA04",
        "instantiation": "true",
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "compatible_printers": [
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n\n"
        ]
      },
      "X1C": {
        "setting_id": "GFSA00",
        "instantiation": "true",
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\nM142 P1 R35 S40\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n\n"
        ]
      }
    }
  },
  "GFA01": {
    "filament_id": "GFA01",
    "vendor": "Bambu Lab",
    "materialType": "PLA Matte",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "70"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "1"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "35"
      ],
      "cool_plate_temp_initial_layer": [
        "35"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "0"
      ],
      "eng_plate_temp_initial_layer": [
        "0"
      ],
      "fan_cooling_layer_time": [
        "100"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "100"
      ],
      "filament_cost": [
        "24.99"
      ],
      "filament_density": [
        "1.32"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.98"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "12"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PLA"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "5%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "55"
      ],
      "hot_plate_temp_initial_layer": [
        "55"
      ],
      "nozzle_temperature_range_low": [
        "190"
      ],
      "nozzle_temperature_range_high": [
        "240"
      ],
      "nozzle_temperature": [
        "220"
      ],
      "nozzle_temperature_initial_layer": [
        "220"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "50%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "45"
      ],
      "supertack_plate_temp_initial_layer": [
        "45"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "4"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "45"
      ],
      "textured_plate_temp": [
        "55"
      ],
      "textured_plate_temp_initial_layer": [
        "55"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "6.6"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "100"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSA01_04",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_max_volumetric_speed": [
          "22"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "pre_start_fan_time": [
          "2"
        ],
        "slow_down_layer_time": [
          "6"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSA01_02",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_max_volumetric_speed": [
          "22"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "pre_start_fan_time": [
          "2"
        ],
        "slow_down_layer_time": [
          "6"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSA01_05",
        "instantiation": "true",
        "additional_cooling_fan_speed": [
          "75"
        ],
        "counter_coef_2": [
          "0.06"
        ],
        "counter_coef_3": [
          "-0.32"
        ],
        "counter_limit_max": [
          "0.05"
        ],
        "counter_limit_min": [
          "-0.4"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_flow_ratio": [
          "0.98",
          "0.98"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "25",
          "35"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "0.4",
          "0.4"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "1",
          "1"
        ],
        "filament_wipe_distance": [
          "1",
          "1"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "Spiral Lift",
          "Spiral Lift"
        ],
        "hole_coef_2": [
          "-0.0081"
        ],
        "hole_coef_3": [
          "0.18"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "220",
          "220"
        ],
        "nozzle_temperature_initial_layer": [
          "220",
          "220"
        ],
        "pre_start_fan_time": [
          "2"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "X1": {
        "setting_id": "GFSA05",
        "instantiation": "true",
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_max_volumetric_speed": [
          "22"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "compatible_printers": [
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\nM142 P1 R35 S40\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n\n"
        ]
      },
      "X1C": {
        "setting_id": "GFSA01",
        "instantiation": "true",
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_max_volumetric_speed": [
          "22"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\nM142 P1 R35 S40\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n\n"
        ]
      }
    }
  },
  "GFA02": {
    "filament_id": "GFA02",
    "vendor": "Bambu Lab",
    "materialType": "PLA Metal",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "70"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "1"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "35"
      ],
      "cool_plate_temp_initial_layer": [
        "35"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "0"
      ],
      "eng_plate_temp_initial_layer": [
        "0"
      ],
      "fan_cooling_layer_time": [
        "100"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "100"
      ],
      "filament_cost": [
        "29.99"
      ],
      "filament_density": [
        "1.25"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.98"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "12"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PLA"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "15%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "55"
      ],
      "hot_plate_temp_initial_layer": [
        "55"
      ],
      "nozzle_temperature_range_low": [
        "190"
      ],
      "nozzle_temperature_range_high": [
        "240"
      ],
      "nozzle_temperature": [
        "220"
      ],
      "nozzle_temperature_initial_layer": [
        "220"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "50%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "45"
      ],
      "supertack_plate_temp_initial_layer": [
        "45"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "4"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "45"
      ],
      "textured_plate_temp": [
        "55"
      ],
      "textured_plate_temp_initial_layer": [
        "55"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "16.8"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "100"
      ],
      "description": "To make the prints get higher gloss, please dry the filament before use, and set the outer wall speed to be 40 to 60 mm/s when slicing."
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSA02_04",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_max_volumetric_speed": [
          "21"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "slow_down_layer_time": [
          "6"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSA02_00",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_max_volumetric_speed": [
          "21"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "slow_down_layer_time": [
          "6"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSA02_07",
        "instantiation": "true",
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.98",
          "0.98"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "21",
          "21"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "0.4",
          "0.4"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "1",
          "1"
        ],
        "filament_wipe_distance": [
          "1",
          "1"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "Spiral Lift",
          "Spiral Lift"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "220",
          "220"
        ],
        "nozzle_temperature_initial_layer": [
          "220",
          "220"
        ],
        "pre_start_fan_time": [
          "2"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "X1": {
        "setting_id": "GFSA02_02",
        "instantiation": "true",
        "filament_max_volumetric_speed": [
          "21"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "compatible_printers": [
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n\n"
        ]
      },
      "X1C": {
        "setting_id": "GFSA02",
        "instantiation": "true",
        "filament_max_volumetric_speed": [
          "21"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\nM142 P1 R35 S40\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n\n"
        ]
      }
    }
  },
  "GFA05": {
    "filament_id": "GFA05",
    "vendor": "Bambu Lab",
    "materialType": "PLA Silk",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "70"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "1"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "35"
      ],
      "cool_plate_temp_initial_layer": [
        "35"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "0"
      ],
      "eng_plate_temp_initial_layer": [
        "0"
      ],
      "fan_cooling_layer_time": [
        "100"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "100"
      ],
      "filament_cost": [
        "29.99"
      ],
      "filament_density": [
        "1.32"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.98"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "12"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PLA"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "5%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "55"
      ],
      "hot_plate_temp_initial_layer": [
        "55"
      ],
      "nozzle_temperature_range_low": [
        "190"
      ],
      "nozzle_temperature_range_high": [
        "240"
      ],
      "nozzle_temperature": [
        "230"
      ],
      "nozzle_temperature_initial_layer": [
        "230"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "50%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "4"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "45"
      ],
      "textured_plate_temp": [
        "55"
      ],
      "textured_plate_temp_initial_layer": [
        "55"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "4.6"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "100"
      ],
      "description": "To make the prints get higher gloss, please dry the filament before use, and set the outer wall speed to be 40 to 60 mm/s when slicing."
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSA05_05",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "pre_start_fan_time": [
          "2"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSA05_03",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "pre_start_fan_time": [
          "2"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "60"
        ],
        "textured_plate_temp_initial_layer": [
          "60"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSA05_16",
        "instantiation": "true",
        "additional_cooling_fan_speed": [
          "75"
        ],
        "counter_coef_2": [
          "0.02"
        ],
        "counter_coef_3": [
          "-0.01"
        ],
        "counter_limit_min": [
          "-0.05"
        ],
        "counter_limit_max": [
          "0.05"
        ],
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.98",
          "0.98"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "12",
          "12"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "0.4",
          "0.4"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "1",
          "1"
        ],
        "filament_wipe_distance": [
          "1",
          "1"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "Spiral Lift",
          "Spiral Lift"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "hole_coef_2": [
          "-0.0081"
        ],
        "hole_coef_3": [
          "0.2"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "230",
          "230"
        ],
        "nozzle_temperature_initial_layer": [
          "230",
          "230"
        ],
        "pre_start_fan_time": [
          "2"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "slow_down_layer_time": [
          "6"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "X1": {
        "setting_id": "GFSA05_02",
        "instantiation": "true",
        "slow_down_layer_time": [
          "8"
        ],
        "compatible_printers": [
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n\n"
        ]
      },
      "X1C": {
        "setting_id": "GFSA05_01",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\nM142 P1 R35 S40\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n\n"
        ]
      }
    }
  },
  "GFA06": {
    "filament_id": "GFA06",
    "vendor": "Bambu Lab",
    "materialType": "PLA Silk+",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "70"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "1"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "35"
      ],
      "cool_plate_temp_initial_layer": [
        "35"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "0"
      ],
      "eng_plate_temp_initial_layer": [
        "0"
      ],
      "fan_cooling_layer_time": [
        "100"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "100"
      ],
      "filament_cost": [
        "29.99"
      ],
      "filament_density": [
        "1.27"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.98"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "12"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PLA"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "5%"
      ],
      "filament_scarf_gap": [
        "15%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "55"
      ],
      "hot_plate_temp_initial_layer": [
        "55"
      ],
      "nozzle_temperature_range_low": [
        "190"
      ],
      "nozzle_temperature_range_high": [
        "240"
      ],
      "nozzle_temperature": [
        "230"
      ],
      "nozzle_temperature_initial_layer": [
        "230"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "50%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "45"
      ],
      "supertack_plate_temp_initial_layer": [
        "45"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "4"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "45"
      ],
      "textured_plate_temp": [
        "55"
      ],
      "textured_plate_temp_initial_layer": [
        "55"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "8.5"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "100"
      ],
      "description": "To make the prints get higher gloss, please dry the filament before use, and set the outer wall speed to be 40 to 60 mm/s when slicing."
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSA06_05",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "supertack_plate_temp": [
          "35"
        ],
        "supertack_plate_temp_initial_layer": [
          "35"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSA06_07",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "supertack_plate_temp": [
          "35"
        ],
        "supertack_plate_temp_initial_layer": [
          "35"
        ],
        "textured_plate_temp": [
          "60"
        ],
        "textured_plate_temp_initial_layer": [
          "60"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSA06_09",
        "instantiation": "true",
        "additional_cooling_fan_speed": [
          "75"
        ],
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.98",
          "0.98"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "12",
          "12"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "0.4",
          "0.4"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "1",
          "1"
        ],
        "filament_wipe_distance": [
          "1",
          "1"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "Spiral Lift",
          "Spiral Lift"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "230",
          "230"
        ],
        "nozzle_temperature_initial_layer": [
          "230",
          "230"
        ],
        "pre_start_fan_time": [
          "2"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "supertack_plate_temp": [
          "35"
        ],
        "supertack_plate_temp_initial_layer": [
          "35"
        ],
        "slow_down_layer_time": [
          "6"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "P1P": {
        "setting_id": "GFSA06_03",
        "instantiation": "true",
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "supertack_plate_temp": [
          "35"
        ],
        "supertack_plate_temp_initial_layer": [
          "35"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle"
        ]
      },
      "X1": {
        "setting_id": "GFSA06_02",
        "instantiation": "true",
        "slow_down_layer_time": [
          "8"
        ],
        "supertack_plate_temp": [
          "35"
        ],
        "supertack_plate_temp_initial_layer": [
          "35"
        ],
        "compatible_printers": [
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSA06_00",
        "instantiation": "true",
        "supertack_plate_temp": [
          "35"
        ],
        "supertack_plate_temp_initial_layer": [
          "35"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\nM142 P1 R35 S40\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ]
      }
    }
  },
  "GFA07": {
    "filament_id": "GFA07",
    "vendor": "Bambu Lab",
    "materialType": "PLA Marble",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "70"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "1"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "35"
      ],
      "cool_plate_temp_initial_layer": [
        "35"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "0"
      ],
      "eng_plate_temp_initial_layer": [
        "0"
      ],
      "fan_cooling_layer_time": [
        "100"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "100"
      ],
      "filament_cost": [
        "29.99"
      ],
      "filament_density": [
        "1.22"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.98"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "12"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PLA"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "15%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "55"
      ],
      "hot_plate_temp_initial_layer": [
        "55"
      ],
      "nozzle_temperature_range_low": [
        "190"
      ],
      "nozzle_temperature_range_high": [
        "240"
      ],
      "nozzle_temperature": [
        "220"
      ],
      "nozzle_temperature_initial_layer": [
        "220"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "50%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "45"
      ],
      "supertack_plate_temp_initial_layer": [
        "45"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "4"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "45"
      ],
      "textured_plate_temp": [
        "55"
      ],
      "textured_plate_temp_initial_layer": [
        "55"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "6.5"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "100"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSA07_03",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "slow_down_layer_time": [
          "6"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSA07_02",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "slow_down_layer_time": [
          "6"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSA07_04",
        "instantiation": "true",
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.98",
          "0.98"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "12",
          "12"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "0.4",
          "0.4"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "1",
          "1"
        ],
        "filament_wipe_distance": [
          "1",
          "1"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "Spiral Lift",
          "Spiral Lift"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "220",
          "220"
        ],
        "nozzle_temperature_initial_layer": [
          "220",
          "220"
        ],
        "pre_start_fan_time": [
          "2"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "X1": {
        "setting_id": "GFSA07_01",
        "instantiation": "true",
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "compatible_printers": [
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n\n"
        ]
      },
      "X1C": {
        "setting_id": "GFSA07_00",
        "instantiation": "true",
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\nM142 P1 R35 S40\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n\n"
        ]
      }
    }
  },
  "GFA08": {
    "filament_id": "GFA08",
    "vendor": "Bambu Lab",
    "materialType": "PLA Sparkle",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "70"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "1"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "35"
      ],
      "cool_plate_temp_initial_layer": [
        "35"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "0"
      ],
      "eng_plate_temp_initial_layer": [
        "0"
      ],
      "fan_cooling_layer_time": [
        "100"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "100"
      ],
      "filament_cost": [
        "29.99"
      ],
      "filament_density": [
        "1.26"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.98"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "12"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PLA"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "15%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "55"
      ],
      "hot_plate_temp_initial_layer": [
        "55"
      ],
      "nozzle_temperature_range_low": [
        "190"
      ],
      "nozzle_temperature_range_high": [
        "240"
      ],
      "nozzle_temperature": [
        "220"
      ],
      "nozzle_temperature_initial_layer": [
        "220"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "50%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "45"
      ],
      "supertack_plate_temp_initial_layer": [
        "45"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "4"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "45"
      ],
      "textured_plate_temp": [
        "55"
      ],
      "textured_plate_temp_initial_layer": [
        "55"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10.3"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "100"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSA08_03",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "slow_down_layer_time": [
          "6"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSA08_02",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "slow_down_layer_time": [
          "6"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSA08_04",
        "instantiation": "true",
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.98",
          "0.98"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "12",
          "12"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "0.4",
          "0.4"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "1",
          "1"
        ],
        "filament_wipe_distance": [
          "1",
          "1"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "Spiral Lift",
          "Spiral Lift"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "220",
          "220"
        ],
        "nozzle_temperature_initial_layer": [
          "220",
          "220"
        ],
        "pre_start_fan_time": [
          "2"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "X1": {
        "setting_id": "GFSA08_01",
        "instantiation": "true",
        "slow_down_layer_time": [
          "8"
        ],
        "compatible_printers": [
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n\n"
        ]
      },
      "X1C": {
        "setting_id": "GFSA08_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\nM142 P1 R35 S40\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n\n"
        ]
      }
    }
  },
  "GFA09": {
    "filament_id": "GFA09",
    "vendor": "Bambu Lab",
    "materialType": "PLA Tough",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "70"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "1"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "35"
      ],
      "cool_plate_temp_initial_layer": [
        "35"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "0"
      ],
      "eng_plate_temp_initial_layer": [
        "0"
      ],
      "fan_cooling_layer_time": [
        "100"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "100"
      ],
      "filament_cost": [
        "28.99"
      ],
      "filament_density": [
        "1.26"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.98"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "12"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PLA"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "15%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "55"
      ],
      "hot_plate_temp_initial_layer": [
        "55"
      ],
      "nozzle_temperature_range_low": [
        "190"
      ],
      "nozzle_temperature_range_high": [
        "240"
      ],
      "nozzle_temperature": [
        "220"
      ],
      "nozzle_temperature_initial_layer": [
        "220"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "50%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "45"
      ],
      "supertack_plate_temp_initial_layer": [
        "45"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "4"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "45"
      ],
      "textured_plate_temp": [
        "55"
      ],
      "textured_plate_temp_initial_layer": [
        "55"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "12.3"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "100"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSA09_05",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_max_volumetric_speed": [
          "21"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "pre_start_fan_time": [
          "2"
        ],
        "slow_down_layer_time": [
          "6"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSA09_03",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_max_volumetric_speed": [
          "21"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "pre_start_fan_time": [
          "2"
        ],
        "slow_down_layer_time": [
          "6"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSA09_06",
        "instantiation": "true",
        "counter_coef_2": [
          "0.003"
        ],
        "counter_coef_3": [
          "0.024"
        ],
        "counter_limit_max": [
          "0.1"
        ],
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.98",
          "0.98"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "21",
          "21"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "0.4",
          "0.4"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "1",
          "1"
        ],
        "filament_wipe_distance": [
          "1",
          "1"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "Spiral Lift",
          "Spiral Lift"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "hole_coef_2": [
          "-0.0081"
        ],
        "hole_coef_3": [
          "0.2041"
        ],
        "hole_limit_min": [
          "0.08"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "220",
          "220"
        ],
        "nozzle_temperature_initial_layer": [
          "220",
          "220"
        ],
        "pre_start_fan_time": [
          "2"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "X1": {
        "setting_id": "GFSA09_01",
        "instantiation": "true",
        "filament_max_volumetric_speed": [
          "21"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "compatible_printers": [
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n\n"
        ]
      },
      "X1C": {
        "setting_id": "GFSA09_02",
        "instantiation": "true",
        "filament_max_volumetric_speed": [
          "21"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\nM142 P1 R35 S40\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n\n"
        ]
      }
    }
  },
  "GFA11": {
    "filament_id": "GFA11",
    "vendor": "Bambu Lab",
    "materialType": "PLA Aero",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "70"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "1"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "35"
      ],
      "cool_plate_temp_initial_layer": [
        "35"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "0"
      ],
      "eng_plate_temp_initial_layer": [
        "0"
      ],
      "fan_cooling_layer_time": [
        "100"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "30"
      ],
      "filament_cost": [
        "44.99"
      ],
      "filament_density": [
        "1.21"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.6"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "6"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PLA-AERO"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "15%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "55"
      ],
      "hot_plate_temp_initial_layer": [
        "55"
      ],
      "nozzle_temperature_range_low": [
        "210"
      ],
      "nozzle_temperature_range_high": [
        "260"
      ],
      "nozzle_temperature": [
        "220"
      ],
      "nozzle_temperature_initial_layer": [
        "220"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "50%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "4"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "45"
      ],
      "textured_plate_temp": [
        "55"
      ],
      "textured_plate_temp_initial_layer": [
        "55"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "3.1"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "100"
      ],
      "description": "This filament is only used to print models with a low density usually, and some special parameters are required. To get better printing quality, please refer to this wiki: Instructions for printing RC model with foaming PLA (PLA Aero)."
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSA11_04",
        "instantiation": "true",
        "additional_cooling_fan_speed": [
          "0"
        ],
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSA11_03",
        "instantiation": "true",
        "additional_cooling_fan_speed": [
          "0"
        ],
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSA11_05",
        "instantiation": "true",
        "additional_cooling_fan_speed": [
          "0"
        ],
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.6",
          "0.6"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "6",
          "6"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "220",
          "220"
        ],
        "nozzle_temperature_initial_layer": [
          "220",
          "220"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "X1": {
        "setting_id": "GFSA11_00",
        "instantiation": "true",
        "additional_cooling_fan_speed": [
          "0"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "compatible_printers": [
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSA11_01",
        "instantiation": "true",
        "additional_cooling_fan_speed": [
          "0"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\nM142 P1 R35 S40\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ]
      }
    }
  },
  "GFA12": {
    "filament_id": "GFA12",
    "vendor": "Bambu Lab",
    "materialType": "PLA Glow",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "70"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "1"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "35"
      ],
      "cool_plate_temp_initial_layer": [
        "35"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "0"
      ],
      "eng_plate_temp_initial_layer": [
        "0"
      ],
      "fan_cooling_layer_time": [
        "100"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "100"
      ],
      "filament_cost": [
        "29.99"
      ],
      "filament_density": [
        "1.26"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.98"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "18"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PLA"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "15%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "55"
      ],
      "hot_plate_temp_initial_layer": [
        "55"
      ],
      "nozzle_temperature_range_low": [
        "190"
      ],
      "nozzle_temperature_range_high": [
        "240"
      ],
      "nozzle_temperature": [
        "220"
      ],
      "nozzle_temperature_initial_layer": [
        "220"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "50%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "45"
      ],
      "supertack_plate_temp_initial_layer": [
        "45"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "4"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "45"
      ],
      "textured_plate_temp": [
        "55"
      ],
      "textured_plate_temp_initial_layer": [
        "55"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "19.8"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "100"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSA12_11",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_min_speed": [
          "50"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSA12_16",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_min_speed": [
          "50"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSA12_06",
        "instantiation": "true",
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.98",
          "0.98"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "18",
          "18"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "0.4",
          "0.4"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "1",
          "1"
        ],
        "filament_wipe_distance": [
          "1",
          "1"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "Spiral Lift",
          "Spiral Lift"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "220",
          "220"
        ],
        "nozzle_temperature_initial_layer": [
          "220",
          "220"
        ],
        "pre_start_fan_time": [
          "2"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "P1P": {
        "setting_id": "GFSA12_02",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_min_speed": [
          "50"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.8 nozzle"
        ]
      },
      "X1": {
        "setting_id": "GFSA12_08",
        "instantiation": "true",
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "compatible_printers": [
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSA12_00",
        "instantiation": "true",
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.4 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\nM142 P1 R35 S40\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ]
      },
      "X1E": {
        "setting_id": "GFSA12_04",
        "instantiation": "true",
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "compatible_printers": [
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\nM142 P1 R35 S40\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ]
      }
    }
  },
  "GFA13": {
    "filament_id": "GFA13",
    "vendor": "Bambu Lab",
    "materialType": "PLA Dynamic",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "70"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "1"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "35"
      ],
      "cool_plate_temp_initial_layer": [
        "35"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "0"
      ],
      "eng_plate_temp_initial_layer": [
        "0"
      ],
      "fan_cooling_layer_time": [
        "100"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "100"
      ],
      "filament_cost": [
        "31.99"
      ],
      "filament_density": [
        "1.26"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "1"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "12"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PLA"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "15%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "55"
      ],
      "hot_plate_temp_initial_layer": [
        "55"
      ],
      "nozzle_temperature_range_low": [
        "190"
      ],
      "nozzle_temperature_range_high": [
        "240"
      ],
      "nozzle_temperature": [
        "220"
      ],
      "nozzle_temperature_initial_layer": [
        "220"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "50%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "45"
      ],
      "supertack_plate_temp_initial_layer": [
        "45"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "4"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "45"
      ],
      "textured_plate_temp": [
        "55"
      ],
      "textured_plate_temp_initial_layer": [
        "55"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "20.8"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "100"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSA13_05",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_flow_ratio": [
          "0.98"
        ],
        "filament_max_volumetric_speed": [
          "21"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "slow_down_layer_time": [
          "6"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSA13_08",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_flow_ratio": [
          "0.98"
        ],
        "filament_max_volumetric_speed": [
          "21"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "slow_down_layer_time": [
          "6"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSA13_09",
        "instantiation": "true",
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.98",
          "0.98"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "21",
          "21"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "0.4",
          "0.4"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "1",
          "1"
        ],
        "filament_wipe_distance": [
          "1",
          "1"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "Spiral Lift",
          "Spiral Lift"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "220",
          "220"
        ],
        "nozzle_temperature_initial_layer": [
          "220",
          "220"
        ],
        "pre_start_fan_time": [
          "2"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "P1P": {
        "setting_id": "GFSA13_03",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_min_speed": [
          "50"
        ],
        "filament_flow_ratio": [
          "0.98"
        ],
        "filament_max_volumetric_speed": [
          "21"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSA13_00",
        "instantiation": "true",
        "filament_flow_ratio": [
          "0.98"
        ],
        "filament_max_volumetric_speed": [
          "21"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\nM142 P1 R35 S40\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ]
      }
    }
  },
  "GFA15": {
    "filament_id": "GFA15",
    "vendor": "Bambu Lab",
    "materialType": "PLA Galaxy",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "70"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "1"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "35"
      ],
      "cool_plate_temp_initial_layer": [
        "35"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "0"
      ],
      "eng_plate_temp_initial_layer": [
        "0"
      ],
      "fan_cooling_layer_time": [
        "100"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "100"
      ],
      "filament_cost": [
        "29.99"
      ],
      "filament_density": [
        "1.19"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.98"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "21"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PLA"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "15%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "55"
      ],
      "hot_plate_temp_initial_layer": [
        "55"
      ],
      "nozzle_temperature_range_low": [
        "190"
      ],
      "nozzle_temperature_range_high": [
        "240"
      ],
      "nozzle_temperature": [
        "220"
      ],
      "nozzle_temperature_initial_layer": [
        "220"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "50%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "45"
      ],
      "supertack_plate_temp_initial_layer": [
        "45"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "4"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "45"
      ],
      "textured_plate_temp": [
        "55"
      ],
      "textured_plate_temp_initial_layer": [
        "55"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "5.8"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "100"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSA15_05",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "pre_start_fan_time": [
          "2"
        ],
        "slow_down_layer_time": [
          "6"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSA15_07",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "pre_start_fan_time": [
          "2"
        ],
        "slow_down_layer_time": [
          "6"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSA15_09",
        "instantiation": "true",
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.98",
          "0.98"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "21",
          "21"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "0.4",
          "0.4"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "1",
          "1"
        ],
        "filament_wipe_distance": [
          "1",
          "1"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "Spiral Lift",
          "Spiral Lift"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "220",
          "220"
        ],
        "nozzle_temperature_initial_layer": [
          "220",
          "220"
        ],
        "pre_start_fan_time": [
          "2"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "P1P": {
        "setting_id": "GFSA15_03",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_min_speed": [
          "50"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSA15_00",
        "instantiation": "true",
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\nM142 P1 R35 S40\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ]
      }
    }
  },
  "GFA16": {
    "filament_id": "GFA16",
    "vendor": "Bambu Lab",
    "materialType": "PLA Wood",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "70"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "1"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "35"
      ],
      "cool_plate_temp_initial_layer": [
        "35"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "0"
      ],
      "eng_plate_temp_initial_layer": [
        "0"
      ],
      "fan_cooling_layer_time": [
        "100"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "100"
      ],
      "filament_cost": [
        "24.99"
      ],
      "filament_density": [
        "1.21"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.98"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "1"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "18"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "18"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PLA"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "15%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "55"
      ],
      "hot_plate_temp_initial_layer": [
        "55"
      ],
      "nozzle_temperature_range_low": [
        "190"
      ],
      "nozzle_temperature_range_high": [
        "240"
      ],
      "nozzle_temperature": [
        "220"
      ],
      "nozzle_temperature_initial_layer": [
        "220"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "50%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "45"
      ],
      "supertack_plate_temp_initial_layer": [
        "45"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "4"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "45"
      ],
      "textured_plate_temp": [
        "55"
      ],
      "textured_plate_temp_initial_layer": [
        "55"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "5.6"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\nM142 P1 R35 S40\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "100"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSA16_04",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "slow_down_layer_time": [
          "6"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ]
      },
      "A1M": {
        "setting_id": "GFSA16_05",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "slow_down_layer_time": [
          "6"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ]
      },
      "H2D": {
        "setting_id": "GFSA16_06",
        "instantiation": "true",
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.98",
          "0.98"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "18",
          "18"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "0.4",
          "0.4"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "1",
          "1"
        ],
        "filament_wipe_distance": [
          "1",
          "1"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "Spiral Lift",
          "Spiral Lift"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "220",
          "220"
        ],
        "nozzle_temperature_initial_layer": [
          "220",
          "220"
        ],
        "pre_start_fan_time": [
          "2"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "P1P": {
        "setting_id": "GFSA16_03",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_min_speed": [
          "50"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ]
      },
      "X1": {
        "setting_id": "GFSA16_02",
        "instantiation": "true",
        "slow_down_layer_time": [
          "8"
        ],
        "compatible_printers": [
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ]
      },
      "X1C": {
        "setting_id": "GFSA16_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle"
        ]
      }
    }
  },
  "GFA17": {
    "filament_id": "GFA17",
    "vendor": "Bambu Lab",
    "materialType": "PLA Translucent",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "70"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "1"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "35"
      ],
      "cool_plate_temp_initial_layer": [
        "35"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "0"
      ],
      "eng_plate_temp_initial_layer": [
        "0"
      ],
      "fan_cooling_layer_time": [
        "100"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "100"
      ],
      "filament_cost": [
        "24.99"
      ],
      "filament_density": [
        "1.22"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.98"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "12"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PLA"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "15%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "55"
      ],
      "hot_plate_temp_initial_layer": [
        "55"
      ],
      "nozzle_temperature_range_low": [
        "190"
      ],
      "nozzle_temperature_range_high": [
        "240"
      ],
      "nozzle_temperature": [
        "220"
      ],
      "nozzle_temperature_initial_layer": [
        "220"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "50%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "45"
      ],
      "supertack_plate_temp_initial_layer": [
        "45"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "8"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "45"
      ],
      "textured_plate_temp": [
        "55"
      ],
      "textured_plate_temp_initial_layer": [
        "55"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10.0"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "100"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSA17_06",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_retract_before_wipe": [
          "0"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "nozzle_temperature_range_low": [
          "200"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S255\n{elsif(bed_temperature[current_extruder] >35)||(bed_temperature_initial_layer[current_extruder] >35)}M106 P3 S180\n{endif};Prevent PLA from jamming\n\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ]
      },
      "A1M": {
        "setting_id": "GFSA17_09",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_retract_before_wipe": [
          "0"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "nozzle_temperature_range_low": [
          "200"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S255\n{elsif(bed_temperature[current_extruder] >35)||(bed_temperature_initial_layer[current_extruder] >35)}M106 P3 S180\n{endif};Prevent PLA from jamming\n\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ]
      },
      "H2D": {
        "setting_id": "GFSA17_12",
        "instantiation": "true",
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.98",
          "0.98"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "12",
          "12"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "0.4",
          "0.4"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "1",
          "1"
        ],
        "filament_wipe_distance": [
          "1",
          "1"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "Spiral Lift",
          "Spiral Lift"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "220",
          "220"
        ],
        "nozzle_temperature_initial_layer": [
          "220",
          "220"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\nM145 P0 ; set airduct mode to cooling mode\nM142 P1 R35 S40 U0.3 V0.5 ; set chamber autocooling"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "P1P": {
        "setting_id": "GFSA17_03",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_min_speed": [
          "50"
        ],
        "filament_retract_before_wipe": [
          "0"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "nozzle_temperature_range_low": [
          "200"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S255\n{elsif(bed_temperature[current_extruder] >35)||(bed_temperature_initial_layer[current_extruder] >35)}M106 P3 S180\n{endif};Prevent PLA from jamming\n\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ]
      },
      "X1C": {
        "setting_id": "GFSA17_00",
        "instantiation": "true",
        "description": "The generic presets are conservatively tuned for compatibility with a wider range of filaments. For higher printing quality and speeds, please use Bambu filaments with Bambu presets.",
        "filament_retract_before_wipe": [
          "0"
        ],
        "nozzle_temperature_range_low": [
          "200"
        ],
        "textured_plate_temp_initial_layer": [
          "60"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab X1E 0.4 nozzle"
        ]
      }
    }
  },
  "GFA18": {
    "filament_id": "GFA18",
    "vendor": "Bambu Lab",
    "materialType": "PLA Lite",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "70"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "1"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "35"
      ],
      "cool_plate_temp_initial_layer": [
        "35"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "0"
      ],
      "eng_plate_temp_initial_layer": [
        "0"
      ],
      "fan_cooling_layer_time": [
        "100"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "100"
      ],
      "filament_cost": [
        "0"
      ],
      "filament_density": [
        "1.40"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.98"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "16"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PLA"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "5%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "55"
      ],
      "hot_plate_temp_initial_layer": [
        "55"
      ],
      "nozzle_temperature_range_low": [
        "190"
      ],
      "nozzle_temperature_range_high": [
        "240"
      ],
      "nozzle_temperature": [
        "210"
      ],
      "nozzle_temperature_initial_layer": [
        "210"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "50%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "45"
      ],
      "supertack_plate_temp_initial_layer": [
        "45"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "4"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "45"
      ],
      "textured_plate_temp": [
        "55"
      ],
      "textured_plate_temp_initial_layer": [
        "55"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "6.6"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "100"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSA18_05",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "nozzle_temperature": [
          "220"
        ],
        "nozzle_temperature_initial_layer": [
          "220"
        ],
        "slow_down_layer_time": [
          "6"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSA18_07",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "nozzle_temperature": [
          "220"
        ],
        "nozzle_temperature_initial_layer": [
          "220"
        ],
        "slow_down_layer_time": [
          "6"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSA18_09",
        "instantiation": "true",
        "additional_cooling_fan_speed": [
          "75"
        ],
        "counter_coef_2": [
          "0.06"
        ],
        "counter_coef_3": [
          "-0.32"
        ],
        "counter_limit_max": [
          "0.05"
        ],
        "counter_limit_min": [
          "-0.4"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_cost": [
          "24.99"
        ],
        "filament_density": [
          "1.32"
        ],
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_flow_ratio": [
          "0.98",
          "0.98"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "20",
          "30"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "0.4",
          "0.4"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "1",
          "1"
        ],
        "filament_wipe_distance": [
          "1",
          "1"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "Spiral Lift",
          "Spiral Lift"
        ],
        "hole_coef_2": [
          "-0.0081"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "220",
          "220"
        ],
        "nozzle_temperature_initial_layer": [
          "220",
          "220"
        ],
        "pre_start_fan_time": [
          "2"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "P1P": {
        "setting_id": "GFSA18_03",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_min_speed": [
          "50"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "nozzle_temperature": [
          "220"
        ],
        "nozzle_temperature_initial_layer": [
          "220"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSA18_00",
        "instantiation": "true",
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "nozzle_temperature": [
          "220"
        ],
        "nozzle_temperature_initial_layer": [
          "220"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\nM142 P1 R35 S40\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ]
      }
    }
  },
  "GFA50": {
    "filament_id": "GFA50",
    "vendor": "Bambu Lab",
    "materialType": "PLA-CF",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "1"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "45"
      ],
      "cool_plate_temp_initial_layer": [
        "45"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "0"
      ],
      "eng_plate_temp_initial_layer": [
        "0"
      ],
      "fan_cooling_layer_time": [
        "100"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "100"
      ],
      "filament_cost": [
        "34.99"
      ],
      "filament_density": [
        "1.22"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.98"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "12"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PLA-CF"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "15%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "55"
      ],
      "hot_plate_temp_initial_layer": [
        "55"
      ],
      "nozzle_temperature_range_low": [
        "210"
      ],
      "nozzle_temperature_range_high": [
        "250"
      ],
      "nozzle_temperature": [
        "220"
      ],
      "nozzle_temperature_initial_layer": [
        "220"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "50%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "40"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "50"
      ],
      "supertack_plate_temp_initial_layer": [
        "50"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "8"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "45"
      ],
      "textured_plate_temp": [
        "55"
      ],
      "textured_plate_temp_initial_layer": [
        "55"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "7.8"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "100"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSA50_04",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_max_volumetric_speed": [
          "15"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "nozzle_temperature": [
          "230"
        ],
        "nozzle_temperature_initial_layer": [
          "230"
        ],
        "slow_down_layer_time": [
          "6"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSA50_00",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_max_volumetric_speed": [
          "15"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "nozzle_temperature": [
          "230"
        ],
        "nozzle_temperature_initial_layer": [
          "230"
        ],
        "slow_down_layer_time": [
          "6"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSA50_01",
        "instantiation": "true",
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_max_volumetric_speed": [
          "15"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "nozzle_temperature": [
          "230"
        ],
        "nozzle_temperature_initial_layer": [
          "230"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab X1E 0.4 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\nM142 P1 R35 S40\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n\n"
        ]
      }
    }
  },
  "GFB00": {
    "filament_id": "GFB00",
    "vendor": "Bambu Lab",
    "materialType": "ABS",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "1"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "3"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "90"
      ],
      "eng_plate_temp_initial_layer": [
        "90"
      ],
      "fan_cooling_layer_time": [
        "30"
      ],
      "fan_max_speed": [
        "80"
      ],
      "fan_min_speed": [
        "10"
      ],
      "filament_cost": [
        "24.99"
      ],
      "filament_density": [
        "1.04"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "28.6"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "ABS"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "90"
      ],
      "hot_plate_temp_initial_layer": [
        "90"
      ],
      "nozzle_temperature_range_low": [
        "240"
      ],
      "nozzle_temperature_range_high": [
        "280"
      ],
      "nozzle_temperature": [
        "270"
      ],
      "nozzle_temperature_initial_layer": [
        "260"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "80"
      ],
      "overhang_fan_threshold": [
        "25%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "3"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "100"
      ],
      "textured_plate_temp": [
        "90"
      ],
      "textured_plate_temp_initial_layer": [
        "90"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "7.4"
      ],
      "filament_start_gcode": [
        "; Filament gcode\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "200"
      ],
      "description": "When printing this filament, there's a risk of warping and low layer adhesion strength. To get better results, please refer to this wiki: Printing Tips for High Temp / Engineering materials."
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSB00_07",
        "instantiation": "true",
        "fan_max_speed": [
          "20"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_max_volumetric_speed": [
          "16"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "hot_plate_temp": [
          "100"
        ],
        "hot_plate_temp_initial_layer": [
          "100"
        ],
        "reduce_fan_stop_start_freq": [
          "0"
        ],
        "slow_down_layer_time": [
          "12"
        ],
        "textured_plate_temp": [
          "100"
        ],
        "textured_plate_temp_initial_layer": [
          "100"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSB00_11",
        "instantiation": "true",
        "chamber_temperatures": [
          "65"
        ],
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.95",
          "0.95"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "16",
          "16"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "270",
          "270"
        ],
        "nozzle_temperature_initial_layer": [
          "260",
          "260"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "X1C": {
        "setting_id": "GFSB00",
        "instantiation": "true",
        "fan_max_speed": [
          "60"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_max_volumetric_speed": [
          "16"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "slow_down_layer_time": [
          "12"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle"
        ]
      }
    }
  },
  "GFB01": {
    "filament_id": "GFB01",
    "vendor": "Bambu Lab",
    "materialType": "ASA",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "1"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "3"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "100"
      ],
      "eng_plate_temp_initial_layer": [
        "100"
      ],
      "fan_cooling_layer_time": [
        "35"
      ],
      "fan_max_speed": [
        "35"
      ],
      "fan_min_speed": [
        "10"
      ],
      "filament_cost": [
        "31.99"
      ],
      "filament_density": [
        "1.05"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "18"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "ASA"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "100"
      ],
      "hot_plate_temp_initial_layer": [
        "100"
      ],
      "nozzle_temperature_range_low": [
        "240"
      ],
      "nozzle_temperature_range_high": [
        "280"
      ],
      "nozzle_temperature": [
        "270"
      ],
      "nozzle_temperature_initial_layer": [
        "270"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "80"
      ],
      "overhang_fan_threshold": [
        "25%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "12"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "100"
      ],
      "textured_plate_temp": [
        "100"
      ],
      "textured_plate_temp_initial_layer": [
        "100"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "4.9"
      ],
      "filament_start_gcode": [
        "; Filament gcode\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "200"
      ],
      "description": "When printing this filament, there's a risk of warping and low layer adhesion strength. To get better results, please refer to this wiki: Printing Tips for High Temp / Engineering materials."
    },
    "model_settings": {
      "X1C": {
        "setting_id": "GFSB01_00",
        "instantiation": "true",
        "fan_min_speed": [
          "25"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab P1P 0.6 nozzle"
        ]
      }
    }
  },
  "GFB02": {
    "filament_id": "GFB02",
    "vendor": "Bambu Lab",
    "materialType": "ASA-Aero",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "1"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "3"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "90"
      ],
      "eng_plate_temp_initial_layer": [
        "90"
      ],
      "fan_cooling_layer_time": [
        "30"
      ],
      "fan_max_speed": [
        "50"
      ],
      "fan_min_speed": [
        "30"
      ],
      "filament_cost": [
        "49.99"
      ],
      "filament_density": [
        "0.99"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.52"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "12"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "1.5"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "ASA-AERO"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "5"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "Normal Lift"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "90"
      ],
      "hot_plate_temp_initial_layer": [
        "90"
      ],
      "nozzle_temperature_range_low": [
        "240"
      ],
      "nozzle_temperature_range_high": [
        "280"
      ],
      "nozzle_temperature": [
        "270"
      ],
      "nozzle_temperature_initial_layer": [
        "270"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "50"
      ],
      "overhang_fan_threshold": [
        "25%"
      ],
      "reduce_fan_stop_start_freq": [
        "0"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "5"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "100"
      ],
      "textured_plate_temp": [
        "90"
      ],
      "textured_plate_temp_initial_layer": [
        "90"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "3.4"
      ],
      "filament_start_gcode": [
        "; Filament gcode\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "200"
      ],
      "description": "This filament is only used to print models with a low density usually, and some special parameters are required. To get better printing quality, please refer to this wiki: ASA Aero Printing Guide."
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSB02_02",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSB02_03",
        "instantiation": "true",
        "chamber_temperatures": [
          "60"
        ],
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.52",
          "0.52"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "12",
          "12"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "270",
          "270"
        ],
        "nozzle_temperature_initial_layer": [
          "270",
          "270"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "P1P": {
        "setting_id": "GFSB02_01",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSB02_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "GFB50": {
    "filament_id": "GFB50",
    "vendor": "Bambu Lab",
    "materialType": "ABS-GF",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "1"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "3"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "90"
      ],
      "eng_plate_temp_initial_layer": [
        "90"
      ],
      "fan_cooling_layer_time": [
        "12"
      ],
      "fan_max_speed": [
        "30"
      ],
      "fan_min_speed": [
        "10"
      ],
      "filament_cost": [
        "29.99"
      ],
      "filament_density": [
        "1.08"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "12"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "ABS-GF"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "90"
      ],
      "hot_plate_temp_initial_layer": [
        "90"
      ],
      "nozzle_temperature_range_low": [
        "240"
      ],
      "nozzle_temperature_range_high": [
        "280"
      ],
      "nozzle_temperature": [
        "270"
      ],
      "nozzle_temperature_initial_layer": [
        "260"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "30"
      ],
      "overhang_fan_threshold": [
        "10%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "4"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "100"
      ],
      "textured_plate_temp": [
        "90"
      ],
      "textured_plate_temp_initial_layer": [
        "90"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "5.3"
      ],
      "filament_start_gcode": [
        "; Filament gcode\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "200"
      ],
      "description": "When printing this filament, there's a risk of nozzle clogging, oozing, warping and low layer adhesion strength. To get better results, please refer to this wiki: Printing Tips for High Temp / Engineering materials."
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSB50_02",
        "instantiation": "true",
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSB50_03",
        "instantiation": "true",
        "chamber_temperatures": [
          "60"
        ],
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.95",
          "0.95"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "12",
          "12"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "270",
          "270"
        ],
        "nozzle_temperature_initial_layer": [
          "260",
          "260"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "P1P": {
        "setting_id": "GFSB50_01",
        "instantiation": "true",
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "compatible_printers": [
          "Bambu Lab P1P 0.8 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.4 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSB50_00",
        "instantiation": "true",
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "compatible_printers": [
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "GFB51": {
    "filament_id": "GFB51",
    "vendor": "Bambu Lab",
    "materialType": "ASA-CF",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "1"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "3"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "100"
      ],
      "eng_plate_temp_initial_layer": [
        "100"
      ],
      "fan_cooling_layer_time": [
        "35"
      ],
      "fan_max_speed": [
        "25"
      ],
      "fan_min_speed": [
        "10"
      ],
      "filament_cost": [
        "36.99"
      ],
      "filament_density": [
        "1.02"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.9"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "18"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "ASA-CF"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "100"
      ],
      "hot_plate_temp_initial_layer": [
        "100"
      ],
      "nozzle_temperature_range_low": [
        "250"
      ],
      "nozzle_temperature_range_high": [
        "280"
      ],
      "nozzle_temperature": [
        "275"
      ],
      "nozzle_temperature_initial_layer": [
        "275"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "80"
      ],
      "overhang_fan_threshold": [
        "25%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "12"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "108"
      ],
      "textured_plate_temp": [
        "100"
      ],
      "textured_plate_temp_initial_layer": [
        "100"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "9.4"
      ],
      "filament_start_gcode": [
        "; Filament gcode\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "200"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSB51_04",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle"
        ]
      },
      "P1P": {
        "setting_id": "GFSB51_02",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSB51_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab X1E 0.4 nozzle"
        ]
      }
    }
  },
  "GFB60": {
    "filament_id": "GFB60",
    "vendor": "Polymaker",
    "materialType": "PolyLite ABS",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "1"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "3"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "90"
      ],
      "eng_plate_temp_initial_layer": [
        "90"
      ],
      "fan_cooling_layer_time": [
        "30"
      ],
      "fan_max_speed": [
        "80"
      ],
      "fan_min_speed": [
        "10"
      ],
      "filament_cost": [
        "26.9"
      ],
      "filament_density": [
        "1.03"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "15"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "ABS"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "90"
      ],
      "hot_plate_temp_initial_layer": [
        "90"
      ],
      "nozzle_temperature_range_low": [
        "240"
      ],
      "nozzle_temperature_range_high": [
        "280"
      ],
      "nozzle_temperature": [
        "270"
      ],
      "nozzle_temperature_initial_layer": [
        "260"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "80"
      ],
      "overhang_fan_threshold": [
        "25%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "3"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "100"
      ],
      "textured_plate_temp": [
        "90"
      ],
      "textured_plate_temp_initial_layer": [
        "90"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10"
      ],
      "filament_start_gcode": [
        "; Filament gcode\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "200"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSB60_06",
        "instantiation": "true",
        "fan_max_speed": [
          "20"
        ],
        "hot_plate_temp": [
          "100"
        ],
        "hot_plate_temp_initial_layer": [
          "100"
        ],
        "reduce_fan_stop_start_freq": [
          "0"
        ],
        "textured_plate_temp": [
          "100"
        ],
        "textured_plate_temp_initial_layer": [
          "100"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSB60_08",
        "instantiation": "true",
        "chamber_temperatures": [
          "60"
        ],
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.95",
          "0.95"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "15",
          "15"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "270",
          "270"
        ],
        "nozzle_temperature_initial_layer": [
          "260",
          "260"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "P1P": {
        "setting_id": "GFSB60_04",
        "instantiation": "true",
        "fan_max_speed": [
          "20"
        ],
        "hot_plate_temp": [
          "100"
        ],
        "hot_plate_temp_initial_layer": [
          "100"
        ],
        "reduce_fan_stop_start_freq": [
          "0"
        ],
        "textured_plate_temp": [
          "100"
        ],
        "textured_plate_temp_initial_layer": [
          "100"
        ],
        "compatible_printers": [
          "Bambu Lab P1P 0.8 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.4 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSB60_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle"
        ]
      }
    }
  },
  "GFB61": {
    "filament_id": "GFB61",
    "vendor": "Polymaker",
    "materialType": "PolyLite ASA",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "1"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "3"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "100"
      ],
      "eng_plate_temp_initial_layer": [
        "100"
      ],
      "fan_cooling_layer_time": [
        "35"
      ],
      "fan_max_speed": [
        "80"
      ],
      "fan_min_speed": [
        "10"
      ],
      "filament_cost": [
        "23.6"
      ],
      "filament_density": [
        "1.02"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "13"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "ASA"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "100"
      ],
      "hot_plate_temp_initial_layer": [
        "100"
      ],
      "nozzle_temperature_range_low": [
        "240"
      ],
      "nozzle_temperature_range_high": [
        "280"
      ],
      "nozzle_temperature": [
        "260"
      ],
      "nozzle_temperature_initial_layer": [
        "260"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "80"
      ],
      "overhang_fan_threshold": [
        "25%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "3"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "100"
      ],
      "textured_plate_temp": [
        "100"
      ],
      "textured_plate_temp_initial_layer": [
        "100"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "4.9"
      ],
      "filament_start_gcode": [
        "; Filament gcode\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "200"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSB61_07",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSB61_08",
        "instantiation": "true",
        "chamber_temperatures": [
          "60"
        ],
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.95",
          "0.95"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "13",
          "13"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "260",
          "260"
        ],
        "nozzle_temperature_initial_layer": [
          "260",
          "260"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "P1P": {
        "setting_id": "GFSB61_04",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSB61_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle"
        ]
      }
    }
  },
  "GFB98": {
    "filament_id": "GFB98",
    "vendor": "Generic",
    "materialType": "Generic ASA",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "1"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "3"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "100"
      ],
      "eng_plate_temp_initial_layer": [
        "100"
      ],
      "fan_cooling_layer_time": [
        "35"
      ],
      "fan_max_speed": [
        "80"
      ],
      "fan_min_speed": [
        "10"
      ],
      "filament_cost": [
        "20"
      ],
      "filament_density": [
        "1.04"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "12"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "ASA"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "100"
      ],
      "hot_plate_temp_initial_layer": [
        "100"
      ],
      "nozzle_temperature_range_low": [
        "240"
      ],
      "nozzle_temperature_range_high": [
        "280"
      ],
      "nozzle_temperature": [
        "260"
      ],
      "nozzle_temperature_initial_layer": [
        "260"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "80"
      ],
      "overhang_fan_threshold": [
        "25%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "3"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "100"
      ],
      "textured_plate_temp": [
        "100"
      ],
      "textured_plate_temp_initial_layer": [
        "100"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "4.9"
      ],
      "filament_start_gcode": [
        "; Filament gcode\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "200"
      ],
      "description": "When printing this filament, there's a risk of warping and low layer adhesion strength. To get better results, please refer to this wiki: Printing Tips for High Temp / Engineering materials."
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSB98_04",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSB98_06",
        "instantiation": "true",
        "chamber_temperatures": [
          "60"
        ],
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.95",
          "0.95"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "12",
          "12"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "260",
          "260"
        ],
        "nozzle_temperature_initial_layer": [
          "260",
          "260"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      }
    }
  },
  "GFB99": {
    "filament_id": "GFB99",
    "vendor": "Generic",
    "materialType": "Generic ABS",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "1"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "3"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "90"
      ],
      "eng_plate_temp_initial_layer": [
        "90"
      ],
      "fan_cooling_layer_time": [
        "30"
      ],
      "fan_max_speed": [
        "80"
      ],
      "fan_min_speed": [
        "10"
      ],
      "filament_cost": [
        "20"
      ],
      "filament_density": [
        "1.04"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "16"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "ABS"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "90"
      ],
      "hot_plate_temp_initial_layer": [
        "90"
      ],
      "nozzle_temperature_range_low": [
        "240"
      ],
      "nozzle_temperature_range_high": [
        "280"
      ],
      "nozzle_temperature": [
        "270"
      ],
      "nozzle_temperature_initial_layer": [
        "260"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "80"
      ],
      "overhang_fan_threshold": [
        "25%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "3"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "100"
      ],
      "textured_plate_temp": [
        "90"
      ],
      "textured_plate_temp_initial_layer": [
        "90"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10"
      ],
      "filament_start_gcode": [
        "; Filament gcode\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "200"
      ],
      "description": "When printing this filament, there's a risk of warping and low layer adhesion strength. To get better results, please refer to this wiki: Printing Tips for High Temp / Engineering materials."
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSB99_05",
        "instantiation": "true",
        "fan_max_speed": [
          "20"
        ],
        "filament_max_volumetric_speed": [
          "15"
        ],
        "hot_plate_temp": [
          "100"
        ],
        "hot_plate_temp_initial_layer": [
          "100"
        ],
        "reduce_fan_stop_start_freq": [
          "0"
        ],
        "textured_plate_temp": [
          "100"
        ],
        "textured_plate_temp_initial_layer": [
          "100"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSB99_07",
        "instantiation": "true",
        "chamber_temperatures": [
          "60"
        ],
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.95",
          "0.95"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "15",
          "15"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "270",
          "270"
        ],
        "nozzle_temperature_initial_layer": [
          "260",
          "260"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      }
    }
  },
  "GFC00": {
    "filament_id": "GFC00",
    "vendor": "Bambu Lab",
    "materialType": "PC",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "3"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "110"
      ],
      "eng_plate_temp_initial_layer": [
        "110"
      ],
      "fan_cooling_layer_time": [
        "30"
      ],
      "fan_max_speed": [
        "60"
      ],
      "fan_min_speed": [
        "10"
      ],
      "filament_cost": [
        "39.99"
      ],
      "filament_density": [
        "1.04"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.94"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "18"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PC"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "110"
      ],
      "hot_plate_temp_initial_layer": [
        "110"
      ],
      "nozzle_temperature_range_low": [
        "260"
      ],
      "nozzle_temperature_range_high": [
        "290"
      ],
      "nozzle_temperature": [
        "280"
      ],
      "nozzle_temperature_initial_layer": [
        "270"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "60"
      ],
      "overhang_fan_threshold": [
        "25%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "2"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "120"
      ],
      "textured_plate_temp": [
        "110"
      ],
      "textured_plate_temp_initial_layer": [
        "110"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "9.0"
      ],
      "filament_start_gcode": [
        "; Filament gcode\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "500"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSC00_14",
        "instantiation": "true",
        "eng_plate_temp": [
          "100"
        ],
        "eng_plate_temp_initial_layer": [
          "100"
        ],
        "fan_max_speed": [
          "20"
        ],
        "hot_plate_temp": [
          "100"
        ],
        "hot_plate_temp_initial_layer": [
          "100"
        ],
        "reduce_fan_stop_start_freq": [
          "0"
        ],
        "slow_down_layer_time": [
          "12"
        ],
        "textured_plate_temp": [
          "100"
        ],
        "textured_plate_temp_initial_layer": [
          "100"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSC00",
        "instantiation": "true",
        "fan_max_speed": [
          "40"
        ],
        "slow_down_layer_time": [
          "12"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 0.4 nozzle"
        ]
      }
    }
  },
  "GFC01": {
    "filament_id": "GFC01",
    "vendor": "Bambu Lab",
    "materialType": "PC FR",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "3"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "110"
      ],
      "eng_plate_temp_initial_layer": [
        "110"
      ],
      "fan_cooling_layer_time": [
        "30"
      ],
      "fan_max_speed": [
        "60"
      ],
      "fan_min_speed": [
        "10"
      ],
      "filament_cost": [
        "0"
      ],
      "filament_density": [
        "1.19"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.94"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "18"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PC"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "110"
      ],
      "hot_plate_temp_initial_layer": [
        "110"
      ],
      "nozzle_temperature_range_low": [
        "260"
      ],
      "nozzle_temperature_range_high": [
        "290"
      ],
      "nozzle_temperature": [
        "280"
      ],
      "nozzle_temperature_initial_layer": [
        "270"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "60"
      ],
      "overhang_fan_threshold": [
        "25%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "2"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "120"
      ],
      "textured_plate_temp": [
        "110"
      ],
      "textured_plate_temp_initial_layer": [
        "110"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "8"
      ],
      "filament_start_gcode": [
        "; Filament gcode\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "500"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSC01_14",
        "instantiation": "true",
        "eng_plate_temp": [
          "100"
        ],
        "eng_plate_temp_initial_layer": [
          "100"
        ],
        "fan_max_speed": [
          "20"
        ],
        "hot_plate_temp": [
          "100"
        ],
        "hot_plate_temp_initial_layer": [
          "100"
        ],
        "reduce_fan_stop_start_freq": [
          "0"
        ],
        "slow_down_layer_time": [
          "12"
        ],
        "textured_plate_temp": [
          "100"
        ],
        "textured_plate_temp_initial_layer": [
          "100"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "P1P": {
        "setting_id": "GFSC01_08",
        "instantiation": "true",
        "eng_plate_temp": [
          "100"
        ],
        "eng_plate_temp_initial_layer": [
          "100"
        ],
        "fan_max_speed": [
          "20"
        ],
        "hot_plate_temp": [
          "100"
        ],
        "hot_plate_temp_initial_layer": [
          "100"
        ],
        "reduce_fan_stop_start_freq": [
          "0"
        ],
        "slow_down_layer_time": [
          "12"
        ],
        "textured_plate_temp": [
          "100"
        ],
        "textured_plate_temp_initial_layer": [
          "100"
        ],
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle"
        ]
      },
      "P1S": {
        "setting_id": "GFSC01_04",
        "instantiation": "true",
        "eng_plate_temp": [
          "100"
        ],
        "eng_plate_temp_initial_layer": [
          "100"
        ],
        "fan_max_speed": [
          "40"
        ],
        "hot_plate_temp": [
          "100"
        ],
        "hot_plate_temp_initial_layer": [
          "100"
        ],
        "slow_down_layer_time": [
          "12"
        ],
        "textured_plate_temp": [
          "100"
        ],
        "textured_plate_temp_initial_layer": [
          "100"
        ],
        "compatible_printers": [
          "Bambu Lab P1S 0.4 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSC01_00",
        "instantiation": "true",
        "fan_max_speed": [
          "40"
        ],
        "slow_down_layer_time": [
          "12"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 0.4 nozzle"
        ]
      },
      "X1E": {
        "setting_id": "GFSC01_10",
        "instantiation": "true",
        "chamber_temperatures": [
          "60"
        ],
        "fan_max_speed": [
          "40"
        ],
        "slow_down_layer_time": [
          "12"
        ],
        "compatible_printers": [
          "Bambu Lab X1E 0.4 nozzle"
        ]
      }
    }
  },
  "GFC99": {
    "filament_id": "GFC99",
    "vendor": "Generic",
    "materialType": "Generic PC",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "3"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "110"
      ],
      "eng_plate_temp_initial_layer": [
        "110"
      ],
      "fan_cooling_layer_time": [
        "30"
      ],
      "fan_max_speed": [
        "60"
      ],
      "fan_min_speed": [
        "10"
      ],
      "filament_cost": [
        "20"
      ],
      "filament_density": [
        "1.04"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.94"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "16"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PC"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "110"
      ],
      "hot_plate_temp_initial_layer": [
        "110"
      ],
      "nozzle_temperature_range_low": [
        "260"
      ],
      "nozzle_temperature_range_high": [
        "290"
      ],
      "nozzle_temperature": [
        "280"
      ],
      "nozzle_temperature_initial_layer": [
        "270"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "60"
      ],
      "overhang_fan_threshold": [
        "25%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "2"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "120"
      ],
      "textured_plate_temp": [
        "110"
      ],
      "textured_plate_temp_initial_layer": [
        "110"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10"
      ],
      "filament_start_gcode": [
        "; Filament gcode\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "500"
      ],
      "description": "When printing this filament, there's a risk of warping and low layer adhesion strength. To get better results, please refer to this wiki: Printing Tips for High Temp / Engineering materials."
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSC99_07",
        "instantiation": "true",
        "eng_plate_temp": [
          "100"
        ],
        "eng_plate_temp_initial_layer": [
          "100"
        ],
        "fan_max_speed": [
          "20"
        ],
        "hot_plate_temp": [
          "100"
        ],
        "hot_plate_temp_initial_layer": [
          "100"
        ],
        "reduce_fan_stop_start_freq": [
          "0"
        ],
        "textured_plate_temp": [
          "100"
        ],
        "textured_plate_temp_initial_layer": [
          "100"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSC99_10",
        "instantiation": "true",
        "chamber_temperatures": [
          "60"
        ],
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.94",
          "0.94"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "16",
          "16"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "280",
          "280"
        ],
        "nozzle_temperature_initial_layer": [
          "270",
          "270"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      }
    }
  },
  "GFG00": {
    "filament_id": "GFG00",
    "vendor": "Bambu Lab",
    "materialType": "PETG Basic",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "3"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "70"
      ],
      "eng_plate_temp_initial_layer": [
        "70"
      ],
      "fan_cooling_layer_time": [
        "30"
      ],
      "fan_max_speed": [
        "40"
      ],
      "fan_min_speed": [
        "10"
      ],
      "filament_cost": [
        "24.99"
      ],
      "filament_density": [
        "1.25"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "8"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PETG"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "70"
      ],
      "hot_plate_temp_initial_layer": [
        "70"
      ],
      "nozzle_temperature_range_low": [
        "230"
      ],
      "nozzle_temperature_range_high": [
        "270"
      ],
      "nozzle_temperature": [
        "255"
      ],
      "nozzle_temperature_initial_layer": [
        "255"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "90"
      ],
      "overhang_fan_threshold": [
        "10%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "70"
      ],
      "supertack_plate_temp_initial_layer": [
        "70"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "12"
      ],
      "slow_down_min_speed": [
        "10"
      ],
      "temperature_vitrification": [
        "70"
      ],
      "textured_plate_temp": [
        "70"
      ],
      "textured_plate_temp_initial_layer": [
        "70"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "13.6"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if (bed_temperature[current_extruder] >80)||(bed_temperature_initial_layer[current_extruder] >80)}M106 P3 S255\n{elsif (bed_temperature[current_extruder] >60)||(bed_temperature_initial_layer[current_extruder] >60)}M106 P3 S180\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "300"
      ],
      "description": "To get better transparent or translucent results with the corresponding filament, please refer to this wiki: Printing tips for transparent PETG."
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSG00_06",
        "instantiation": "true",
        "filament_flow_ratio": [
          "0.94"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_max_volumetric_speed": [
          "9"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "pre_start_fan_time": [
          "2"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSG00_01",
        "instantiation": "true",
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_max_volumetric_speed": [
          "13"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab X1E 0.4 nozzle"
        ]
      }
    }
  },
  "GFG01": {
    "filament_id": "GFG01",
    "vendor": "Bambu Lab",
    "materialType": "PETG Translucent",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "3"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "70"
      ],
      "eng_plate_temp_initial_layer": [
        "70"
      ],
      "fan_cooling_layer_time": [
        "30"
      ],
      "fan_max_speed": [
        "30"
      ],
      "fan_min_speed": [
        "10"
      ],
      "filament_cost": [
        "24.99"
      ],
      "filament_density": [
        "1.25"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "6"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PETG"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "70"
      ],
      "hot_plate_temp_initial_layer": [
        "70"
      ],
      "nozzle_temperature_range_low": [
        "230"
      ],
      "nozzle_temperature_range_high": [
        "270"
      ],
      "nozzle_temperature": [
        "245"
      ],
      "nozzle_temperature_initial_layer": [
        "250"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "90"
      ],
      "overhang_fan_threshold": [
        "10%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "70"
      ],
      "supertack_plate_temp_initial_layer": [
        "70"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "12"
      ],
      "slow_down_min_speed": [
        "10"
      ],
      "temperature_vitrification": [
        "70"
      ],
      "textured_plate_temp": [
        "70"
      ],
      "textured_plate_temp_initial_layer": [
        "70"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "7.2"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if (bed_temperature[current_extruder] >80)||(bed_temperature_initial_layer[current_extruder] >80)}M106 P3 S255\n{elsif (bed_temperature[current_extruder] >60)||(bed_temperature_initial_layer[current_extruder] >60)}M106 P3 S180\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "300"
      ],
      "description": "To get better transparent or translucent results with the corresponding filament, please refer to this wiki: Printing tips for transparent PETG."
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSG01_05",
        "instantiation": "true",
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "filament_retraction_length": [
          "0.3"
        ],
        "pre_start_fan_time": [
          "2"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSG01_02",
        "instantiation": "true",
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "filament_retraction_length": [
          "0.3"
        ],
        "pre_start_fan_time": [
          "2"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSG01_00",
        "instantiation": "true",
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "filament_retraction_length": [
          "0.3"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab X1E 0.4 nozzle"
        ]
      }
    }
  },
  "GFG02": {
    "filament_id": "GFG02",
    "vendor": "Bambu Lab",
    "materialType": "PETG HF",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "3"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "70"
      ],
      "eng_plate_temp_initial_layer": [
        "70"
      ],
      "fan_cooling_layer_time": [
        "30"
      ],
      "fan_max_speed": [
        "40"
      ],
      "fan_min_speed": [
        "10"
      ],
      "filament_cost": [
        "24.99"
      ],
      "filament_density": [
        "1.28"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "21"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PETG"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "30"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "70"
      ],
      "hot_plate_temp_initial_layer": [
        "70"
      ],
      "nozzle_temperature_range_low": [
        "230"
      ],
      "nozzle_temperature_range_high": [
        "270"
      ],
      "nozzle_temperature": [
        "245"
      ],
      "nozzle_temperature_initial_layer": [
        "230"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "90"
      ],
      "overhang_fan_threshold": [
        "10%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "70"
      ],
      "supertack_plate_temp_initial_layer": [
        "70"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "12"
      ],
      "slow_down_min_speed": [
        "10"
      ],
      "temperature_vitrification": [
        "70"
      ],
      "textured_plate_temp": [
        "70"
      ],
      "textured_plate_temp_initial_layer": [
        "70"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10.6"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if (bed_temperature[current_extruder] >80)||(bed_temperature_initial_layer[current_extruder] >80)}M106 P3 S255\n{elsif (bed_temperature[current_extruder] >60)||(bed_temperature_initial_layer[current_extruder] >60)}M106 P3 S180\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "300"
      ],
      "filament_change_length": [
        "12"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSG02_03",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "15"
        ],
        "fan_max_speed": [
          "50"
        ],
        "fan_min_speed": [
          "30"
        ],
        "filament_flow_ratio": [
          "0.94"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_max_volumetric_speed": [
          "18"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "nozzle_temperature": [
          "240"
        ],
        "overhang_fan_speed": [
          "100"
        ],
        "pre_start_fan_time": [
          "2"
        ],
        "slow_down_layer_time": [
          "7"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSG02_06",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "15"
        ],
        "fan_max_speed": [
          "50"
        ],
        "fan_min_speed": [
          "30"
        ],
        "filament_flow_ratio": [
          "0.94"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_max_volumetric_speed": [
          "18"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "nozzle_temperature": [
          "240"
        ],
        "overhang_fan_speed": [
          "100"
        ],
        "pre_start_fan_time": [
          "2"
        ],
        "slow_down_layer_time": [
          "7"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSG02_00",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "20"
        ],
        "fan_min_speed": [
          "20"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "overhang_fan_speed": [
          "100"
        ],
        "slow_down_layer_time": [
          "10"
        ],
        "slow_down_min_speed": [
          "20"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab X1E 0.4 nozzle"
        ]
      }
    }
  },
  "GFG50": {
    "filament_id": "GFG50",
    "vendor": "Bambu Lab",
    "materialType": "PETG-CF",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "3"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "70"
      ],
      "eng_plate_temp_initial_layer": [
        "70"
      ],
      "fan_cooling_layer_time": [
        "20"
      ],
      "fan_max_speed": [
        "30"
      ],
      "fan_min_speed": [
        "0"
      ],
      "filament_cost": [
        "34.99"
      ],
      "filament_density": [
        "1.25"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "14"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PETG-CF"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "70"
      ],
      "hot_plate_temp_initial_layer": [
        "70"
      ],
      "nozzle_temperature_range_low": [
        "240"
      ],
      "nozzle_temperature_range_high": [
        "270"
      ],
      "nozzle_temperature": [
        "255"
      ],
      "nozzle_temperature_initial_layer": [
        "255"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "90"
      ],
      "overhang_fan_threshold": [
        "10%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "40"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "70"
      ],
      "supertack_plate_temp_initial_layer": [
        "70"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "6"
      ],
      "slow_down_min_speed": [
        "10"
      ],
      "temperature_vitrification": [
        "70"
      ],
      "textured_plate_temp": [
        "70"
      ],
      "textured_plate_temp_initial_layer": [
        "70"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10.7"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if (bed_temperature[current_extruder] >80)||(bed_temperature_initial_layer[current_extruder] >80)}M106 P3 S255\n{elsif (bed_temperature[current_extruder] >60)||(bed_temperature_initial_layer[current_extruder] >60)}M106 P3 S180\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "300"
      ]
    },
    "model_settings": {
      "A1M": {
        "setting_id": "GFSG50_00",
        "instantiation": "true",
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_max_volumetric_speed": [
          "9"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSG50_01",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "30"
        ],
        "fan_max_speed": [
          "40"
        ],
        "fan_min_speed": [
          "5"
        ],
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_max_volumetric_speed": [
          "11.5"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "overhang_fan_speed": [
          "100"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "GFG60": {
    "filament_id": "GFG60",
    "vendor": "Polymaker",
    "materialType": "PolyLite PETG",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "3"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "70"
      ],
      "eng_plate_temp_initial_layer": [
        "70"
      ],
      "fan_cooling_layer_time": [
        "30"
      ],
      "fan_max_speed": [
        "90"
      ],
      "fan_min_speed": [
        "40"
      ],
      "filament_cost": [
        "30"
      ],
      "filament_density": [
        "1.27"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "25"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PETG"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "70"
      ],
      "hot_plate_temp_initial_layer": [
        "70"
      ],
      "nozzle_temperature_range_low": [
        "220"
      ],
      "nozzle_temperature_range_high": [
        "260"
      ],
      "nozzle_temperature": [
        "255"
      ],
      "nozzle_temperature_initial_layer": [
        "255"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "90"
      ],
      "overhang_fan_threshold": [
        "10%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "70"
      ],
      "supertack_plate_temp_initial_layer": [
        "70"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "12"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "70"
      ],
      "textured_plate_temp": [
        "70"
      ],
      "textured_plate_temp_initial_layer": [
        "70"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if (bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S180\n{elsif (bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S255\n{endif};Prevent PLA from jamming\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "300"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSG60_06",
        "instantiation": "true",
        "filament_max_volumetric_speed": [
          "8"
        ],
        "hot_plate_temp": [
          "80"
        ],
        "hot_plate_temp_initial_layer": [
          "80"
        ],
        "nozzle_temperature_range_high": [
          "270"
        ],
        "textured_plate_temp": [
          "80"
        ],
        "textured_plate_temp_initial_layer": [
          "80"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle",
          "Bambu Lab A1 0.4 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSG60_04",
        "instantiation": "true",
        "filament_max_volumetric_speed": [
          "8"
        ],
        "nozzle_temperature_range_high": [
          "270"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSG60_08",
        "instantiation": "true",
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.95",
          "0.95"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "11.5",
          "11.5"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature_range_high": [
          "270"
        ],
        "nozzle_temperature": [
          "255",
          "255"
        ],
        "nozzle_temperature_initial_layer": [
          "255",
          "255"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "P1P": {
        "setting_id": "GFSG60_02",
        "instantiation": "true",
        "filament_max_volumetric_speed": [
          "11.5"
        ],
        "hot_plate_temp": [
          "80"
        ],
        "hot_plate_temp_initial_layer": [
          "80"
        ],
        "nozzle_temperature_range_high": [
          "270"
        ],
        "textured_plate_temp": [
          "80"
        ],
        "textured_plate_temp_initial_layer": [
          "80"
        ],
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSG60_00",
        "instantiation": "true",
        "filament_max_volumetric_speed": [
          "11.5"
        ],
        "nozzle_temperature_range_high": [
          "270"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "GFG96": {
    "filament_id": "GFG96",
    "vendor": "Generic",
    "materialType": "Generic PETG HF",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "3"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "70"
      ],
      "eng_plate_temp_initial_layer": [
        "70"
      ],
      "fan_cooling_layer_time": [
        "30"
      ],
      "fan_max_speed": [
        "40"
      ],
      "fan_min_speed": [
        "20"
      ],
      "filament_cost": [
        "24.99"
      ],
      "filament_density": [
        "1.28"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "16"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PETG"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "70"
      ],
      "hot_plate_temp_initial_layer": [
        "70"
      ],
      "nozzle_temperature_range_low": [
        "220"
      ],
      "nozzle_temperature_range_high": [
        "270"
      ],
      "nozzle_temperature": [
        "220"
      ],
      "nozzle_temperature_initial_layer": [
        "220"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "90"
      ],
      "overhang_fan_threshold": [
        "10%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "70"
      ],
      "supertack_plate_temp_initial_layer": [
        "70"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "25"
      ],
      "slow_down_min_speed": [
        "10"
      ],
      "temperature_vitrification": [
        "70"
      ],
      "textured_plate_temp": [
        "70"
      ],
      "textured_plate_temp_initial_layer": [
        "70"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if (bed_temperature[current_extruder] >80)||(bed_temperature_initial_layer[current_extruder] >80)}M106 P3 S255\n{elsif (bed_temperature[current_extruder] >60)||(bed_temperature_initial_layer[current_extruder] >60)}M106 P3 S180\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "300"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSG96_04",
        "instantiation": "true",
        "filament_retraction_length": [
          "0.4"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSG96_06",
        "instantiation": "true",
        "filament_retraction_length": [
          "0.4"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSG96_08",
        "instantiation": "true",
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.95",
          "0.95"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "16",
          "16"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "0.4",
          "0.4"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "220",
          "220"
        ],
        "nozzle_temperature_initial_layer": [
          "220",
          "220"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "P1P": {
        "setting_id": "GFSG96_02",
        "instantiation": "true",
        "filament_retraction_length": [
          "0.4"
        ],
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSG96_00",
        "instantiation": "true",
        "filament_retraction_length": [
          "0.4"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.4 nozzle"
        ]
      }
    }
  },
  "GFG97": {
    "filament_id": "GFG97",
    "vendor": "Generic",
    "materialType": "Generic PCTG",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "3"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "70"
      ],
      "eng_plate_temp_initial_layer": [
        "70"
      ],
      "fan_cooling_layer_time": [
        "30"
      ],
      "fan_max_speed": [
        "40"
      ],
      "fan_min_speed": [
        "10"
      ],
      "filament_cost": [
        "28.99"
      ],
      "filament_density": [
        "1.29"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "6"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PCTG"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "70"
      ],
      "hot_plate_temp_initial_layer": [
        "70"
      ],
      "nozzle_temperature_range_low": [
        "240"
      ],
      "nozzle_temperature_range_high": [
        "270"
      ],
      "nozzle_temperature": [
        "255"
      ],
      "nozzle_temperature_initial_layer": [
        "255"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "90"
      ],
      "overhang_fan_threshold": [
        "10%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "12"
      ],
      "slow_down_min_speed": [
        "10"
      ],
      "temperature_vitrification": [
        "90"
      ],
      "textured_plate_temp": [
        "70"
      ],
      "textured_plate_temp_initial_layer": [
        "70"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if (bed_temperature[current_extruder] >80)||(bed_temperature_initial_layer[current_extruder] >80)}M106 P3 S255\n{elsif (bed_temperature[current_extruder] >60)||(bed_temperature_initial_layer[current_extruder] >60)}M106 P3 S180\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSG97_01",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSG97_02",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSG97_03",
        "instantiation": "true",
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.95",
          "0.95"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "6",
          "6"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "255",
          "255"
        ],
        "nozzle_temperature_initial_layer": [
          "255",
          "255"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "X1C": {
        "setting_id": "GFSG97_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "GFG98": {
    "filament_id": "GFG98",
    "vendor": "Generic",
    "materialType": "Generic PETG-CF",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "3"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "70"
      ],
      "eng_plate_temp_initial_layer": [
        "70"
      ],
      "fan_cooling_layer_time": [
        "20"
      ],
      "fan_max_speed": [
        "30"
      ],
      "fan_min_speed": [
        "0"
      ],
      "filament_cost": [
        "34.99"
      ],
      "filament_density": [
        "1.25"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "12"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PETG-CF"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "70"
      ],
      "hot_plate_temp_initial_layer": [
        "70"
      ],
      "nozzle_temperature_range_low": [
        "240"
      ],
      "nozzle_temperature_range_high": [
        "270"
      ],
      "nozzle_temperature": [
        "255"
      ],
      "nozzle_temperature_initial_layer": [
        "255"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "90"
      ],
      "overhang_fan_threshold": [
        "10%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "40"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "70"
      ],
      "supertack_plate_temp_initial_layer": [
        "70"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "6"
      ],
      "slow_down_min_speed": [
        "10"
      ],
      "temperature_vitrification": [
        "70"
      ],
      "textured_plate_temp": [
        "70"
      ],
      "textured_plate_temp_initial_layer": [
        "70"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if (bed_temperature[current_extruder] >80)||(bed_temperature_initial_layer[current_extruder] >80)}M106 P3 S255\n{elsif (bed_temperature[current_extruder] >60)||(bed_temperature_initial_layer[current_extruder] >60)}M106 P3 S180\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "300"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSG98_01",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "30"
        ],
        "fan_max_speed": [
          "40"
        ],
        "fan_min_speed": [
          "5"
        ],
        "filament_max_volumetric_speed": [
          "8"
        ],
        "overhang_fan_speed": [
          "100"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSG98_02",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "30"
        ],
        "fan_max_speed": [
          "40"
        ],
        "fan_min_speed": [
          "5"
        ],
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.95",
          "0.95"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "11.5",
          "11.5"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "255",
          "255"
        ],
        "nozzle_temperature_initial_layer": [
          "255",
          "255"
        ],
        "overhang_fan_speed": [
          "100"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "X1C": {
        "setting_id": "GFSG50",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "30"
        ],
        "fan_max_speed": [
          "40"
        ],
        "fan_min_speed": [
          "5"
        ],
        "filament_max_volumetric_speed": [
          "11.5"
        ],
        "overhang_fan_speed": [
          "100"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "GFG99": {
    "filament_id": "GFG99",
    "vendor": "Generic",
    "materialType": "Generic PETG",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "3"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "70"
      ],
      "eng_plate_temp_initial_layer": [
        "70"
      ],
      "fan_cooling_layer_time": [
        "30"
      ],
      "fan_max_speed": [
        "90"
      ],
      "fan_min_speed": [
        "40"
      ],
      "filament_cost": [
        "30"
      ],
      "filament_density": [
        "1.27"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "12"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PETG"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "70"
      ],
      "hot_plate_temp_initial_layer": [
        "70"
      ],
      "nozzle_temperature_range_low": [
        "220"
      ],
      "nozzle_temperature_range_high": [
        "270"
      ],
      "nozzle_temperature": [
        "255"
      ],
      "nozzle_temperature_initial_layer": [
        "255"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "90"
      ],
      "overhang_fan_threshold": [
        "10%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "70"
      ],
      "supertack_plate_temp_initial_layer": [
        "70"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "12"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "70"
      ],
      "textured_plate_temp": [
        "70"
      ],
      "textured_plate_temp_initial_layer": [
        "70"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if (bed_temperature[current_extruder] >80)||(bed_temperature_initial_layer[current_extruder] >80)}M106 P3 S255\n{elsif (bed_temperature[current_extruder] >60)||(bed_temperature_initial_layer[current_extruder] >60)}M106 P3 S180\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "300"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSG99_03",
        "instantiation": "true",
        "filament_max_volumetric_speed": [
          "8"
        ],
        "hot_plate_temp": [
          "80"
        ],
        "hot_plate_temp_initial_layer": [
          "80"
        ],
        "textured_plate_temp": [
          "80"
        ],
        "textured_plate_temp_initial_layer": [
          "80"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSG99_00",
        "instantiation": "true",
        "filament_max_volumetric_speed": [
          "8"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSG99_05",
        "instantiation": "true",
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.95",
          "0.95"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "12",
          "12"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "255",
          "255"
        ],
        "nozzle_temperature_initial_layer": [
          "255",
          "255"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      }
    }
  },
  "GFL00": {
    "filament_id": "GFL00",
    "vendor": "Polymaker",
    "materialType": "PolyLite PLA",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "70"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "1"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "35"
      ],
      "cool_plate_temp_initial_layer": [
        "35"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "0"
      ],
      "eng_plate_temp_initial_layer": [
        "0"
      ],
      "fan_cooling_layer_time": [
        "100"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "100"
      ],
      "filament_cost": [
        "25.4"
      ],
      "filament_density": [
        "1.24"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "12"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PLA"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "15%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "55"
      ],
      "hot_plate_temp_initial_layer": [
        "55"
      ],
      "nozzle_temperature_range_low": [
        "190"
      ],
      "nozzle_temperature_range_high": [
        "240"
      ],
      "nozzle_temperature": [
        "220"
      ],
      "nozzle_temperature_initial_layer": [
        "220"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "50%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "45"
      ],
      "supertack_plate_temp_initial_layer": [
        "45"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "4"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "45"
      ],
      "textured_plate_temp": [
        "55"
      ],
      "textured_plate_temp_initial_layer": [
        "55"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10.0"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S255\n{elsif(bed_temperature[current_extruder] >35)||(bed_temperature_initial_layer[current_extruder] >35)}M106 P3 S180\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "100"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSL00_02",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_max_volumetric_speed": [
          "15"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSL00_00",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_max_volumetric_speed": [
          "15"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSL00_04",
        "instantiation": "true",
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.95",
          "0.95"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "15",
          "15"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "220",
          "220"
        ],
        "nozzle_temperature_initial_layer": [
          "220",
          "220"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "X1": {
        "setting_id": "GFSL23",
        "instantiation": "true",
        "filament_max_volumetric_speed": [
          "15"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "compatible_printers": [
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n\n"
        ]
      },
      "X1C": {
        "setting_id": "GFSL19",
        "instantiation": "true",
        "filament_max_volumetric_speed": [
          "15"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n\n"
        ]
      }
    }
  },
  "GFL01": {
    "filament_id": "GFL01",
    "vendor": "Polymaker",
    "materialType": "PolyTerra PLA",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "70"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "1"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "35"
      ],
      "cool_plate_temp_initial_layer": [
        "35"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "0"
      ],
      "eng_plate_temp_initial_layer": [
        "0"
      ],
      "fan_cooling_layer_time": [
        "100"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "100"
      ],
      "filament_cost": [
        "25.4"
      ],
      "filament_density": [
        "1.31"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.98"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "12"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PLA"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "15%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "55"
      ],
      "hot_plate_temp_initial_layer": [
        "55"
      ],
      "nozzle_temperature_range_low": [
        "190"
      ],
      "nozzle_temperature_range_high": [
        "240"
      ],
      "nozzle_temperature": [
        "220"
      ],
      "nozzle_temperature_initial_layer": [
        "220"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "50%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "45"
      ],
      "supertack_plate_temp_initial_layer": [
        "45"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "4"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "45"
      ],
      "textured_plate_temp": [
        "55"
      ],
      "textured_plate_temp_initial_layer": [
        "55"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10.0"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S255\n{elsif(bed_temperature[current_extruder] >35)||(bed_temperature_initial_layer[current_extruder] >35)}M106 P3 S180\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "100"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSL01_02",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_max_volumetric_speed": [
          "22"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSL01_00",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_max_volumetric_speed": [
          "22"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSL01_04",
        "instantiation": "true",
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.98",
          "0.98"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "22",
          "22"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "220",
          "220"
        ],
        "nozzle_temperature_initial_layer": [
          "220",
          "220"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "X1": {
        "setting_id": "GFSL22",
        "instantiation": "true",
        "filament_max_volumetric_speed": [
          "22"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "compatible_printers": [
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n\n"
        ]
      },
      "X1C": {
        "setting_id": "GFSL18",
        "instantiation": "true",
        "filament_max_volumetric_speed": [
          "22"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n\n"
        ]
      }
    }
  },
  "GFL03": {
    "filament_id": "GFL03",
    "vendor": "eSUN",
    "materialType": "eSUN PLA+",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "70"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "1"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "35"
      ],
      "cool_plate_temp_initial_layer": [
        "35"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "0"
      ],
      "eng_plate_temp_initial_layer": [
        "0"
      ],
      "fan_cooling_layer_time": [
        "100"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "100"
      ],
      "filament_cost": [
        "22.99"
      ],
      "filament_density": [
        "1.25"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.98"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "16"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PLA"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "15%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "55"
      ],
      "hot_plate_temp_initial_layer": [
        "55"
      ],
      "nozzle_temperature_range_low": [
        "190"
      ],
      "nozzle_temperature_range_high": [
        "240"
      ],
      "nozzle_temperature": [
        "220"
      ],
      "nozzle_temperature_initial_layer": [
        "220"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "50%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "45"
      ],
      "supertack_plate_temp_initial_layer": [
        "45"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "6"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "45"
      ],
      "textured_plate_temp": [
        "55"
      ],
      "textured_plate_temp_initial_layer": [
        "55"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10.0"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "100"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSL03_05",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSL03_03",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSL03_07",
        "instantiation": "true",
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.98",
          "0.98"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "16",
          "16"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "220",
          "220"
        ],
        "nozzle_temperature_initial_layer": [
          "220",
          "220"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "X1": {
        "setting_id": "GFSL03_02",
        "instantiation": "true",
        "slow_down_layer_time": [
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSL03_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "GFL04": {
    "filament_id": "GFL04",
    "vendor": "Overture",
    "materialType": "Overture PLA",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "70"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "1"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "35"
      ],
      "cool_plate_temp_initial_layer": [
        "35"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "0"
      ],
      "eng_plate_temp_initial_layer": [
        "0"
      ],
      "fan_cooling_layer_time": [
        "100"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "100"
      ],
      "filament_cost": [
        "24.15"
      ],
      "filament_density": [
        "1.2"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.98"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "15"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PLA"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "15%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "55"
      ],
      "hot_plate_temp_initial_layer": [
        "55"
      ],
      "nozzle_temperature_range_low": [
        "190"
      ],
      "nozzle_temperature_range_high": [
        "240"
      ],
      "nozzle_temperature": [
        "220"
      ],
      "nozzle_temperature_initial_layer": [
        "220"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "50%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "45"
      ],
      "supertack_plate_temp_initial_layer": [
        "45"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "6"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "45"
      ],
      "textured_plate_temp": [
        "55"
      ],
      "textured_plate_temp_initial_layer": [
        "55"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10.0"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S255\n{elsif(bed_temperature[current_extruder] >35)||(bed_temperature_initial_layer[current_extruder] >35)}M106 P3 S180\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "100"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSL04_07",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSL04_00",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSL04_09",
        "instantiation": "true",
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.98",
          "0.98"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "15",
          "15"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "220",
          "220"
        ],
        "nozzle_temperature_initial_layer": [
          "220",
          "220"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "P1P": {
        "setting_id": "GFSL04_03",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_min_speed": [
          "50"
        ],
        "slow_down_layer_time": [
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle"
        ]
      },
      "X1": {
        "setting_id": "GFSL04_01",
        "instantiation": "true",
        "slow_down_layer_time": [
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab X1 0.6 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ]
      },
      "X1C": {
        "setting_id": "GFSL04_05",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ]
      }
    }
  },
  "GFL05": {
    "filament_id": "GFL05",
    "vendor": "Overture",
    "materialType": "Overture Matte PLA",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "70"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "1"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "35"
      ],
      "cool_plate_temp_initial_layer": [
        "35"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "0"
      ],
      "eng_plate_temp_initial_layer": [
        "0"
      ],
      "fan_cooling_layer_time": [
        "100"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "100"
      ],
      "filament_cost": [
        "24.52"
      ],
      "filament_density": [
        "1.22"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.98"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "16"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PLA"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "15%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "55"
      ],
      "hot_plate_temp_initial_layer": [
        "55"
      ],
      "nozzle_temperature_range_low": [
        "190"
      ],
      "nozzle_temperature_range_high": [
        "240"
      ],
      "nozzle_temperature": [
        "220"
      ],
      "nozzle_temperature_initial_layer": [
        "220"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "50%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "45"
      ],
      "supertack_plate_temp_initial_layer": [
        "45"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "6"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "45"
      ],
      "textured_plate_temp": [
        "55"
      ],
      "textured_plate_temp_initial_layer": [
        "55"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10.0"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S255\n{elsif(bed_temperature[current_extruder] >35)||(bed_temperature_initial_layer[current_extruder] >35)}M106 P3 S180\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "100"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSL05_07",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSL05_05",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSL05_09",
        "instantiation": "true",
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.98",
          "0.98"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "16",
          "16"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "220",
          "220"
        ],
        "nozzle_temperature_initial_layer": [
          "220",
          "220"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "P1P": {
        "setting_id": "GFSL05_03",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_min_speed": [
          "50"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "slow_down_layer_time": [
          "10"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle"
        ]
      },
      "X1": {
        "setting_id": "GFSL05_02",
        "instantiation": "true",
        "slow_down_layer_time": [
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab X1 0.4 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ]
      },
      "X1C": {
        "setting_id": "GFSL05_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ]
      }
    }
  },
  "GFL06": {
    "filament_id": "GFL06",
    "vendor": "Polymaker",
    "materialType": "Fiberon PETG-ESD",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "3"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "60"
      ],
      "eng_plate_temp_initial_layer": [
        "60"
      ],
      "fan_cooling_layer_time": [
        "15"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "0"
      ],
      "filament_cost": [
        "0"
      ],
      "filament_density": [
        "1.24"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "20"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PETG"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "60"
      ],
      "hot_plate_temp_initial_layer": [
        "60"
      ],
      "nozzle_temperature_range_low": [
        "250"
      ],
      "nozzle_temperature_range_high": [
        "290"
      ],
      "nozzle_temperature": [
        "290"
      ],
      "nozzle_temperature_initial_layer": [
        "290"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "95%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "70"
      ],
      "supertack_plate_temp_initial_layer": [
        "70"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "2"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "76"
      ],
      "textured_plate_temp": [
        "60"
      ],
      "textured_plate_temp_initial_layer": [
        "60"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if (bed_temperature[current_extruder] >80)||(bed_temperature_initial_layer[current_extruder] >80)}M106 P3 S255\n{elsif (bed_temperature[current_extruder] >60)||(bed_temperature_initial_layer[current_extruder] >60)}M106 P3 S180\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "300"
      ]
    },
    "model_settings": {
      "X1C": {
        "setting_id": "GFSL06_00",
        "instantiation": "true",
        "filament_cost": [
          "29.99"
        ],
        "compatible_printers": [
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle"
        ]
      }
    }
  },
  "GFL50": {
    "filament_id": "GFL50",
    "vendor": "Polymaker",
    "materialType": "Fiberon PA6-CF",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "1"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "3"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "40"
      ],
      "eng_plate_temp_initial_layer": [
        "40"
      ],
      "fan_cooling_layer_time": [
        "15"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "0"
      ],
      "filament_cost": [
        "83.99"
      ],
      "filament_density": [
        "1.17"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "14"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PA6-CF"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "40"
      ],
      "hot_plate_temp_initial_layer": [
        "40"
      ],
      "nozzle_temperature_range_low": [
        "280"
      ],
      "nozzle_temperature_range_high": [
        "300"
      ],
      "nozzle_temperature": [
        "300"
      ],
      "nozzle_temperature_initial_layer": [
        "300"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "95%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "40"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "2"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "215"
      ],
      "textured_plate_temp": [
        "40"
      ],
      "textured_plate_temp_initial_layer": [
        "40"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10"
      ],
      "filament_start_gcode": [
        "; Filament gcode\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "400"
      ]
    },
    "model_settings": {
      "X1C": {
        "setting_id": "GFSL50_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle"
        ]
      }
    }
  },
  "GFL51": {
    "filament_id": "GFL51",
    "vendor": "Polymaker",
    "materialType": "Fiberon PA6-GF",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "1"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "3"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "40"
      ],
      "eng_plate_temp_initial_layer": [
        "40"
      ],
      "fan_cooling_layer_time": [
        "15"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "0"
      ],
      "filament_cost": [
        "63.99"
      ],
      "filament_density": [
        "1.2"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "12"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PA-GF"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "2"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "40"
      ],
      "hot_plate_temp_initial_layer": [
        "40"
      ],
      "nozzle_temperature_range_low": [
        "280"
      ],
      "nozzle_temperature_range_high": [
        "300"
      ],
      "nozzle_temperature": [
        "300"
      ],
      "nozzle_temperature_initial_layer": [
        "300"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "95%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "40"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "2"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "191"
      ],
      "textured_plate_temp": [
        "40"
      ],
      "textured_plate_temp_initial_layer": [
        "40"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10"
      ],
      "filament_start_gcode": [
        "; Filament gcode\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "400"
      ]
    },
    "model_settings": {
      "X1C": {
        "setting_id": "GFSL51_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle"
        ]
      }
    }
  },
  "GFL52": {
    "filament_id": "GFL52",
    "vendor": "Polymaker",
    "materialType": "Fiberon PA12-CF",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "1"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "3"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "40"
      ],
      "eng_plate_temp_initial_layer": [
        "40"
      ],
      "fan_cooling_layer_time": [
        "15"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "0"
      ],
      "filament_cost": [
        "99.99"
      ],
      "filament_density": [
        "1.06"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "14"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PA-CF"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "2"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "40"
      ],
      "hot_plate_temp_initial_layer": [
        "40"
      ],
      "nozzle_temperature_range_low": [
        "260"
      ],
      "nozzle_temperature_range_high": [
        "300"
      ],
      "nozzle_temperature": [
        "300"
      ],
      "nozzle_temperature_initial_layer": [
        "300"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "95%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "40"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "2"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "131"
      ],
      "textured_plate_temp": [
        "40"
      ],
      "textured_plate_temp_initial_layer": [
        "40"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10"
      ],
      "filament_start_gcode": [
        "; Filament gcode\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "400"
      ]
    },
    "model_settings": {
      "X1C": {
        "setting_id": "GFSL52_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle"
        ]
      }
    }
  },
  "GFL53": {
    "filament_id": "GFL53",
    "vendor": "Polymaker",
    "materialType": "Fiberon PA612-CF",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "1"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "3"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "100"
      ],
      "eng_plate_temp_initial_layer": [
        "100"
      ],
      "fan_cooling_layer_time": [
        "5"
      ],
      "fan_max_speed": [
        "30"
      ],
      "fan_min_speed": [
        "10"
      ],
      "filament_cost": [
        "94.99"
      ],
      "filament_density": [
        "1.06"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.96"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "8"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PA"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "2"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "100"
      ],
      "hot_plate_temp_initial_layer": [
        "100"
      ],
      "nozzle_temperature_range_low": [
        "260"
      ],
      "nozzle_temperature_range_high": [
        "300"
      ],
      "nozzle_temperature": [
        "290"
      ],
      "nozzle_temperature_initial_layer": [
        "290"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "40"
      ],
      "overhang_fan_threshold": [
        "0%"
      ],
      "reduce_fan_stop_start_freq": [
        "0"
      ],
      "required_nozzle_HRC": [
        "40"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "2"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "180"
      ],
      "textured_plate_temp": [
        "100"
      ],
      "textured_plate_temp_initial_layer": [
        "100"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10"
      ],
      "filament_start_gcode": [
        "; Filament gcode\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "400"
      ]
    },
    "model_settings": {
      "X1C": {
        "setting_id": "GFSL53_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle"
        ]
      }
    }
  },
  "GFL54": {
    "filament_id": "GFL54",
    "vendor": "Polymaker",
    "materialType": "Fiberon PET-CF",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "3"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "70"
      ],
      "eng_plate_temp_initial_layer": [
        "70"
      ],
      "fan_cooling_layer_time": [
        "242"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "0"
      ],
      "filament_cost": [
        "89.99"
      ],
      "filament_density": [
        "1.34"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "12"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PET-CF"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "70"
      ],
      "hot_plate_temp_initial_layer": [
        "70"
      ],
      "nozzle_temperature_range_low": [
        "270"
      ],
      "nozzle_temperature_range_high": [
        "300"
      ],
      "nozzle_temperature": [
        "300"
      ],
      "nozzle_temperature_initial_layer": [
        "300"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "95%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "40"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "80"
      ],
      "supertack_plate_temp_initial_layer": [
        "80"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "5"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "147"
      ],
      "textured_plate_temp": [
        "70"
      ],
      "textured_plate_temp_initial_layer": [
        "70"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if (bed_temperature[current_extruder] >80)||(bed_temperature_initial_layer[current_extruder] >80)}M106 P3 S255\n{elsif (bed_temperature[current_extruder] >60)||(bed_temperature_initial_layer[current_extruder] >60)}M106 P3 S180\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "800"
      ]
    },
    "model_settings": {
      "X1C": {
        "setting_id": "GFSL54_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle"
        ]
      }
    }
  },
  "GFL55": {
    "filament_id": "GFL55",
    "vendor": "Polymaker",
    "materialType": "Fiberon PETG-rCF",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "3"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "70"
      ],
      "eng_plate_temp_initial_layer": [
        "70"
      ],
      "fan_cooling_layer_time": [
        "12"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "0"
      ],
      "filament_cost": [
        "39.99"
      ],
      "filament_density": [
        "1.3"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "12"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PETG-CF"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "70"
      ],
      "hot_plate_temp_initial_layer": [
        "70"
      ],
      "nozzle_temperature_range_low": [
        "240"
      ],
      "nozzle_temperature_range_high": [
        "270"
      ],
      "nozzle_temperature": [
        "270"
      ],
      "nozzle_temperature_initial_layer": [
        "270"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "95%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "40"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "70"
      ],
      "supertack_plate_temp_initial_layer": [
        "70"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "2"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "70"
      ],
      "textured_plate_temp": [
        "70"
      ],
      "textured_plate_temp_initial_layer": [
        "70"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if (bed_temperature[current_extruder] >80)||(bed_temperature_initial_layer[current_extruder] >80)}M106 P3 S255\n{elsif (bed_temperature[current_extruder] >60)||(bed_temperature_initial_layer[current_extruder] >60)}M106 P3 S180\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "300"
      ]
    },
    "model_settings": {
      "X1C": {
        "setting_id": "GFSL55_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle"
        ]
      }
    }
  },
  "GFL95": {
    "filament_id": "GFL95",
    "vendor": "Generic",
    "materialType": "Generic PLA High Speed",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "70"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "1"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "35"
      ],
      "cool_plate_temp_initial_layer": [
        "35"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "0"
      ],
      "eng_plate_temp_initial_layer": [
        "0"
      ],
      "fan_cooling_layer_time": [
        "100"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "100"
      ],
      "filament_cost": [
        "20"
      ],
      "filament_density": [
        "1.24"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.98"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "18"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PLA"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "15%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "55"
      ],
      "hot_plate_temp_initial_layer": [
        "55"
      ],
      "nozzle_temperature_range_low": [
        "190"
      ],
      "nozzle_temperature_range_high": [
        "240"
      ],
      "nozzle_temperature": [
        "220"
      ],
      "nozzle_temperature_initial_layer": [
        "220"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "50%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "45"
      ],
      "supertack_plate_temp_initial_layer": [
        "45"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "8"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "45"
      ],
      "textured_plate_temp": [
        "55"
      ],
      "textured_plate_temp_initial_layer": [
        "55"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10.0"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S255\n{elsif(bed_temperature[current_extruder] >35)||(bed_temperature_initial_layer[current_extruder] >35)}M106 P3 S180\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "100"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSL95_04",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "slow_down_layer_time": [
          "6"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSL95_06",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "slow_down_layer_time": [
          "6"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle",
          "Bambu Lab A1 mini 0.4 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSL95_08",
        "instantiation": "true",
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.98",
          "0.98"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "18",
          "18"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "220",
          "220"
        ],
        "nozzle_temperature_initial_layer": [
          "220",
          "220"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "slow_down_layer_time": [
          "4"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "P1P": {
        "setting_id": "GFSL95_02",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_min_speed": [
          "50"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSL95_00",
        "instantiation": "true",
        "slow_down_layer_time": [
          "4"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
        ]
      }
    }
  },
  "GFL96": {
    "filament_id": "GFL96",
    "vendor": "Generic",
    "materialType": "Generic PLA Silk",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "70"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "1"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "35"
      ],
      "cool_plate_temp_initial_layer": [
        "35"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "0"
      ],
      "eng_plate_temp_initial_layer": [
        "0"
      ],
      "fan_cooling_layer_time": [
        "100"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "100"
      ],
      "filament_cost": [
        "20"
      ],
      "filament_density": [
        "1.24"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.98"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "12"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PLA"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "15%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "55"
      ],
      "hot_plate_temp_initial_layer": [
        "55"
      ],
      "nozzle_temperature_range_low": [
        "190"
      ],
      "nozzle_temperature_range_high": [
        "240"
      ],
      "nozzle_temperature": [
        "220"
      ],
      "nozzle_temperature_initial_layer": [
        "220"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "50%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "35"
      ],
      "supertack_plate_temp_initial_layer": [
        "35"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "8"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "45"
      ],
      "textured_plate_temp": [
        "55"
      ],
      "textured_plate_temp_initial_layer": [
        "55"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10.0"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S255\n{elsif(bed_temperature[current_extruder] >35)||(bed_temperature_initial_layer[current_extruder] >35)}M106 P3 S180\n{endif};Prevent PLA from jamming\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "100"
      ],
      "description": "To make the prints get higher gloss, please dry the filament before use, and set the outer wall speed to be 40 to 60 mm/s when slicing."
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSL96_01",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_max_volumetric_speed": [
          "7.5"
        ],
        "filament_retraction_length": [
          "0.5"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSL96_00",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "filament_max_volumetric_speed": [
          "7.5"
        ],
        "filament_retraction_length": [
          "0.5"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "textured_plate_temp": [
          "60"
        ],
        "textured_plate_temp_initial_layer": [
          "60"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSL96_02",
        "instantiation": "true",
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.98",
          "0.98"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "7.5",
          "7.5"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "220",
          "220"
        ],
        "nozzle_temperature_initial_layer": [
          "220",
          "220"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      }
    }
  },
  "GFL98": {
    "filament_id": "GFL98",
    "vendor": "Generic",
    "materialType": "Generic PLA-CF",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "1"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "45"
      ],
      "cool_plate_temp_initial_layer": [
        "45"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "0"
      ],
      "eng_plate_temp_initial_layer": [
        "0"
      ],
      "fan_cooling_layer_time": [
        "100"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "100"
      ],
      "filament_cost": [
        "20"
      ],
      "filament_density": [
        "1.24"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "12"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PLA-CF"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "15%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "55"
      ],
      "hot_plate_temp_initial_layer": [
        "55"
      ],
      "nozzle_temperature_range_low": [
        "190"
      ],
      "nozzle_temperature_range_high": [
        "240"
      ],
      "nozzle_temperature": [
        "220"
      ],
      "nozzle_temperature_initial_layer": [
        "220"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "50%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "40"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "50"
      ],
      "supertack_plate_temp_initial_layer": [
        "50"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "7"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "45"
      ],
      "textured_plate_temp": [
        "55"
      ],
      "textured_plate_temp_initial_layer": [
        "55"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10.0"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "100"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSL98_01",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSL98_00",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSL98_02",
        "instantiation": "true",
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.95",
          "0.95"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "12",
          "12"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "220",
          "220"
        ],
        "nozzle_temperature_initial_layer": [
          "220",
          "220"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      }
    }
  },
  "GFL99": {
    "filament_id": "GFL99",
    "vendor": "Generic",
    "materialType": "Generic PLA",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "70"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "1"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "35"
      ],
      "cool_plate_temp_initial_layer": [
        "35"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "0"
      ],
      "eng_plate_temp_initial_layer": [
        "0"
      ],
      "fan_cooling_layer_time": [
        "100"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "100"
      ],
      "filament_cost": [
        "20"
      ],
      "filament_density": [
        "1.24"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.98"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "12"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PLA"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "15%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "55"
      ],
      "hot_plate_temp_initial_layer": [
        "55"
      ],
      "nozzle_temperature_range_low": [
        "190"
      ],
      "nozzle_temperature_range_high": [
        "240"
      ],
      "nozzle_temperature": [
        "220"
      ],
      "nozzle_temperature_initial_layer": [
        "220"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "50%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "45"
      ],
      "supertack_plate_temp_initial_layer": [
        "45"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "8"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "45"
      ],
      "textured_plate_temp": [
        "55"
      ],
      "textured_plate_temp_initial_layer": [
        "55"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10.0"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S255\n{elsif(bed_temperature[current_extruder] >35)||(bed_temperature_initial_layer[current_extruder] >35)}M106 P3 S180\n{endif};Prevent PLA from jamming\n\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "100"
      ],
      "description": "The generic presets are conservatively tuned for compatibility with a wider range of filaments. For higher printing quality and speeds, please use Bambu filaments with Bambu presets."
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSL99_04",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSL99_02",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSL99_06",
        "instantiation": "true",
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.98",
          "0.98"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "12",
          "12"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "220",
          "220"
        ],
        "nozzle_temperature_initial_layer": [
          "220",
          "220"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      }
    }
  },
  "GFN03": {
    "filament_id": "GFN03",
    "vendor": "Bambu Lab",
    "materialType": "PA-CF",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "1"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "3"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "100"
      ],
      "eng_plate_temp_initial_layer": [
        "100"
      ],
      "fan_cooling_layer_time": [
        "4"
      ],
      "fan_max_speed": [
        "60"
      ],
      "fan_min_speed": [
        "0"
      ],
      "filament_cost": [
        "84.99"
      ],
      "filament_density": [
        "1.09"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.96"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "8"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PA-CF"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "100"
      ],
      "hot_plate_temp_initial_layer": [
        "100"
      ],
      "nozzle_temperature_range_low": [
        "260"
      ],
      "nozzle_temperature_range_high": [
        "300"
      ],
      "nozzle_temperature": [
        "280"
      ],
      "nozzle_temperature_initial_layer": [
        "280"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "40"
      ],
      "overhang_fan_threshold": [
        "0%"
      ],
      "reduce_fan_stop_start_freq": [
        "0"
      ],
      "required_nozzle_HRC": [
        "40"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "2"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "170"
      ],
      "textured_plate_temp": [
        "100"
      ],
      "textured_plate_temp_initial_layer": [
        "100"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "5.7"
      ],
      "filament_start_gcode": [
        "; Filament gcode\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "400"
      ],
      "description": "When printing this filament, there's a risk of nozzle clogging, oozing, warping and low layer adhesion strength. To get better results, please refer to this wiki: Printing Tips for High Temp / Engineering materials."
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSN03_01",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "5"
        ],
        "fan_max_speed": [
          "30"
        ],
        "fan_min_speed": [
          "10"
        ],
        "full_fan_speed_layer": [
          "2"
        ],
        "nozzle_temperature": [
          "290"
        ],
        "nozzle_temperature_initial_layer": [
          "290"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSN03_02",
        "instantiation": "true",
        "chamber_temperatures": [
          "60"
        ],
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.96",
          "0.96"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "8",
          "8"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "290",
          "290"
        ],
        "nozzle_temperature_initial_layer": [
          "290",
          "290"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "X1C": {
        "setting_id": "GFSN00",
        "instantiation": "true",
        "nozzle_temperature_initial_layer": [
          "290"
        ],
        "nozzle_temperature": [
          "290"
        ],
        "fan_max_speed": [
          "30"
        ],
        "fan_min_speed": [
          "10"
        ],
        "fan_cooling_layer_time": [
          "5"
        ],
        "full_fan_speed_layer": [
          "2"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle"
        ]
      }
    }
  },
  "GFN04": {
    "filament_id": "GFN04",
    "vendor": "Bambu Lab",
    "materialType": "PAHT-CF",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "1"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "3"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "100"
      ],
      "eng_plate_temp_initial_layer": [
        "100"
      ],
      "fan_cooling_layer_time": [
        "5"
      ],
      "fan_max_speed": [
        "30"
      ],
      "fan_min_speed": [
        "10"
      ],
      "filament_cost": [
        "94.99"
      ],
      "filament_density": [
        "1.06"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.96"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "8"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PA-CF"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "2"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "100"
      ],
      "hot_plate_temp_initial_layer": [
        "100"
      ],
      "nozzle_temperature_range_low": [
        "260"
      ],
      "nozzle_temperature_range_high": [
        "300"
      ],
      "nozzle_temperature": [
        "290"
      ],
      "nozzle_temperature_initial_layer": [
        "290"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "40"
      ],
      "overhang_fan_threshold": [
        "0%"
      ],
      "reduce_fan_stop_start_freq": [
        "0"
      ],
      "required_nozzle_HRC": [
        "40"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "2"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "180"
      ],
      "textured_plate_temp": [
        "100"
      ],
      "textured_plate_temp_initial_layer": [
        "100"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "13.3"
      ],
      "filament_start_gcode": [
        "; Filament gcode\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "400"
      ],
      "description": "When printing this filament, there's a risk of nozzle clogging, oozing, warping and low layer adhesion strength. To get better results, please refer to this wiki: Printing Tips for High Temp / Engineering materials."
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSN04_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSN04_01",
        "instantiation": "true",
        "chamber_temperatures": [
          "60"
        ],
        "counter_coef_2": [
          "0.00545"
        ],
        "counter_coef_3": [
          "-0.0202"
        ],
        "counter_limit_max": [
          "0.03"
        ],
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.96",
          "0.96"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "8",
          "8"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "290",
          "290"
        ],
        "nozzle_temperature_initial_layer": [
          "290",
          "290"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "X1C": {
        "setting_id": "GFSN04",
        "instantiation": "true",
        "chamber_temperatures": [
          "60"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "GFN05": {
    "filament_id": "GFN05",
    "vendor": "Bambu Lab",
    "materialType": "PA6-CF",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "1"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "3"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "100"
      ],
      "eng_plate_temp_initial_layer": [
        "100"
      ],
      "fan_cooling_layer_time": [
        "5"
      ],
      "fan_max_speed": [
        "30"
      ],
      "fan_min_speed": [
        "10"
      ],
      "filament_cost": [
        "79.99"
      ],
      "filament_density": [
        "1.10"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.96"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "8"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PA6-CF"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "100"
      ],
      "hot_plate_temp_initial_layer": [
        "100"
      ],
      "nozzle_temperature_range_low": [
        "260"
      ],
      "nozzle_temperature_range_high": [
        "300"
      ],
      "nozzle_temperature": [
        "275"
      ],
      "nozzle_temperature_initial_layer": [
        "275"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "40"
      ],
      "overhang_fan_threshold": [
        "0%"
      ],
      "reduce_fan_stop_start_freq": [
        "0"
      ],
      "required_nozzle_HRC": [
        "40"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "2"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "170"
      ],
      "textured_plate_temp": [
        "100"
      ],
      "textured_plate_temp_initial_layer": [
        "100"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "15.5"
      ],
      "filament_start_gcode": [
        "; Filament gcode\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "400"
      ],
      "description": "When printing this filament, there's a risk of nozzle clogging, oozing, warping and low layer adhesion strength. To get better results, please refer to this wiki: Printing Tips for High Temp / Engineering materials."
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSN05_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSN05_04",
        "instantiation": "true",
        "chamber_temperatures": [
          "60"
        ],
        "counter_coef_2": [
          "0.00565"
        ],
        "counter_coef_3": [
          "-0.0202"
        ],
        "counter_limit_max": [
          "0.03"
        ],
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.96",
          "0.96"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "8",
          "8"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "275",
          "275"
        ],
        "nozzle_temperature_initial_layer": [
          "275",
          "275"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "X1C": {
        "setting_id": "GFSN05_02",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle"
        ]
      },
      "X1E": {
        "setting_id": "GFSN05_03",
        "instantiation": "true",
        "chamber_temperatures": [
          "60"
        ],
        "compatible_printers": [
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "GFN06": {
    "filament_id": "GFN06",
    "vendor": "Bambu Lab",
    "materialType": "PPA-CF",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "1"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "3"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "100"
      ],
      "eng_plate_temp_initial_layer": [
        "100"
      ],
      "fan_cooling_layer_time": [
        "5"
      ],
      "fan_max_speed": [
        "30"
      ],
      "fan_min_speed": [
        "10"
      ],
      "filament_cost": [
        "20"
      ],
      "filament_density": [
        "1.17"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.96"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "8"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PPA-CF"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "100"
      ],
      "hot_plate_temp_initial_layer": [
        "100"
      ],
      "nozzle_temperature_range_low": [
        "280"
      ],
      "nozzle_temperature_range_high": [
        "320"
      ],
      "nozzle_temperature": [
        "290"
      ],
      "nozzle_temperature_initial_layer": [
        "290"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "40"
      ],
      "overhang_fan_threshold": [
        "0%"
      ],
      "reduce_fan_stop_start_freq": [
        "0"
      ],
      "required_nozzle_HRC": [
        "40"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "2"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "210"
      ],
      "textured_plate_temp": [
        "100"
      ],
      "textured_plate_temp_initial_layer": [
        "100"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "4.3"
      ],
      "filament_start_gcode": [
        "; Filament gcode\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "description": "When printing this filament, there's a risk of nozzle clogging, oozing, warping and low layer adhesion strength. To get better results, please refer to this wiki: Printing Tips for High Temp / Engineering materials."
    },
    "model_settings": {
      "H2D": {
        "setting_id": "GFSN06_02",
        "instantiation": "true",
        "chamber_temperatures": [
          "60"
        ],
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.96",
          "0.96"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "8",
          "8"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_printable": [
          "1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "290",
          "290"
        ],
        "nozzle_temperature_initial_layer": [
          "290",
          "290"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "X1C": {
        "setting_id": "GFSN06_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.8 nozzle"
        ]
      },
      "X1E": {
        "setting_id": "GFSN06_01",
        "instantiation": "true",
        "chamber_temperatures": [
          "60"
        ],
        "compatible_printers": [
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle"
        ]
      }
    }
  },
  "GFN07": {
    "filament_id": "GFN07",
    "vendor": "Bambu Lab",
    "materialType": "PPA-GF",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "1"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "3"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "100"
      ],
      "eng_plate_temp_initial_layer": [
        "100"
      ],
      "fan_cooling_layer_time": [
        "5"
      ],
      "fan_max_speed": [
        "30"
      ],
      "fan_min_speed": [
        "10"
      ],
      "filament_cost": [
        "20"
      ],
      "filament_density": [
        "1.17"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.96"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "8"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PPA-GF"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "100"
      ],
      "hot_plate_temp_initial_layer": [
        "100"
      ],
      "nozzle_temperature_range_low": [
        "280"
      ],
      "nozzle_temperature_range_high": [
        "320"
      ],
      "nozzle_temperature": [
        "290"
      ],
      "nozzle_temperature_initial_layer": [
        "290"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "40"
      ],
      "overhang_fan_threshold": [
        "0%"
      ],
      "reduce_fan_stop_start_freq": [
        "0"
      ],
      "required_nozzle_HRC": [
        "40"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "2"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "210"
      ],
      "textured_plate_temp": [
        "100"
      ],
      "textured_plate_temp_initial_layer": [
        "100"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10"
      ],
      "filament_start_gcode": [
        "; Filament gcode\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ]
    },
    "model_settings": {
      "H2D": {
        "setting_id": "GFSN07_02",
        "instantiation": "true",
        "chamber_temperatures": [
          "60"
        ],
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.96",
          "0.96"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "8",
          "8"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "290",
          "290"
        ],
        "nozzle_temperature_initial_layer": [
          "290",
          "290"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "X1C": {
        "setting_id": "GFSN07_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.8 nozzle"
        ]
      },
      "X1E": {
        "setting_id": "GFSN07_01",
        "instantiation": "true",
        "chamber_temperatures": [
          "60"
        ],
        "compatible_printers": [
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle"
        ]
      }
    }
  },
  "GFN08": {
    "filament_id": "GFN08",
    "vendor": "Bambu Lab",
    "materialType": "PA6-GF",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "1"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "3"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "100"
      ],
      "eng_plate_temp_initial_layer": [
        "100"
      ],
      "fan_cooling_layer_time": [
        "5"
      ],
      "fan_max_speed": [
        "30"
      ],
      "fan_min_speed": [
        "10"
      ],
      "filament_cost": [
        "59.99"
      ],
      "filament_density": [
        "1.14"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.96"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "8"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PA-GF"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "2"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "100"
      ],
      "hot_plate_temp_initial_layer": [
        "100"
      ],
      "nozzle_temperature_range_low": [
        "260"
      ],
      "nozzle_temperature_range_high": [
        "300"
      ],
      "nozzle_temperature": [
        "290"
      ],
      "nozzle_temperature_initial_layer": [
        "290"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "40"
      ],
      "overhang_fan_threshold": [
        "0%"
      ],
      "reduce_fan_stop_start_freq": [
        "0"
      ],
      "required_nozzle_HRC": [
        "40"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "2"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "180"
      ],
      "textured_plate_temp": [
        "100"
      ],
      "textured_plate_temp_initial_layer": [
        "100"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "4.1"
      ],
      "filament_start_gcode": [
        "; Filament gcode\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "400"
      ],
      "description": "When printing this filament, there's a risk of nozzle clogging, oozing, warping and low layer adhesion strength. To get better results, please refer to this wiki: Printing Tips for High Temp / Engineering materials."
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSN08_02",
        "instantiation": "true",
        "filament_max_volumetric_speed": [
          "10.5"
        ],
        "nozzle_temperature": [
          "265"
        ],
        "nozzle_temperature_initial_layer": [
          "265"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSN08_03",
        "instantiation": "true",
        "chamber_temperatures": [
          "60"
        ],
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.96",
          "0.96"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "10.5",
          "10.5"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "265",
          "265"
        ],
        "nozzle_temperature_initial_layer": [
          "265",
          "265"
        ],
        "retraction_distances_when_ec": [
          "4",
          "4"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "P1P": {
        "setting_id": "GFSN08_01",
        "instantiation": "true",
        "filament_max_volumetric_speed": [
          "10.5"
        ],
        "nozzle_temperature": [
          "265"
        ],
        "nozzle_temperature_initial_layer": [
          "265"
        ],
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSN08_00",
        "instantiation": "true",
        "chamber_temperatures": [
          "60"
        ],
        "filament_max_volumetric_speed": [
          "10.5"
        ],
        "nozzle_temperature": [
          "265"
        ],
        "nozzle_temperature_initial_layer": [
          "265"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "GFN96": {
    "filament_id": "GFN96",
    "vendor": "Generic",
    "materialType": "Generic PPA-GF",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "1"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "3"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "100"
      ],
      "eng_plate_temp_initial_layer": [
        "100"
      ],
      "fan_cooling_layer_time": [
        "5"
      ],
      "fan_max_speed": [
        "30"
      ],
      "fan_min_speed": [
        "10"
      ],
      "filament_cost": [
        "20"
      ],
      "filament_density": [
        "1.17"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.96"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "6"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PPA-GF"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "100"
      ],
      "hot_plate_temp_initial_layer": [
        "100"
      ],
      "nozzle_temperature_range_low": [
        "280"
      ],
      "nozzle_temperature_range_high": [
        "320"
      ],
      "nozzle_temperature": [
        "290"
      ],
      "nozzle_temperature_initial_layer": [
        "290"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "40"
      ],
      "overhang_fan_threshold": [
        "0%"
      ],
      "reduce_fan_stop_start_freq": [
        "0"
      ],
      "required_nozzle_HRC": [
        "40"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "2"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "210"
      ],
      "textured_plate_temp": [
        "100"
      ],
      "textured_plate_temp_initial_layer": [
        "100"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10"
      ],
      "filament_start_gcode": [
        "; Filament gcode\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ]
    },
    "model_settings": {
      "H2D": {
        "setting_id": "GFSN96_02",
        "instantiation": "true",
        "chamber_temperatures": [
          "60"
        ],
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.96",
          "0.96"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "6",
          "6"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "290",
          "290"
        ],
        "nozzle_temperature_initial_layer": [
          "290",
          "290"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "X1C": {
        "setting_id": "GFSN96_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.8 nozzle"
        ]
      },
      "X1E": {
        "setting_id": "GFSN96_01",
        "instantiation": "true",
        "chamber_temperatures": [
          "60"
        ],
        "compatible_printers": [
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle"
        ]
      }
    }
  },
  "GFN97": {
    "filament_id": "GFN97",
    "vendor": "Generic",
    "materialType": "Generic PPA-CF",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "1"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "3"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "100"
      ],
      "eng_plate_temp_initial_layer": [
        "100"
      ],
      "fan_cooling_layer_time": [
        "5"
      ],
      "fan_max_speed": [
        "30"
      ],
      "fan_min_speed": [
        "10"
      ],
      "filament_cost": [
        "20"
      ],
      "filament_density": [
        "1.17"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.96"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "6"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PPA-CF"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "100"
      ],
      "hot_plate_temp_initial_layer": [
        "100"
      ],
      "nozzle_temperature_range_low": [
        "280"
      ],
      "nozzle_temperature_range_high": [
        "320"
      ],
      "nozzle_temperature": [
        "290"
      ],
      "nozzle_temperature_initial_layer": [
        "290"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "40"
      ],
      "overhang_fan_threshold": [
        "0%"
      ],
      "reduce_fan_stop_start_freq": [
        "0"
      ],
      "required_nozzle_HRC": [
        "40"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "2"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "210"
      ],
      "textured_plate_temp": [
        "100"
      ],
      "textured_plate_temp_initial_layer": [
        "100"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10"
      ],
      "filament_start_gcode": [
        "; Filament gcode\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "description": "When printing this filament, there's a risk of nozzle clogging, oozing, warping and low layer adhesion strength. To get better results, please refer to this wiki: Printing Tips for High Temp / Engineering materials."
    },
    "model_settings": {
      "H2D": {
        "setting_id": "GFSN97_02",
        "instantiation": "true",
        "chamber_temperatures": [
          "60"
        ],
        "fan_max_speed": [
          "35"
        ],
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.96",
          "0.96"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "6.5",
          "6.5"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_printable": [
          "1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "290",
          "290"
        ],
        "nozzle_temperature_initial_layer": [
          "290",
          "290"
        ],
        "overhang_fan_threshold": [
          "25%"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "X1C": {
        "setting_id": "GFSN97_00",
        "instantiation": "true",
        "fan_max_speed": [
          "35"
        ],
        "filament_max_volumetric_speed": [
          "6.5"
        ],
        "overhang_fan_threshold": [
          "25%"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle"
        ]
      },
      "X1E": {
        "setting_id": "GFSN97_01",
        "instantiation": "true",
        "chamber_temperatures": [
          "60"
        ],
        "fan_max_speed": [
          "35"
        ],
        "filament_max_volumetric_speed": [
          "6.5"
        ],
        "overhang_fan_threshold": [
          "25%"
        ],
        "compatible_printers": [
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "GFN98": {
    "filament_id": "GFN98",
    "vendor": "Generic",
    "materialType": "Generic PA-CF",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "1"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "3"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "100"
      ],
      "eng_plate_temp_initial_layer": [
        "100"
      ],
      "fan_cooling_layer_time": [
        "5"
      ],
      "fan_max_speed": [
        "30"
      ],
      "fan_min_speed": [
        "10"
      ],
      "filament_cost": [
        "20"
      ],
      "filament_density": [
        "1.04"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "1"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "8"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PA-CF"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "2"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "100"
      ],
      "hot_plate_temp_initial_layer": [
        "100"
      ],
      "nozzle_temperature_range_low": [
        "260"
      ],
      "nozzle_temperature_range_high": [
        "300"
      ],
      "nozzle_temperature": [
        "290"
      ],
      "nozzle_temperature_initial_layer": [
        "290"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "40"
      ],
      "overhang_fan_threshold": [
        "0%"
      ],
      "reduce_fan_stop_start_freq": [
        "0"
      ],
      "required_nozzle_HRC": [
        "40"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "2"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "170"
      ],
      "textured_plate_temp": [
        "100"
      ],
      "textured_plate_temp_initial_layer": [
        "100"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10"
      ],
      "filament_start_gcode": [
        "; Filament gcode\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "400"
      ],
      "description": "When printing this filament, there's a risk of nozzle clogging, oozing, warping and low layer adhesion strength. To get better results, please refer to this wiki: Printing Tips for High Temp / Engineering materials."
    },
    "model_settings": {}
  },
  "GFN99": {
    "filament_id": "GFN99",
    "vendor": "Generic",
    "materialType": "Generic PA",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "1"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "60"
      ],
      "close_fan_the_first_x_layers": [
        "3"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "100"
      ],
      "eng_plate_temp_initial_layer": [
        "100"
      ],
      "fan_cooling_layer_time": [
        "65"
      ],
      "fan_max_speed": [
        "85"
      ],
      "fan_min_speed": [
        "40"
      ],
      "filament_cost": [
        "20"
      ],
      "filament_density": [
        "1.04"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "1"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "12"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PA"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "100"
      ],
      "hot_plate_temp_initial_layer": [
        "100"
      ],
      "nozzle_temperature_range_low": [
        "240"
      ],
      "nozzle_temperature_range_high": [
        "280"
      ],
      "nozzle_temperature": [
        "260"
      ],
      "nozzle_temperature_initial_layer": [
        "260"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "95"
      ],
      "overhang_fan_threshold": [
        "10%"
      ],
      "reduce_fan_stop_start_freq": [
        "0"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "8"
      ],
      "slow_down_min_speed": [
        "10"
      ],
      "temperature_vitrification": [
        "108"
      ],
      "textured_plate_temp": [
        "100"
      ],
      "textured_plate_temp_initial_layer": [
        "100"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10"
      ],
      "filament_start_gcode": [
        "; Filament gcode\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "400"
      ],
      "description": "When printing this filament, there's a risk of warping and low layer adhesion strength. To get better results, please refer to this wiki: Printing Tips for High Temp / Engineering materials."
    },
    "model_settings": {
      "H2D": {
        "setting_id": "GFSN99_01",
        "instantiation": "true",
        "description": "When printing this filament, there's a risk of warping and low layer adhesion strength. To get better results, please refer to this wiki: Printing Tips for High Temp / Engineering materials.",
        "chamber_temperatures": [
          "60"
        ],
        "fan_cooling_layer_time": [
          "65"
        ],
        "fan_max_speed": [
          "85"
        ],
        "fan_min_speed": [
          "40"
        ],
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_flow_ratio": [
          "1",
          "1"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "12",
          "12"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "260",
          "260"
        ],
        "nozzle_temperature_initial_layer": [
          "260",
          "260"
        ],
        "nozzle_temperature_range_high": [
          "280"
        ],
        "nozzle_temperature_range_low": [
          "240"
        ],
        "overhang_fan_speed": [
          "95"
        ],
        "overhang_fan_threshold": [
          "10%"
        ],
        "required_nozzle_HRC": [
          "3"
        ],
        "retraction_distances_when_ec": [
          "4",
          "4"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "slow_down_min_speed": [
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      }
    }
  },
  "GFP95": {
    "filament_id": "GFP95",
    "vendor": "Generic",
    "materialType": "Generic PP-GF",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "70"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "1"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "35"
      ],
      "cool_plate_temp_initial_layer": [
        "35"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "0"
      ],
      "eng_plate_temp_initial_layer": [
        "0"
      ],
      "fan_cooling_layer_time": [
        "100"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "100"
      ],
      "filament_cost": [
        "59.99"
      ],
      "filament_density": [
        "1.05"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "1"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "6"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PP-GF"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "55"
      ],
      "hot_plate_temp_initial_layer": [
        "55"
      ],
      "nozzle_temperature_range_low": [
        "220"
      ],
      "nozzle_temperature_range_high": [
        "250"
      ],
      "nozzle_temperature": [
        "235"
      ],
      "nozzle_temperature_initial_layer": [
        "235"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "50%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "4"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "110"
      ],
      "textured_plate_temp": [
        "55"
      ],
      "textured_plate_temp_initial_layer": [
        "55"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S255\n{elsif(bed_temperature[current_extruder] >35)||(bed_temperature_initial_layer[current_extruder] >35)}M106 P3 S180\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "902"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSP95_00",
        "instantiation": "true",
        "description": "This is neither a commonly used filament, nor one of Bambu filaments, and it varies a lot from brand to brand. So, it's highly recommended to ask its vendor for suitable profile before printing and adjust some parameters according to its performances.",
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSP95_01",
        "instantiation": "true",
        "description": "This is neither a commonly used filament, nor one of Bambu filaments, and it varies a lot from brand to brand. So, it's highly recommended to ask its vendor for suitable profile before printing and adjust some parameters according to its performances.",
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "1",
          "1"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "6",
          "6"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "235",
          "235"
        ],
        "nozzle_temperature_initial_layer": [
          "235",
          "235"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "X1C": {
        "setting_id": "GFSP97_03",
        "instantiation": "true",
        "description": "This is neither a commonly used filament, nor one of Bambu filaments, and it varies a lot from brand to brand. So, it's highly recommended to ask its vendor for suitable profile before printing and adjust some parameters according to its performances.",
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "GFP96": {
    "filament_id": "GFP96",
    "vendor": "Generic",
    "materialType": "Generic PP-CF",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "70"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "1"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "35"
      ],
      "cool_plate_temp_initial_layer": [
        "35"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "0"
      ],
      "eng_plate_temp_initial_layer": [
        "0"
      ],
      "fan_cooling_layer_time": [
        "100"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "100"
      ],
      "filament_cost": [
        "77.99"
      ],
      "filament_density": [
        "1.01"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "1"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "6"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PP-CF"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "55"
      ],
      "hot_plate_temp_initial_layer": [
        "55"
      ],
      "nozzle_temperature_range_low": [
        "220"
      ],
      "nozzle_temperature_range_high": [
        "250"
      ],
      "nozzle_temperature": [
        "235"
      ],
      "nozzle_temperature_initial_layer": [
        "235"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "50%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "4"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "110"
      ],
      "textured_plate_temp": [
        "55"
      ],
      "textured_plate_temp_initial_layer": [
        "55"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S255\n{elsif(bed_temperature[current_extruder] >35)||(bed_temperature_initial_layer[current_extruder] >35)}M106 P3 S180\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "902"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSP96_01",
        "instantiation": "true",
        "description": "This is neither a commonly used filament, nor one of Bambu filaments, and it varies a lot from brand to brand. So, it's highly recommended to ask its vendor for suitable profile before printing and adjust some parameters according to its performances.",
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSP96_02",
        "instantiation": "true",
        "description": "This is neither a commonly used filament, nor one of Bambu filaments, and it varies a lot from brand to brand. So, it's highly recommended to ask its vendor for suitable profile before printing and adjust some parameters according to its performances.",
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "1",
          "1"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "6",
          "6"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "235",
          "235"
        ],
        "nozzle_temperature_initial_layer": [
          "235",
          "235"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "X1C": {
        "setting_id": "GFSP96_00",
        "instantiation": "true",
        "description": "This is neither a commonly used filament, nor one of Bambu filaments, and it varies a lot from brand to brand. So, it's highly recommended to ask its vendor for suitable profile before printing and adjust some parameters according to its performances.",
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "GFP97": {
    "filament_id": "GFP97",
    "vendor": "Generic",
    "materialType": "Generic PP",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "70"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "1"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "35"
      ],
      "cool_plate_temp_initial_layer": [
        "35"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "0"
      ],
      "eng_plate_temp_initial_layer": [
        "0"
      ],
      "fan_cooling_layer_time": [
        "100"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "100"
      ],
      "filament_cost": [
        "34.99"
      ],
      "filament_density": [
        "0.93"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "1"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "12"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PP"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "55"
      ],
      "hot_plate_temp_initial_layer": [
        "55"
      ],
      "nozzle_temperature_range_low": [
        "220"
      ],
      "nozzle_temperature_range_high": [
        "250"
      ],
      "nozzle_temperature": [
        "235"
      ],
      "nozzle_temperature_initial_layer": [
        "235"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "50%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "4"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "110"
      ],
      "textured_plate_temp": [
        "55"
      ],
      "textured_plate_temp_initial_layer": [
        "55"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S255\n{elsif(bed_temperature[current_extruder] >35)||(bed_temperature_initial_layer[current_extruder] >35)}M106 P3 S180\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "902"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSP97_01",
        "instantiation": "true",
        "description": "This is neither a commonly used filament, nor one of Bambu filaments, and it varies a lot from brand to brand. So, it's highly recommended to ask its vendor for suitable profile before printing and adjust some parameters according to its performances.",
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSP97_02",
        "instantiation": "true",
        "description": "This is neither a commonly used filament, nor one of Bambu filaments, and it varies a lot from brand to brand. So, it's highly recommended to ask its vendor for suitable profile before printing and adjust some parameters according to its performances.",
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSP97_04",
        "instantiation": "true",
        "description": "This is neither a commonly used filament, nor one of Bambu filaments, and it varies a lot from brand to brand. So, it's highly recommended to ask its vendor for suitable profile before printing and adjust some parameters according to its performances.",
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "1",
          "1"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "12",
          "12"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "235",
          "235"
        ],
        "nozzle_temperature_initial_layer": [
          "235",
          "235"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "X1C": {
        "setting_id": "GFSP97_00",
        "instantiation": "true",
        "description": "This is neither a commonly used filament, nor one of Bambu filaments, and it varies a lot from brand to brand. So, it's highly recommended to ask its vendor for suitable profile before printing and adjust some parameters according to its performances.",
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "GFP98": {
    "filament_id": "GFP98",
    "vendor": "Generic",
    "materialType": "Generic PE-CF",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "70"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "1"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "35"
      ],
      "cool_plate_temp_initial_layer": [
        "35"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "0"
      ],
      "eng_plate_temp_initial_layer": [
        "0"
      ],
      "fan_cooling_layer_time": [
        "100"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "100"
      ],
      "filament_cost": [
        "65.99"
      ],
      "filament_density": [
        "0.95"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "1"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "6"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PE-CF"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "55"
      ],
      "hot_plate_temp_initial_layer": [
        "55"
      ],
      "nozzle_temperature_range_low": [
        "175"
      ],
      "nozzle_temperature_range_high": [
        "220"
      ],
      "nozzle_temperature": [
        "210"
      ],
      "nozzle_temperature_initial_layer": [
        "210"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "50%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "4"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "70"
      ],
      "textured_plate_temp": [
        "55"
      ],
      "textured_plate_temp_initial_layer": [
        "55"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "901"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSP98_01",
        "instantiation": "true",
        "description": "This is neither a commonly used filament, nor one of Bambu filaments, and it varies a lot from brand to brand. So, it's highly recommended to ask its vendor for suitable profile before printing and adjust some parameters according to its performances.",
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSP98_02",
        "instantiation": "true",
        "description": "This is neither a commonly used filament, nor one of Bambu filaments, and it varies a lot from brand to brand. So, it's highly recommended to ask its vendor for suitable profile before printing and adjust some parameters according to its performances.",
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSP98_03",
        "instantiation": "true",
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "1",
          "1"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "6",
          "6"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "210",
          "210"
        ],
        "nozzle_temperature_initial_layer": [
          "210",
          "210"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "X1C": {
        "setting_id": "GFSP98_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "GFP99": {
    "filament_id": "GFP99",
    "vendor": "Generic",
    "materialType": "Generic PE",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "70"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "1"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "35"
      ],
      "cool_plate_temp_initial_layer": [
        "35"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "0"
      ],
      "eng_plate_temp_initial_layer": [
        "0"
      ],
      "fan_cooling_layer_time": [
        "100"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "100"
      ],
      "filament_cost": [
        "40.99"
      ],
      "filament_density": [
        "0.95"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "1"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "8"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PE"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "55"
      ],
      "hot_plate_temp_initial_layer": [
        "55"
      ],
      "nozzle_temperature_range_low": [
        "175"
      ],
      "nozzle_temperature_range_high": [
        "220"
      ],
      "nozzle_temperature": [
        "210"
      ],
      "nozzle_temperature_initial_layer": [
        "210"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "50%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "4"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "70"
      ],
      "textured_plate_temp": [
        "55"
      ],
      "textured_plate_temp_initial_layer": [
        "55"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "901"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSP99_01",
        "instantiation": "true",
        "description": "This is neither a commonly used filament, nor one of Bambu filaments, and it varies a lot from brand to brand. So, it's highly recommended to ask its vendor for suitable profile before printing and adjust some parameters according to its performances.",
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSP99_02",
        "instantiation": "true",
        "description": "This is neither a commonly used filament, nor one of Bambu filaments, and it varies a lot from brand to brand. So, it's highly recommended to ask its vendor for suitable profile before printing and adjust some parameters according to its performances.",
        "compatible_printers": [
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSP99_03",
        "instantiation": "true",
        "description": "This is neither a commonly used filament, nor one of Bambu filaments, and it varies a lot from brand to brand. So, it's highly recommended to ask its vendor for suitable profile before printing and adjust some parameters according to its performances.",
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "1",
          "1"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "8",
          "8"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "210",
          "210"
        ],
        "nozzle_temperature_initial_layer": [
          "210",
          "210"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "X1C": {
        "setting_id": "GFSP99_00",
        "instantiation": "true",
        "description": "This is neither a commonly used filament, nor one of Bambu filaments, and it varies a lot from brand to brand. So, it's highly recommended to ask its vendor for suitable profile before printing and adjust some parameters according to its performances.",
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "GFR98": {
    "filament_id": "GFR98",
    "vendor": "Generic",
    "materialType": "Generic PHA",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "70"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "1"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "35"
      ],
      "cool_plate_temp_initial_layer": [
        "35"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "0"
      ],
      "eng_plate_temp_initial_layer": [
        "0"
      ],
      "fan_cooling_layer_time": [
        "100"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "100"
      ],
      "filament_cost": [
        "27.99"
      ],
      "filament_density": [
        "1.24"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "1"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "6"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PHA"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "55"
      ],
      "hot_plate_temp_initial_layer": [
        "55"
      ],
      "nozzle_temperature_range_low": [
        "190"
      ],
      "nozzle_temperature_range_high": [
        "240"
      ],
      "nozzle_temperature": [
        "220"
      ],
      "nozzle_temperature_initial_layer": [
        "220"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "50%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "4"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "120"
      ],
      "textured_plate_temp": [
        "55"
      ],
      "textured_plate_temp_initial_layer": [
        "55"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S255\n{elsif(bed_temperature[current_extruder] >35)||(bed_temperature_initial_layer[current_extruder] >35)}M106 P3 S180\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSR98_02",
        "instantiation": "true",
        "description": "This is neither a commonly used filament, nor one of Bambu filaments, and it varies a lot from brand to brand. So, it's highly recommended to ask its vendor for suitable profile before printing and adjust some parameters according to its performances.",
        "compatible_printers": [
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle",
          "Bambu Lab A1 0.4 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSR98_01",
        "instantiation": "true",
        "description": "This is neither a commonly used filament, nor one of Bambu filaments, and it varies a lot from brand to brand. So, it's highly recommended to ask its vendor for suitable profile before printing and adjust some parameters according to its performances.",
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSR98_03",
        "instantiation": "true",
        "description": "This is neither a commonly used filament, nor one of Bambu filaments, and it varies a lot from brand to brand. So, it's highly recommended to ask its vendor for suitable profile before printing and adjust some parameters according to its performances.",
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "1",
          "1"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "6",
          "6"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "220",
          "220"
        ],
        "nozzle_temperature_initial_layer": [
          "220",
          "220"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "X1C": {
        "setting_id": "GFSR98_00",
        "instantiation": "true",
        "description": "This is neither a commonly used filament, nor one of Bambu filaments, and it varies a lot from brand to brand. So, it's highly recommended to ask its vendor for suitable profile before printing and adjust some parameters according to its performances.",
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle",
          "Bambu Lab P1P 0.4 nozzle"
        ]
      }
    }
  },
  "GFR99": {
    "filament_id": "GFR99",
    "vendor": "Generic",
    "materialType": "Generic EVA",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "70"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "1"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "35"
      ],
      "cool_plate_temp_initial_layer": [
        "35"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "0"
      ],
      "eng_plate_temp_initial_layer": [
        "0"
      ],
      "fan_cooling_layer_time": [
        "100"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "100"
      ],
      "filament_cost": [
        "21.99"
      ],
      "filament_density": [
        "0.94"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "1"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "12"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "EVA"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "55"
      ],
      "hot_plate_temp_initial_layer": [
        "55"
      ],
      "nozzle_temperature_range_low": [
        "175"
      ],
      "nozzle_temperature_range_high": [
        "220"
      ],
      "nozzle_temperature": [
        "210"
      ],
      "nozzle_temperature_initial_layer": [
        "210"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "50%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "4"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "70"
      ],
      "textured_plate_temp": [
        "55"
      ],
      "textured_plate_temp_initial_layer": [
        "55"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSR99_01",
        "instantiation": "true",
        "description": "This is neither a commonly used filament, nor one of Bambu filaments, and it varies a lot from brand to brand. So, it's highly recommended to ask its vendor for suitable profile before printing and adjust some parameters according to its performances.",
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSR99_02",
        "instantiation": "true",
        "description": "This is neither a commonly used filament, nor one of Bambu filaments, and it varies a lot from brand to brand. So, it's highly recommended to ask its vendor for suitable profile before printing and adjust some parameters according to its performances.",
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSR99_03",
        "instantiation": "true",
        "description": "This is neither a commonly used filament, nor one of Bambu filaments, and it varies a lot from brand to brand. So, it's highly recommended to ask its vendor for suitable profile before printing and adjust some parameters according to its performances.",
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "1",
          "1"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "12",
          "12"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "210",
          "210"
        ],
        "nozzle_temperature_initial_layer": [
          "210",
          "210"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "X1C": {
        "setting_id": "GFSR99_00",
        "instantiation": "true",
        "description": "This is neither a commonly used filament, nor one of Bambu filaments, and it varies a lot from brand to brand. So, it's highly recommended to ask its vendor for suitable profile before printing and adjust some parameters according to its performances.",
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "GFS00": {
    "filament_id": "GFS00",
    "vendor": "Bambu Lab",
    "materialType": "Support W",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "70"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "1"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "40"
      ],
      "cool_plate_temp_initial_layer": [
        "40"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "0"
      ],
      "eng_plate_temp_initial_layer": [
        "0"
      ],
      "fan_cooling_layer_time": [
        "100"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "100"
      ],
      "filament_cost": [
        "69.98"
      ],
      "filament_density": [
        "1.30"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "1"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "1"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "12"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PLA"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "15%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "55"
      ],
      "hot_plate_temp_initial_layer": [
        "55"
      ],
      "nozzle_temperature_range_low": [
        "190"
      ],
      "nozzle_temperature_range_high": [
        "240"
      ],
      "nozzle_temperature": [
        "220"
      ],
      "nozzle_temperature_initial_layer": [
        "220"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "50%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "45"
      ],
      "supertack_plate_temp_initial_layer": [
        "45"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "8"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "45"
      ],
      "textured_plate_temp": [
        "55"
      ],
      "textured_plate_temp_initial_layer": [
        "55"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10.0"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "700"
      ],
      "description": "This is a non-water-soluble support filament, and usually it is only for the support structure and not for the model body. To get better printing quality, please refer to this wiki: Printing Tips for Support Filament and Support Function."
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSS00_03",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSS00_01",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "textured_plate_temp": [
          "60"
        ],
        "textured_plate_temp_initial_layer": [
          "60"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSS00_05",
        "instantiation": "true",
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "1",
          "1"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "12",
          "12"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "220",
          "220"
        ],
        "nozzle_temperature_initial_layer": [
          "220",
          "220"
        ],
        "pre_start_fan_time": [
          "2"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "X1": {
        "setting_id": "GFSS02",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n\n"
        ]
      },
      "X1C": {
        "setting_id": "GFSS00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n\n"
        ]
      }
    }
  },
  "GFS01": {
    "filament_id": "GFS01",
    "vendor": "Bambu Lab",
    "materialType": "Support G",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "1"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "3"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "100"
      ],
      "eng_plate_temp_initial_layer": [
        "100"
      ],
      "fan_cooling_layer_time": [
        "10"
      ],
      "fan_max_speed": [
        "60"
      ],
      "fan_min_speed": [
        "0"
      ],
      "filament_cost": [
        "34.99"
      ],
      "filament_density": [
        "1.22"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "1"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "1"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "8"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PA"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "100"
      ],
      "hot_plate_temp_initial_layer": [
        "100"
      ],
      "nozzle_temperature_range_low": [
        "260"
      ],
      "nozzle_temperature_range_high": [
        "300"
      ],
      "nozzle_temperature": [
        "280"
      ],
      "nozzle_temperature_initial_layer": [
        "280"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "30"
      ],
      "overhang_fan_threshold": [
        "95%"
      ],
      "reduce_fan_stop_start_freq": [
        "0"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "6"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "108"
      ],
      "textured_plate_temp": [
        "100"
      ],
      "textured_plate_temp_initial_layer": [
        "100"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10"
      ],
      "filament_start_gcode": [
        "; Filament gcode\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "701"
      ],
      "description": "This is a non-water-soluble support filament, and usually it is only for the support structure and not for the model body. To get better printing quality, please refer to this wiki: Printing Tips for Support Filament and Support Function."
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSS01_01",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSS01_02",
        "instantiation": "true",
        "chamber_temperatures": [
          "60"
        ],
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "1",
          "1"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "8",
          "8"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "280",
          "280"
        ],
        "nozzle_temperature_initial_layer": [
          "280",
          "280"
        ],
        "retraction_distances_when_ec": [
          "4",
          "4"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "X1C": {
        "setting_id": "GFSS01",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle"
        ]
      }
    }
  },
  "GFS02": {
    "filament_id": "GFS02",
    "vendor": "Bambu Lab",
    "materialType": "Support For PLA",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "70"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "1"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "40"
      ],
      "cool_plate_temp_initial_layer": [
        "40"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "0"
      ],
      "eng_plate_temp_initial_layer": [
        "0"
      ],
      "fan_cooling_layer_time": [
        "100"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "100"
      ],
      "filament_cost": [
        "69.98"
      ],
      "filament_density": [
        "1.30"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "1"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "1"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "12"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PLA"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "15%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "55"
      ],
      "hot_plate_temp_initial_layer": [
        "55"
      ],
      "nozzle_temperature_range_low": [
        "190"
      ],
      "nozzle_temperature_range_high": [
        "240"
      ],
      "nozzle_temperature": [
        "220"
      ],
      "nozzle_temperature_initial_layer": [
        "220"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "50%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "45"
      ],
      "supertack_plate_temp_initial_layer": [
        "45"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "8"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "45"
      ],
      "textured_plate_temp": [
        "55"
      ],
      "textured_plate_temp_initial_layer": [
        "55"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10.0"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "702"
      ],
      "description": "This is a non-water-soluble support filament, and usually it is only for the support structure and not for the model body. To get better printing quality, please refer to this wiki: Printing Tips for Support Filament and Support Function."
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSS02_04",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSS02_00",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "60"
        ],
        "hot_plate_temp_initial_layer": [
          "60"
        ],
        "textured_plate_temp": [
          "60"
        ],
        "textured_plate_temp_initial_layer": [
          "60"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSS02_07",
        "instantiation": "true",
        "fan_max_speed": [
          "30"
        ],
        "fan_min_speed": [
          "20"
        ],
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "1",
          "1"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "6",
          "6"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "220",
          "220"
        ],
        "nozzle_temperature_initial_layer": [
          "220",
          "220"
        ],
        "pre_start_fan_time": [
          "2"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "X1C": {
        "setting_id": "GFSS02_02",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "GFS03": {
    "filament_id": "GFS03",
    "vendor": "Bambu Lab",
    "materialType": "Support For PA PET",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "1"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "3"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "100"
      ],
      "eng_plate_temp_initial_layer": [
        "100"
      ],
      "fan_cooling_layer_time": [
        "10"
      ],
      "fan_max_speed": [
        "60"
      ],
      "fan_min_speed": [
        "0"
      ],
      "filament_cost": [
        "34.99"
      ],
      "filament_density": [
        "1.22"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "1"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "1"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "8"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PA"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "100"
      ],
      "hot_plate_temp_initial_layer": [
        "100"
      ],
      "nozzle_temperature_range_low": [
        "260"
      ],
      "nozzle_temperature_range_high": [
        "300"
      ],
      "nozzle_temperature": [
        "280"
      ],
      "nozzle_temperature_initial_layer": [
        "280"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "30"
      ],
      "overhang_fan_threshold": [
        "95%"
      ],
      "reduce_fan_stop_start_freq": [
        "0"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "6"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "108"
      ],
      "textured_plate_temp": [
        "100"
      ],
      "textured_plate_temp_initial_layer": [
        "100"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10"
      ],
      "filament_start_gcode": [
        "; Filament gcode\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "703"
      ],
      "description": "This is a non-water-soluble support filament, and usually it is only for the support structure and not for the model body. To get better printing quality, please refer to this wiki: Printing Tips for Support Filament and Support Function."
    },
    "model_settings": {}
  },
  "GFS04": {
    "filament_id": "GFS04",
    "vendor": "Bambu Lab",
    "materialType": "PVA",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "70"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "1"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "45"
      ],
      "cool_plate_temp_initial_layer": [
        "45"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "0"
      ],
      "eng_plate_temp_initial_layer": [
        "0"
      ],
      "fan_cooling_layer_time": [
        "100"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "100"
      ],
      "filament_cost": [
        "79.98"
      ],
      "filament_density": [
        "1.27"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "1"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "1"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "6"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "1"
      ],
      "filament_type": [
        "PVA"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "55"
      ],
      "hot_plate_temp_initial_layer": [
        "55"
      ],
      "nozzle_temperature_range_low": [
        "210"
      ],
      "nozzle_temperature_range_high": [
        "250"
      ],
      "nozzle_temperature": [
        "220"
      ],
      "nozzle_temperature_initial_layer": [
        "220"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "50%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "35"
      ],
      "supertack_plate_temp_initial_layer": [
        "35"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "7"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "45"
      ],
      "textured_plate_temp": [
        "55"
      ],
      "textured_plate_temp_initial_layer": [
        "55"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S255\n{elsif(bed_temperature[current_extruder] >35)||(bed_temperature_initial_layer[current_extruder] >35)}M106 P3 S180\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "704"
      ],
      "description": "This is a water-soluble support filament, and usually it is only for the support structure and not for the model body. Printing this filament is of many requirements, and to get better printing quality, please refer to this wiki: PVA Printing Guide."
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSS04_04",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "nozzle_temperature": [
          "240"
        ],
        "nozzle_temperature_initial_layer": [
          "240"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSS04_06",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "nozzle_temperature": [
          "240"
        ],
        "nozzle_temperature_initial_layer": [
          "240"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSS04_10",
        "instantiation": "true",
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "1",
          "1"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "6",
          "6"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "240",
          "240"
        ],
        "nozzle_temperature_initial_layer": [
          "240",
          "240"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "P1P": {
        "setting_id": "GFSS04_02",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_min_speed": [
          "50"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "nozzle_temperature": [
          "240"
        ],
        "nozzle_temperature_initial_layer": [
          "240"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSS04_00",
        "instantiation": "true",
        "nozzle_temperature": [
          "240"
        ],
        "nozzle_temperature_initial_layer": [
          "240"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "GFS05": {
    "filament_id": "GFS05",
    "vendor": "Bambu Lab",
    "materialType": "Support For PLA-PETG",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "70"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "1"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "35"
      ],
      "cool_plate_temp_initial_layer": [
        "35"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "0"
      ],
      "eng_plate_temp_initial_layer": [
        "0"
      ],
      "fan_cooling_layer_time": [
        "80"
      ],
      "fan_max_speed": [
        "30"
      ],
      "fan_min_speed": [
        "20"
      ],
      "filament_cost": [
        "69.98"
      ],
      "filament_density": [
        "1.19"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "1"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "1"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "6"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PLA"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "15%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "60"
      ],
      "hot_plate_temp_initial_layer": [
        "60"
      ],
      "nozzle_temperature_range_low": [
        "190"
      ],
      "nozzle_temperature_range_high": [
        "240"
      ],
      "nozzle_temperature": [
        "210"
      ],
      "nozzle_temperature_initial_layer": [
        "210"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "50%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "45"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "8"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "45"
      ],
      "textured_plate_temp": [
        "60"
      ],
      "textured_plate_temp_initial_layer": [
        "60"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10.0"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S255\n{elsif(bed_temperature[current_extruder] >35)||(bed_temperature_initial_layer[current_extruder] >35)}M106 P3 S180\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "705"
      ],
      "description": "This is a non-water-soluble support filament, and usually it is only for the support structure and not for the model body. To get better printing quality, please refer to this wiki: Printing Tips for Support Filament and Support Function."
    },
    "model_settings": {}
  },
  "GFS06": {
    "filament_id": "GFS06",
    "vendor": "Bambu Lab",
    "materialType": "Support for ABS",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "1"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "3"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "90"
      ],
      "eng_plate_temp_initial_layer": [
        "90"
      ],
      "fan_cooling_layer_time": [
        "30"
      ],
      "fan_max_speed": [
        "30"
      ],
      "fan_min_speed": [
        "10"
      ],
      "filament_cost": [
        "29.98"
      ],
      "filament_density": [
        "1.16"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "1"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "6"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "ABS"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "90"
      ],
      "hot_plate_temp_initial_layer": [
        "90"
      ],
      "nozzle_temperature_range_low": [
        "240"
      ],
      "nozzle_temperature_range_high": [
        "270"
      ],
      "nozzle_temperature": [
        "270"
      ],
      "nozzle_temperature_initial_layer": [
        "260"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "80"
      ],
      "overhang_fan_threshold": [
        "25%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "12"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "90"
      ],
      "textured_plate_temp": [
        "90"
      ],
      "textured_plate_temp_initial_layer": [
        "90"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10"
      ],
      "filament_start_gcode": [
        "; Filament gcode\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "706"
      ],
      "description": "This is a non-water-soluble support filament, and usually it is only for the support structure and not for the model body. To get better printing quality, please refer to this wiki: Printing Tips for Support Filament and Support Function."
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSS06_01",
        "instantiation": "true",
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSS06_02",
        "instantiation": "true",
        "chamber_temperatures": [
          "60"
        ],
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.95",
          "0.95"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "6",
          "6"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "270",
          "270"
        ],
        "nozzle_temperature_initial_layer": [
          "260",
          "260"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "X1C": {
        "setting_id": "GFSS06_00",
        "instantiation": "true",
        "filament_long_retractions_when_cut": [
          "1"
        ],
        "filament_retraction_distances_when_cut": [
          "18"
        ],
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "GFS97": {
    "filament_id": "GFS97",
    "vendor": "Generic",
    "materialType": "Generic BVOH",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "70"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "1"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "40"
      ],
      "cool_plate_temp_initial_layer": [
        "40"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "0"
      ],
      "eng_plate_temp_initial_layer": [
        "0"
      ],
      "fan_cooling_layer_time": [
        "100"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "100"
      ],
      "filament_cost": [
        "69.99"
      ],
      "filament_density": [
        "1.13"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "1"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "1"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "8"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "BVOH"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "55"
      ],
      "hot_plate_temp_initial_layer": [
        "55"
      ],
      "nozzle_temperature_range_low": [
        "190"
      ],
      "nozzle_temperature_range_high": [
        "240"
      ],
      "nozzle_temperature": [
        "220"
      ],
      "nozzle_temperature_initial_layer": [
        "220"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "50%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "8"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "45"
      ],
      "textured_plate_temp": [
        "55"
      ],
      "textured_plate_temp_initial_layer": [
        "55"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >55)||(bed_temperature_initial_layer[current_extruder] >55)}M106 P3 S200\n{elsif(bed_temperature[current_extruder] >50)||(bed_temperature_initial_layer[current_extruder] >50)}M106 P3 S150\n{elsif(bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S50\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "797"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSS97_02",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSS97_01",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSS97_03",
        "instantiation": "true",
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "1",
          "1"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "8",
          "8"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "220",
          "220"
        ],
        "nozzle_temperature_initial_layer": [
          "220",
          "220"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "X1C": {
        "setting_id": "GFSS97_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle"
        ]
      }
    }
  },
  "GFS98": {
    "filament_id": "GFS98",
    "vendor": "Generic",
    "materialType": "Generic HIPS",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "3"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "90"
      ],
      "eng_plate_temp_initial_layer": [
        "90"
      ],
      "fan_cooling_layer_time": [
        "10"
      ],
      "fan_max_speed": [
        "60"
      ],
      "fan_min_speed": [
        "0"
      ],
      "filament_cost": [
        "22.99"
      ],
      "filament_density": [
        "1.06"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "1"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "1"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "8"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "HIPS"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "90"
      ],
      "hot_plate_temp_initial_layer": [
        "90"
      ],
      "nozzle_temperature_range_low": [
        "220"
      ],
      "nozzle_temperature_range_high": [
        "270"
      ],
      "nozzle_temperature": [
        "240"
      ],
      "nozzle_temperature_initial_layer": [
        "240"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "80"
      ],
      "overhang_fan_threshold": [
        "25%"
      ],
      "reduce_fan_stop_start_freq": [
        "0"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "6"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "100"
      ],
      "textured_plate_temp": [
        "90"
      ],
      "textured_plate_temp_initial_layer": [
        "90"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10"
      ],
      "filament_start_gcode": [
        "; Filament gcode\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "798"
      ]
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSS98_04",
        "instantiation": "true",
        "eng_plate_temp": [
          "70"
        ],
        "eng_plate_temp_initial_layer": [
          "70"
        ],
        "hot_plate_temp": [
          "70"
        ],
        "hot_plate_temp_initial_layer": [
          "70"
        ],
        "textured_plate_temp": [
          "70"
        ],
        "textured_plate_temp_initial_layer": [
          "70"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSS98_02",
        "instantiation": "true",
        "eng_plate_temp": [
          "70"
        ],
        "eng_plate_temp_initial_layer": [
          "70"
        ],
        "hot_plate_temp": [
          "70"
        ],
        "hot_plate_temp_initial_layer": [
          "70"
        ],
        "textured_plate_temp": [
          "70"
        ],
        "textured_plate_temp_initial_layer": [
          "70"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSS98_06",
        "instantiation": "true",
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "1",
          "1"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "8",
          "8"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "240",
          "240"
        ],
        "nozzle_temperature_initial_layer": [
          "240",
          "240"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "X1C": {
        "setting_id": "GFSS98_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "GFS99": {
    "filament_id": "GFS99",
    "vendor": "Generic",
    "materialType": "Generic PVA",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "70"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "1"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "45"
      ],
      "cool_plate_temp_initial_layer": [
        "45"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "0"
      ],
      "eng_plate_temp_initial_layer": [
        "0"
      ],
      "fan_cooling_layer_time": [
        "100"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "100"
      ],
      "filament_cost": [
        "20"
      ],
      "filament_density": [
        "1.24"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.95"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "1"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "16"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "1"
      ],
      "filament_type": [
        "PVA"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "55"
      ],
      "hot_plate_temp_initial_layer": [
        "55"
      ],
      "nozzle_temperature_range_low": [
        "190"
      ],
      "nozzle_temperature_range_high": [
        "240"
      ],
      "nozzle_temperature": [
        "220"
      ],
      "nozzle_temperature_initial_layer": [
        "220"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "50%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "35"
      ],
      "supertack_plate_temp_initial_layer": [
        "35"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "7"
      ],
      "slow_down_min_speed": [
        "20"
      ],
      "temperature_vitrification": [
        "45"
      ],
      "textured_plate_temp": [
        "55"
      ],
      "textured_plate_temp_initial_layer": [
        "55"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >45)||(bed_temperature_initial_layer[current_extruder] >45)}M106 P3 S255\n{elsif(bed_temperature[current_extruder] >35)||(bed_temperature_initial_layer[current_extruder] >35)}M106 P3 S180\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "704"
      ],
      "description": "This is a water-soluble support filament, and usually it is only for the support structure and not for the model body. Printing this filament is of many requirements, and to get better printing quality, please refer to this wiki: PVA Printing Guide."
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSS99_03",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSS99_01",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "80"
        ],
        "fan_max_speed": [
          "80"
        ],
        "fan_min_speed": [
          "60"
        ],
        "hot_plate_temp": [
          "65"
        ],
        "hot_plate_temp_initial_layer": [
          "65"
        ],
        "slow_down_layer_time": [
          "8"
        ],
        "textured_plate_temp": [
          "65"
        ],
        "textured_plate_temp_initial_layer": [
          "65"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle",
          "Bambu Lab A1 mini 0.4 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSS99_06",
        "instantiation": "true",
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.95",
          "0.95"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "16",
          "16"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "220",
          "220"
        ],
        "nozzle_temperature_initial_layer": [
          "220",
          "220"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      }
    }
  },
  "GFT01": {
    "filament_id": "GFT01",
    "vendor": "Bambu Lab",
    "materialType": "PET-CF",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "3"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "80"
      ],
      "eng_plate_temp_initial_layer": [
        "80"
      ],
      "fan_cooling_layer_time": [
        "5"
      ],
      "fan_max_speed": [
        "30"
      ],
      "fan_min_speed": [
        "10"
      ],
      "filament_cost": [
        "84.99"
      ],
      "filament_density": [
        "1.29"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "1"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "8"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PET-CF"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "100"
      ],
      "hot_plate_temp_initial_layer": [
        "100"
      ],
      "nozzle_temperature_range_low": [
        "260"
      ],
      "nozzle_temperature_range_high": [
        "290"
      ],
      "nozzle_temperature": [
        "270"
      ],
      "nozzle_temperature_initial_layer": [
        "270"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "40"
      ],
      "overhang_fan_threshold": [
        "0%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "40"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "80"
      ],
      "supertack_plate_temp_initial_layer": [
        "80"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "2"
      ],
      "slow_down_min_speed": [
        "10"
      ],
      "temperature_vitrification": [
        "185"
      ],
      "textured_plate_temp": [
        "100"
      ],
      "textured_plate_temp_initial_layer": [
        "100"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "4.5"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if (bed_temperature[current_extruder] >80)||(bed_temperature_initial_layer[current_extruder] >80)}M106 P3 S255\n{elsif (bed_temperature[current_extruder] >60)||(bed_temperature_initial_layer[current_extruder] >60)}M106 P3 S180\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "800"
      ],
      "description": "When printing this filament, there's a risk of nozzle clogging, oozing, warping and low layer adhesion strength. To get better results, please refer to this wiki: Printing Tips for High Temp / Engineering materials."
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFST01_01",
        "instantiation": "true",
        "reduce_fan_stop_start_freq": [
          "0"
        ],
        "slow_down_min_speed": [
          "20"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.8 nozzle",
          "Bambu Lab A1 0.6 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFST01_02",
        "instantiation": "true",
        "chamber_temperatures": [
          "50"
        ],
        "counter_coef_2": [
          "0.0075"
        ],
        "counter_coef_3": [
          "-0.052"
        ],
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "1",
          "1"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "8",
          "8"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "hole_coef_2": [
          "-0.012"
        ],
        "hole_coef_3": [
          "0.35043"
        ],
        "hole_limit_min": [
          "0.07"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "270",
          "270"
        ],
        "nozzle_temperature_initial_layer": [
          "270",
          "270"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "X1C": {
        "setting_id": "GFST01",
        "instantiation": "true",
        "reduce_fan_stop_start_freq": [
          "0"
        ],
        "slow_down_min_speed": [
          "20"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle"
        ]
      }
    }
  },
  "GFT02": {
    "filament_id": "GFT02",
    "vendor": "Bambu Lab",
    "materialType": "PPS-CF",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "60"
      ],
      "close_fan_the_first_x_layers": [
        "3"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "110"
      ],
      "eng_plate_temp_initial_layer": [
        "110"
      ],
      "fan_cooling_layer_time": [
        "5"
      ],
      "fan_max_speed": [
        "30"
      ],
      "fan_min_speed": [
        "0"
      ],
      "filament_cost": [
        "175"
      ],
      "filament_density": [
        "1.26"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.96"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "6"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PPS-CF"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "110"
      ],
      "hot_plate_temp_initial_layer": [
        "110"
      ],
      "nozzle_temperature_range_low": [
        "310"
      ],
      "nozzle_temperature_range_high": [
        "340"
      ],
      "nozzle_temperature": [
        "320"
      ],
      "nozzle_temperature_initial_layer": [
        "320"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "30"
      ],
      "overhang_fan_threshold": [
        "25%"
      ],
      "reduce_fan_stop_start_freq": [
        "0"
      ],
      "required_nozzle_HRC": [
        "40"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "2"
      ],
      "slow_down_min_speed": [
        "10"
      ],
      "temperature_vitrification": [
        "220"
      ],
      "textured_plate_temp": [
        "110"
      ],
      "textured_plate_temp_initial_layer": [
        "110"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "2.8"
      ],
      "filament_start_gcode": [
        "; Filament gcode\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "801"
      ],
      "description": "When printing this filament, there's a risk of nozzle clogging, oozing, warping and low layer adhesion strength. To get better results, please refer to this wiki: Printing Tips for High Temp / Engineering materials."
    },
    "model_settings": {
      "H2D": {
        "setting_id": "GFST02_01",
        "instantiation": "true",
        "chamber_temperatures": [
          "65"
        ],
        "counter_coef_2": [
          "0.00565"
        ],
        "counter_coef_3": [
          "-0.0202"
        ],
        "counter_limit_max": [
          "0.03"
        ],
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.96",
          "0.96"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "6",
          "6"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_printable": [
          "1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "320",
          "320"
        ],
        "nozzle_temperature_initial_layer": [
          "320",
          "320"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "X1E": {
        "setting_id": "GFST02_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "GFT97": {
    "filament_id": "GFT97",
    "vendor": "Generic",
    "materialType": "Generic PPS",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "60"
      ],
      "close_fan_the_first_x_layers": [
        "3"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "110"
      ],
      "eng_plate_temp_initial_layer": [
        "110"
      ],
      "fan_cooling_layer_time": [
        "5"
      ],
      "fan_max_speed": [
        "50"
      ],
      "fan_min_speed": [
        "0"
      ],
      "filament_cost": [
        "0"
      ],
      "filament_density": [
        "1.36"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.96"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "4"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PPS"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "110"
      ],
      "hot_plate_temp_initial_layer": [
        "110"
      ],
      "nozzle_temperature_range_low": [
        "300"
      ],
      "nozzle_temperature_range_high": [
        "340"
      ],
      "nozzle_temperature": [
        "320"
      ],
      "nozzle_temperature_initial_layer": [
        "320"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "30"
      ],
      "overhang_fan_threshold": [
        "0%"
      ],
      "reduce_fan_stop_start_freq": [
        "0"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "2"
      ],
      "slow_down_min_speed": [
        "10"
      ],
      "temperature_vitrification": [
        "125"
      ],
      "textured_plate_temp": [
        "110"
      ],
      "textured_plate_temp_initial_layer": [
        "110"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10"
      ],
      "filament_start_gcode": [
        "; Filament gcode\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "801"
      ]
    },
    "model_settings": {
      "H2D": {
        "setting_id": "GFST97_01",
        "instantiation": "true",
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.96",
          "0.96"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "4",
          "4"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "320",
          "320"
        ],
        "nozzle_temperature_initial_layer": [
          "320",
          "320"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "X1E": {
        "setting_id": "GFST97_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle"
        ]
      }
    }
  },
  "GFT98": {
    "filament_id": "GFT98",
    "vendor": "Generic",
    "materialType": "Generic PPS-CF",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "0"
      ],
      "chamber_temperatures": [
        "60"
      ],
      "close_fan_the_first_x_layers": [
        "3"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "0"
      ],
      "cool_plate_temp_initial_layer": [
        "0"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "110"
      ],
      "eng_plate_temp_initial_layer": [
        "110"
      ],
      "fan_cooling_layer_time": [
        "5"
      ],
      "fan_max_speed": [
        "30"
      ],
      "fan_min_speed": [
        "0"
      ],
      "filament_cost": [
        "240"
      ],
      "filament_density": [
        "1.26"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.96"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "3"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "nil"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "PPS-CF"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "110"
      ],
      "hot_plate_temp_initial_layer": [
        "110"
      ],
      "nozzle_temperature_range_low": [
        "310"
      ],
      "nozzle_temperature_range_high": [
        "340"
      ],
      "nozzle_temperature": [
        "320"
      ],
      "nozzle_temperature_initial_layer": [
        "320"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "30"
      ],
      "overhang_fan_threshold": [
        "0%"
      ],
      "reduce_fan_stop_start_freq": [
        "0"
      ],
      "required_nozzle_HRC": [
        "40"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "2"
      ],
      "slow_down_min_speed": [
        "10"
      ],
      "temperature_vitrification": [
        "220"
      ],
      "textured_plate_temp": [
        "110"
      ],
      "textured_plate_temp_initial_layer": [
        "110"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "5.7"
      ],
      "filament_start_gcode": [
        "; Filament gcode\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "801"
      ],
      "description": "When printing this filament, there's a risk of nozzle clogging, oozing, warping and low layer adhesion strength. To get better results, please refer to this wiki: Printing Tips for High Temp / Engineering materials."
    },
    "model_settings": {
      "H2D": {
        "setting_id": "GFST98_01",
        "instantiation": "true",
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.96",
          "0.96"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "3",
          "3"
        ],
        "filament_ramming_volumetric_speed": [
          "-1",
          "-1"
        ],
        "filament_printable": [
          "1"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "0",
          "0"
        ],
        "filament_ramming_travel_time": [
          "0",
          "0"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "320",
          "320"
        ],
        "nozzle_temperature_initial_layer": [
          "320",
          "320"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "X1E": {
        "setting_id": "GFST98_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab X1E 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle"
        ]
      }
    }
  },
  "GFU00": {
    "filament_id": "GFU00",
    "vendor": "Bambu Lab",
    "materialType": "TPU 95A HF",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "70"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "1"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "30"
      ],
      "cool_plate_temp_initial_layer": [
        "30"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "30"
      ],
      "eng_plate_temp_initial_layer": [
        "30"
      ],
      "fan_cooling_layer_time": [
        "100"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "100"
      ],
      "filament_cost": [
        "41.99"
      ],
      "filament_density": [
        "1.22"
      ],
      "filament_deretraction_speed": [
        "10"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "1"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "12"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "2"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "10"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "TPU"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "35"
      ],
      "hot_plate_temp_initial_layer": [
        "35"
      ],
      "nozzle_temperature_range_low": [
        "200"
      ],
      "nozzle_temperature_range_high": [
        "250"
      ],
      "nozzle_temperature": [
        "230"
      ],
      "nozzle_temperature_initial_layer": [
        "230"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "95%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "8"
      ],
      "slow_down_min_speed": [
        "10"
      ],
      "temperature_vitrification": [
        "30"
      ],
      "textured_plate_temp": [
        "35"
      ],
      "textured_plate_temp_initial_layer": [
        "35"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "86.3"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >35)||(bed_temperature_initial_layer[current_extruder] >35)}M106 P3 S255\n{elsif(bed_temperature[current_extruder] >30)||(bed_temperature_initial_layer[current_extruder] >30)}M106 P3 S180\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "600"
      ],
      "description": "This filament is too soft and not compatible with the AMS. Printing it is of many requirements, and to get better printing quality, please refer to this wiki: TPU printing guide."
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSU00_06",
        "instantiation": "true",
        "filament_deretraction_speed": [
          "nil"
        ],
        "filament_retraction_length": [
          "0.8"
        ],
        "filament_retraction_speed": [
          "nil"
        ],
        "hot_plate_temp": [
          "45"
        ],
        "hot_plate_temp_initial_layer": [
          "45"
        ],
        "textured_plate_temp": [
          "45"
        ],
        "textured_plate_temp_initial_layer": [
          "45"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSU00_05",
        "instantiation": "true",
        "filament_deretraction_speed": [
          "nil"
        ],
        "filament_retraction_length": [
          "0.8"
        ],
        "filament_retraction_speed": [
          "nil"
        ],
        "hot_plate_temp": [
          "30"
        ],
        "hot_plate_temp_initial_layer": [
          "30"
        ],
        "textured_plate_temp": [
          "30"
        ],
        "textured_plate_temp_initial_layer": [
          "30"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSU00_08",
        "instantiation": "true",
        "additional_cooling_fan_speed": [
          "100"
        ],
        "filament_deretraction_speed": [
          "10",
          "10"
        ],
        "filament_flow_ratio": [
          "1",
          "1"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "12",
          "12"
        ],
        "filament_ramming_volumetric_speed": [
          "3.0",
          "3.0"
        ],
        "filament_printable": [
          "2"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "2",
          "2"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "10",
          "10"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "200",
          "200"
        ],
        "filament_ramming_travel_time": [
          "20",
          "20"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "230",
          "230"
        ],
        "nozzle_temperature_initial_layer": [
          "230",
          "230"
        ],
        "retraction_distances_when_ec": [
          "0",
          "0"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "P1P": {
        "setting_id": "GFSU00_02",
        "instantiation": "true",
        "filament_deretraction_speed": [
          "nil"
        ],
        "filament_retraction_length": [
          "0.8"
        ],
        "filament_retraction_speed": [
          "nil"
        ],
        "hot_plate_temp": [
          "45"
        ],
        "hot_plate_temp_initial_layer": [
          "45"
        ],
        "textured_plate_temp": [
          "45"
        ],
        "textured_plate_temp_initial_layer": [
          "45"
        ],
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle"
        ]
      },
      "P1S": {
        "setting_id": "GFSU00_03",
        "instantiation": "true",
        "filament_deretraction_speed": [
          "nil"
        ],
        "filament_retraction_length": [
          "0.8"
        ],
        "filament_retraction_speed": [
          "nil"
        ],
        "compatible_printers": [
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle"
        ]
      },
      "X1": {
        "setting_id": "GFSU00_01",
        "instantiation": "true",
        "filament_deretraction_speed": [
          "nil"
        ],
        "filament_retraction_length": [
          "0.8"
        ],
        "filament_retraction_speed": [
          "nil"
        ],
        "compatible_printers": [
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSU00_00",
        "instantiation": "true",
        "filament_deretraction_speed": [
          "nil"
        ],
        "filament_retraction_length": [
          "0.8"
        ],
        "filament_retraction_speed": [
          "nil"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle"
        ]
      },
      "X1E": {
        "setting_id": "GFSU00_04",
        "instantiation": "true",
        "filament_deretraction_speed": [
          "nil"
        ],
        "filament_retraction_length": [
          "0.8"
        ],
        "filament_retraction_speed": [
          "nil"
        ],
        "compatible_printers": [
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "GFU01": {
    "filament_id": "GFU01",
    "vendor": "Bambu Lab",
    "materialType": "TPU 95A",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "70"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "1"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "30"
      ],
      "cool_plate_temp_initial_layer": [
        "30"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "30"
      ],
      "eng_plate_temp_initial_layer": [
        "30"
      ],
      "fan_cooling_layer_time": [
        "100"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "100"
      ],
      "filament_cost": [
        "41.99"
      ],
      "filament_density": [
        "1.22"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "1"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "15"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "0.4"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "TPU"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "35"
      ],
      "hot_plate_temp_initial_layer": [
        "35"
      ],
      "nozzle_temperature_range_low": [
        "200"
      ],
      "nozzle_temperature_range_high": [
        "250"
      ],
      "nozzle_temperature": [
        "230"
      ],
      "nozzle_temperature_initial_layer": [
        "230"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "95%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "8"
      ],
      "slow_down_min_speed": [
        "10"
      ],
      "temperature_vitrification": [
        "30"
      ],
      "textured_plate_temp": [
        "35"
      ],
      "textured_plate_temp_initial_layer": [
        "35"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "88.7"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >35)||(bed_temperature_initial_layer[current_extruder] >35)}M106 P3 S255\n{elsif(bed_temperature[current_extruder] >30)||(bed_temperature_initial_layer[current_extruder] >30)}M106 P3 S180\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "600"
      ],
      "description": "This filament is too soft and not compatible with the AMS. Printing it is of many requirements, and to get better printing quality, please refer to this wiki: TPU printing guide."
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSU01_01",
        "instantiation": "true",
        "filament_max_volumetric_speed": [
          "3.6"
        ],
        "hot_plate_temp": [
          "45"
        ],
        "hot_plate_temp_initial_layer": [
          "45"
        ],
        "textured_plate_temp": [
          "45"
        ],
        "textured_plate_temp_initial_layer": [
          "45"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSU01_00",
        "instantiation": "true",
        "filament_max_volumetric_speed": [
          "3.6"
        ],
        "hot_plate_temp": [
          "30"
        ],
        "hot_plate_temp_initial_layer": [
          "30"
        ],
        "textured_plate_temp": [
          "30"
        ],
        "textured_plate_temp_initial_layer": [
          "30"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSU01_03",
        "instantiation": "true",
        "additional_cooling_fan_speed": [
          "100"
        ],
        "filament_deretraction_speed": [
          "10",
          "10"
        ],
        "filament_flow_ratio": [
          "1",
          "1"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "3.6",
          "3.6"
        ],
        "filament_ramming_volumetric_speed": [
          "0.9",
          "0.9"
        ],
        "filament_printable": [
          "2"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "2",
          "2"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "10",
          "10"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "200",
          "200"
        ],
        "filament_ramming_travel_time": [
          "20",
          "20"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "230",
          "230"
        ],
        "nozzle_temperature_initial_layer": [
          "230",
          "230"
        ],
        "retraction_distances_when_ec": [
          "0",
          "0"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "X1": {
        "setting_id": "GFSU01",
        "instantiation": "true",
        "filament_max_volumetric_speed": [
          "3.6"
        ],
        "compatible_printers": [
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSU00",
        "instantiation": "true",
        "filament_max_volumetric_speed": [
          "3.6"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "GFU02": {
    "filament_id": "GFU02",
    "vendor": "Bambu Lab",
    "materialType": "TPU for AMS",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "70"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "1"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "30"
      ],
      "cool_plate_temp_initial_layer": [
        "30"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "30"
      ],
      "eng_plate_temp_initial_layer": [
        "30"
      ],
      "fan_cooling_layer_time": [
        "30"
      ],
      "fan_max_speed": [
        "50"
      ],
      "fan_min_speed": [
        "20"
      ],
      "filament_cost": [
        "38.99"
      ],
      "filament_density": [
        "1.26"
      ],
      "filament_deretraction_speed": [
        "10"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "0.97"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "18"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "2"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "10"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "TPU-AMS"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "35"
      ],
      "hot_plate_temp_initial_layer": [
        "35"
      ],
      "nozzle_temperature_range_low": [
        "220"
      ],
      "nozzle_temperature_range_high": [
        "240"
      ],
      "nozzle_temperature": [
        "230"
      ],
      "nozzle_temperature_initial_layer": [
        "230"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "25%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "10"
      ],
      "slow_down_min_speed": [
        "10"
      ],
      "temperature_vitrification": [
        "30"
      ],
      "textured_plate_temp": [
        "35"
      ],
      "textured_plate_temp_initial_layer": [
        "35"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "9.6"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >35)||(bed_temperature_initial_layer[current_extruder] >35)}M106 P3 S255\n{elsif(bed_temperature[current_extruder] >30)||(bed_temperature_initial_layer[current_extruder] >30)}M106 P3 S180\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "600"
      ],
      "description": "If you are to print a kind of soft TPU, please don't slice with this profile, and it is only for TPU that has high enough hardness (not less than 55D) and is compatible with the AMS. To get better printing quality, please refer to this wiki: TPU printing guide."
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSU02_02",
        "instantiation": "true",
        "fan_max_speed": [
          "40"
        ],
        "filament_deretraction_speed": [
          "nil"
        ],
        "filament_retraction_length": [
          "0.4"
        ],
        "filament_retraction_speed": [
          "nil"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSU02_03",
        "instantiation": "true",
        "fan_max_speed": [
          "40"
        ],
        "filament_deretraction_speed": [
          "nil"
        ],
        "filament_retraction_length": [
          "0.4"
        ],
        "filament_retraction_speed": [
          "nil"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.4 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSU02_04",
        "instantiation": "true",
        "additional_cooling_fan_speed": [
          "100"
        ],
        "fan_max_speed": [
          "40"
        ],
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "0.97",
          "0.97"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "12",
          "12"
        ],
        "filament_ramming_volumetric_speed": [
          "4.5",
          "4.5"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "0.4",
          "0.4"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "200",
          "200"
        ],
        "filament_ramming_travel_time": [
          "20",
          "20"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "230",
          "230"
        ],
        "nozzle_temperature_initial_layer": [
          "230",
          "230"
        ],
        "retraction_distances_when_ec": [
          "0",
          "0"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "P1P": {
        "setting_id": "GFSU02_01",
        "instantiation": "true",
        "fan_max_speed": [
          "40"
        ],
        "filament_deretraction_speed": [
          "nil"
        ],
        "filament_retraction_length": [
          "0.4"
        ],
        "filament_retraction_speed": [
          "nil"
        ],
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSU02_00",
        "instantiation": "true",
        "fan_max_speed": [
          "40"
        ],
        "filament_deretraction_speed": [
          "nil"
        ],
        "filament_retraction_length": [
          "0.4"
        ],
        "filament_retraction_speed": [
          "nil"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.8 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle"
        ]
      }
    }
  },
  "GFU03": {
    "filament_id": "GFU03",
    "vendor": "Bambu Lab",
    "materialType": "TPU 90A",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "70"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "1"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "30"
      ],
      "cool_plate_temp_initial_layer": [
        "30"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "30"
      ],
      "eng_plate_temp_initial_layer": [
        "30"
      ],
      "fan_cooling_layer_time": [
        "100"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "100"
      ],
      "filament_cost": [
        "59.99"
      ],
      "filament_density": [
        "1.24"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "1"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "2.8"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "0.4"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "TPU"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "35"
      ],
      "hot_plate_temp_initial_layer": [
        "35"
      ],
      "nozzle_temperature_range_low": [
        "200"
      ],
      "nozzle_temperature_range_high": [
        "240"
      ],
      "nozzle_temperature": [
        "225"
      ],
      "nozzle_temperature_initial_layer": [
        "225"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "95%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "14"
      ],
      "slow_down_min_speed": [
        "10"
      ],
      "temperature_vitrification": [
        "30"
      ],
      "textured_plate_temp": [
        "35"
      ],
      "textured_plate_temp_initial_layer": [
        "35"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "87.3"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >35)||(bed_temperature_initial_layer[current_extruder] >35)}M106 P3 S255\n{elsif(bed_temperature[current_extruder] >30)||(bed_temperature_initial_layer[current_extruder] >30)}M106 P3 S180\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "600"
      ],
      "description": "This filament is too soft and not compatible with the AMS. Printing it is of many requirements, and to get better printing quality, please refer to this wiki: TPU printing guide."
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSU03_04",
        "instantiation": "true",
        "filament_density": [
          "1.22"
        ],
        "hot_plate_temp": [
          "45"
        ],
        "hot_plate_temp_initial_layer": [
          "45"
        ],
        "impact_strength_z": [
          "88.7"
        ],
        "nozzle_temperature_range_high": [
          "250"
        ],
        "textured_plate_temp": [
          "45"
        ],
        "textured_plate_temp_initial_layer": [
          "45"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSU03_05",
        "instantiation": "true",
        "filament_density": [
          "1.22"
        ],
        "hot_plate_temp": [
          "30"
        ],
        "hot_plate_temp_initial_layer": [
          "30"
        ],
        "impact_strength_z": [
          "88.7"
        ],
        "nozzle_temperature_range_high": [
          "250"
        ],
        "textured_plate_temp": [
          "30"
        ],
        "textured_plate_temp_initial_layer": [
          "30"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.8 nozzle",
          "Bambu Lab A1 mini 0.4 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSU03_02",
        "instantiation": "true",
        "additional_cooling_fan_speed": [
          "100"
        ],
        "filament_deretraction_speed": [
          "10",
          "10"
        ],
        "filament_flow_ratio": [
          "1",
          "1"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "2.8",
          "2.8"
        ],
        "filament_ramming_volumetric_speed": [
          "0.7",
          "0.7"
        ],
        "filament_printable": [
          "2"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "2",
          "2"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "10",
          "10"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "195",
          "195"
        ],
        "filament_ramming_travel_time": [
          "20",
          "20"
        ],
        "impact_strength_z": [
          "88.7"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature_range_high": [
          "250"
        ],
        "nozzle_temperature": [
          "225",
          "225"
        ],
        "nozzle_temperature_initial_layer": [
          "225",
          "225"
        ],
        "retraction_distances_when_ec": [
          "0",
          "0"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "P1P": {
        "setting_id": "GFSU03_01",
        "instantiation": "true",
        "description": "This filament is too soft and not compatible with the AMS. Printing it is of many requirements, and to get better printing quality, please refer to this wiki: TPU printing guide.",
        "compatible_printers": [
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSU03_00",
        "instantiation": "true",
        "description": "This filament is too soft and not compatible with the AMS. Printing it is of many requirements, and to get better printing quality, please refer to this wiki: TPU printing guide.",
        "compatible_printers": [
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle"
        ]
      }
    }
  },
  "GFU04": {
    "filament_id": "GFU04",
    "vendor": "Bambu Lab",
    "materialType": "TPU 85A",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "70"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "1"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "30"
      ],
      "cool_plate_temp_initial_layer": [
        "30"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "30"
      ],
      "eng_plate_temp_initial_layer": [
        "30"
      ],
      "fan_cooling_layer_time": [
        "100"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "100"
      ],
      "filament_cost": [
        "44.99"
      ],
      "filament_density": [
        "1.18"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "1"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "2.2"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "0.4"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "TPU"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "35"
      ],
      "hot_plate_temp_initial_layer": [
        "35"
      ],
      "nozzle_temperature_range_low": [
        "200"
      ],
      "nozzle_temperature_range_high": [
        "240"
      ],
      "nozzle_temperature": [
        "225"
      ],
      "nozzle_temperature_initial_layer": [
        "225"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "95%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "20"
      ],
      "slow_down_min_speed": [
        "10"
      ],
      "temperature_vitrification": [
        "30"
      ],
      "textured_plate_temp": [
        "35"
      ],
      "textured_plate_temp_initial_layer": [
        "35"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >35)||(bed_temperature_initial_layer[current_extruder] >35)}M106 P3 S255\n{elsif(bed_temperature[current_extruder] >30)||(bed_temperature_initial_layer[current_extruder] >30)}M106 P3 S180\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "600"
      ],
      "description": "This filament is too soft and not compatible with the AMS. Printing it is of many requirements, and to get better printing quality, please refer to this wiki: TPU printing guide."
    },
    "model_settings": {
      "H2D": {
        "setting_id": "GFSU04_02",
        "instantiation": "true",
        "additional_cooling_fan_speed": [
          "100"
        ],
        "filament_deretraction_speed": [
          "10",
          "10"
        ],
        "filament_flow_ratio": [
          "1",
          "1"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "2.2",
          "2.2"
        ],
        "filament_ramming_volumetric_speed": [
          "0.55",
          "0.55"
        ],
        "filament_printable": [
          "2"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "2",
          "2"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "10",
          "10"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "195",
          "195"
        ],
        "filament_ramming_travel_time": [
          "20",
          "20"
        ],
        "impact_strength_z": [
          "88.7"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature_range_high": [
          "250"
        ],
        "nozzle_temperature": [
          "225",
          "225"
        ],
        "nozzle_temperature_initial_layer": [
          "225",
          "225"
        ],
        "retraction_distances_when_ec": [
          "0",
          "0"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "P1P": {
        "setting_id": "GFSU04_01",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSU04_00",
        "instantiation": "true",
        "compatible_printers": [
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "GFU98": {
    "filament_id": "GFU98",
    "vendor": "Generic",
    "materialType": "Generic TPU for AMS",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "70"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "1"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "30"
      ],
      "cool_plate_temp_initial_layer": [
        "30"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "30"
      ],
      "eng_plate_temp_initial_layer": [
        "30"
      ],
      "fan_cooling_layer_time": [
        "100"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "100"
      ],
      "filament_cost": [
        "41.99"
      ],
      "filament_density": [
        "1.26"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "1"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "10.5"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "0.8"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "TPU-AMS"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "35"
      ],
      "hot_plate_temp_initial_layer": [
        "35"
      ],
      "nozzle_temperature_range_low": [
        "200"
      ],
      "nozzle_temperature_range_high": [
        "250"
      ],
      "nozzle_temperature": [
        "230"
      ],
      "nozzle_temperature_initial_layer": [
        "230"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "95%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "8"
      ],
      "slow_down_min_speed": [
        "10"
      ],
      "temperature_vitrification": [
        "30"
      ],
      "textured_plate_temp": [
        "35"
      ],
      "textured_plate_temp_initial_layer": [
        "35"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if  (bed_temperature[current_extruder] >35)||(bed_temperature_initial_layer[current_extruder] >35)}M106 P3 S255\n{elsif(bed_temperature[current_extruder] >30)||(bed_temperature_initial_layer[current_extruder] >30)}M106 P3 S180\n{endif}\n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "600"
      ],
      "description": "If you are to print a kind of soft TPU, please don't slice with this profile, and it is only for TPU that has high enough hardness (not less than 55D) and is compatible with the AMS. To get better printing quality, please refer to this wiki: TPU printing guide."
    },
    "model_settings": {
      "A1": {
        "setting_id": "GFSU98_02",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "40"
        ],
        "fan_max_speed": [
          "50"
        ],
        "fan_min_speed": [
          "10"
        ],
        "overhang_fan_threshold": [
          "25%"
        ],
        "slow_down_layer_time": [
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab A1 0.4 nozzle",
          "Bambu Lab A1 0.6 nozzle",
          "Bambu Lab A1 0.8 nozzle"
        ]
      },
      "A1M": {
        "setting_id": "GFSU98_03",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "40"
        ],
        "fan_max_speed": [
          "50"
        ],
        "fan_min_speed": [
          "10"
        ],
        "overhang_fan_threshold": [
          "25%"
        ],
        "slow_down_layer_time": [
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab A1 mini 0.8 nozzle",
          "Bambu Lab A1 mini 0.6 nozzle",
          "Bambu Lab A1 mini 0.4 nozzle"
        ]
      },
      "H2D": {
        "setting_id": "GFSU98_04",
        "instantiation": "true",
        "additional_cooling_fan_speed": [
          "100"
        ],
        "fan_cooling_layer_time": [
          "40"
        ],
        "fan_max_speed": [
          "50"
        ],
        "fan_min_speed": [
          "10"
        ],
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_flow_ratio": [
          "1",
          "1"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "10.5",
          "10.5"
        ],
        "filament_ramming_volumetric_speed": [
          "2.625",
          "2.625"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_pre_cooling_temperature": [
          "200",
          "200"
        ],
        "filament_ramming_travel_time": [
          "20",
          "20"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "230",
          "230"
        ],
        "nozzle_temperature_initial_layer": [
          "230",
          "230"
        ],
        "overhang_fan_threshold": [
          "25%"
        ],
        "retraction_distances_when_ec": [
          "10",
          "10"
        ],
        "slow_down_layer_time": [
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      },
      "P1P": {
        "setting_id": "GFSU98_01",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "40"
        ],
        "fan_max_speed": [
          "50"
        ],
        "fan_min_speed": [
          "10"
        ],
        "overhang_fan_threshold": [
          "25%"
        ],
        "slow_down_layer_time": [
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab P1P 0.6 nozzle",
          "Bambu Lab P1P 0.8 nozzle",
          "Bambu Lab P1P 0.4 nozzle",
          "Bambu Lab X1 0.4 nozzle",
          "Bambu Lab X1 0.6 nozzle",
          "Bambu Lab X1 0.8 nozzle"
        ]
      },
      "X1C": {
        "setting_id": "GFSU98_00",
        "instantiation": "true",
        "fan_cooling_layer_time": [
          "40"
        ],
        "fan_max_speed": [
          "50"
        ],
        "fan_min_speed": [
          "10"
        ],
        "overhang_fan_threshold": [
          "25%"
        ],
        "slow_down_layer_time": [
          "10"
        ],
        "compatible_printers": [
          "Bambu Lab X1 Carbon 0.4 nozzle",
          "Bambu Lab P1S 0.4 nozzle",
          "Bambu Lab P1S 0.6 nozzle",
          "Bambu Lab P1S 0.8 nozzle",
          "Bambu Lab X1 Carbon 0.6 nozzle",
          "Bambu Lab X1 Carbon 0.8 nozzle",
          "Bambu Lab X1E 0.4 nozzle",
          "Bambu Lab X1E 0.6 nozzle",
          "Bambu Lab X1E 0.8 nozzle"
        ]
      }
    }
  },
  "GFU99": {
    "filament_id": "GFU99",
    "vendor": "Generic",
    "materialType": "Generic TPU",
    "base_settings": {
      "instantiation": "false",
      "activate_air_filtration": [
        "0"
      ],
      "additional_cooling_fan_speed": [
        "70"
      ],
      "chamber_temperatures": [
        "0"
      ],
      "close_fan_the_first_x_layers": [
        "1"
      ],
      "complete_print_exhaust_fan_speed": [
        "70"
      ],
      "cool_plate_temp": [
        "30"
      ],
      "cool_plate_temp_initial_layer": [
        "30"
      ],
      "during_print_exhaust_fan_speed": [
        "70"
      ],
      "eng_plate_temp": [
        "30"
      ],
      "eng_plate_temp_initial_layer": [
        "30"
      ],
      "fan_cooling_layer_time": [
        "100"
      ],
      "fan_max_speed": [
        "100"
      ],
      "fan_min_speed": [
        "100"
      ],
      "filament_cost": [
        "20"
      ],
      "filament_density": [
        "1.24"
      ],
      "filament_deretraction_speed": [
        "nil"
      ],
      "filament_diameter": [
        "1.75"
      ],
      "filament_flow_ratio": [
        "1"
      ],
      "filament_flush_temp": [
        "0"
      ],
      "filament_flush_volumetric_speed": [
        "0"
      ],
      "filament_is_support": [
        "0"
      ],
      "filament_long_retractions_when_cut": [
        "nil"
      ],
      "filament_long_retractions_when_ec": [
        "nil"
      ],
      "filament_max_volumetric_speed": [
        "3.2"
      ],
      "filament_ramming_volumetric_speed": [
        "-1"
      ],
      "filament_minimal_purge_on_wipe_tower": [
        "15"
      ],
      "filament_printable": [
        "3"
      ],
      "filament_retract_before_wipe": [
        "nil"
      ],
      "filament_retract_restart_extra": [
        "nil"
      ],
      "filament_retract_when_changing_layer": [
        "nil"
      ],
      "filament_retraction_distances_when_cut": [
        "nil"
      ],
      "filament_retraction_distances_when_ec": [
        "nil"
      ],
      "filament_retraction_length": [
        "0.4"
      ],
      "filament_retraction_minimum_travel": [
        "nil"
      ],
      "filament_retraction_speed": [
        "nil"
      ],
      "filament_settings_id": [
        ""
      ],
      "filament_soluble": [
        "0"
      ],
      "filament_type": [
        "TPU"
      ],
      "filament_wipe": [
        "nil"
      ],
      "filament_wipe_distance": [
        "nil"
      ],
      "filament_prime_volume": [
        "45"
      ],
      "filament_z_hop": [
        "nil"
      ],
      "filament_z_hop_types": [
        "nil"
      ],
      "full_fan_speed_layer": [
        "0"
      ],
      "filament_extruder_id": [
        "1"
      ],
      "filament_extruder_variant": [
        "Direct Drive Standard"
      ],
      "filament_scarf_seam_type": [
        "none"
      ],
      "filament_scarf_height": [
        "10%"
      ],
      "filament_scarf_gap": [
        "0%"
      ],
      "filament_scarf_length": [
        "10"
      ],
      "filament_shrink": [
        "100%"
      ],
      "hot_plate_temp": [
        "35"
      ],
      "hot_plate_temp_initial_layer": [
        "35"
      ],
      "nozzle_temperature_range_low": [
        "200"
      ],
      "nozzle_temperature_range_high": [
        "250"
      ],
      "nozzle_temperature": [
        "240"
      ],
      "nozzle_temperature_initial_layer": [
        "240"
      ],
      "long_retractions_when_ec": [
        "0"
      ],
      "overhang_fan_speed": [
        "100"
      ],
      "overhang_fan_threshold": [
        "95%"
      ],
      "reduce_fan_stop_start_freq": [
        "1"
      ],
      "required_nozzle_HRC": [
        "3"
      ],
      "retraction_distances_when_ec": [
        "0"
      ],
      "supertack_plate_temp": [
        "0"
      ],
      "supertack_plate_temp_initial_layer": [
        "0"
      ],
      "slow_down_for_layer_cooling": [
        "1"
      ],
      "slow_down_layer_time": [
        "8"
      ],
      "slow_down_min_speed": [
        "10"
      ],
      "temperature_vitrification": [
        "30"
      ],
      "textured_plate_temp": [
        "35"
      ],
      "textured_plate_temp_initial_layer": [
        "35"
      ],
      "counter_coef_1": [
        "0"
      ],
      "counter_coef_2": [
        "0.008"
      ],
      "counter_coef_3": [
        "-0.041"
      ],
      "hole_coef_1": [
        "0"
      ],
      "hole_coef_2": [
        "-0.008"
      ],
      "hole_coef_3": [
        "0.23415"
      ],
      "counter_limit_min": [
        "-0.035"
      ],
      "counter_limit_max": [
        "0.033"
      ],
      "hole_limit_min": [
        "0.088"
      ],
      "hole_limit_max": [
        "0.22"
      ],
      "circle_compensation_speed": [
        "200"
      ],
      "diameter_limit": [
        "50"
      ],
      "impact_strength_z": [
        "10"
      ],
      "filament_start_gcode": [
        "; filament start gcode\n{if (bed_temperature[current_extruder] >35)||(bed_temperature_initial_layer[current_extruder] >35)}M106 P3 S255\n{elsif (bed_temperature[current_extruder] >30)||(bed_temperature_initial_layer[current_extruder] >30)}M106 P3 S180\n{endif} \n\n{if activate_air_filtration[current_extruder] && support_air_filtration}\nM106 P3 S{during_print_exhaust_fan_speed_num[current_extruder]} \n{endif}"
      ],
      "filament_end_gcode": [
        "; filament end gcode \n\n"
      ],
      "filament_pre_cooling_temperature": [
        "0"
      ],
      "filament_ramming_travel_time": [
        "0"
      ],
      "filament_adhesiveness_category": [
        "600"
      ],
      "description": "This filament is too soft and not compatible with the AMS. Printing it is of many requirements, and to get better printing quality, please refer to this wiki: TPU printing guide."
    },
    "model_settings": {
      "H2D": {
        "setting_id": "GFSU99_02",
        "instantiation": "true",
        "additional_cooling_fan_speed": [
          "100"
        ],
        "filament_deretraction_speed": [
          "nil",
          "nil"
        ],
        "filament_extruder_variant": [
          "Direct Drive Standard",
          "Direct Drive High Flow"
        ],
        "filament_flow_ratio": [
          "1",
          "1"
        ],
        "filament_flush_temp": [
          "0",
          "0"
        ],
        "filament_flush_volumetric_speed": [
          "0",
          "0"
        ],
        "filament_long_retractions_when_cut": [
          "nil",
          "nil"
        ],
        "filament_max_volumetric_speed": [
          "3.2",
          "3.2"
        ],
        "filament_pre_cooling_temperature": [
          "210",
          "210"
        ],
        "filament_printable": [
          "2"
        ],
        "filament_ramming_travel_time": [
          "20",
          "20"
        ],
        "filament_ramming_volumetric_speed": [
          "0.8",
          "0.8"
        ],
        "filament_retract_before_wipe": [
          "nil",
          "nil"
        ],
        "filament_retract_restart_extra": [
          "nil",
          "nil"
        ],
        "filament_retract_when_changing_layer": [
          "nil",
          "nil"
        ],
        "filament_retraction_distances_when_cut": [
          "nil",
          "nil"
        ],
        "filament_retraction_length": [
          "nil",
          "nil"
        ],
        "filament_retraction_minimum_travel": [
          "nil",
          "nil"
        ],
        "filament_retraction_speed": [
          "nil",
          "nil"
        ],
        "filament_wipe": [
          "nil",
          "nil"
        ],
        "filament_wipe_distance": [
          "nil",
          "nil"
        ],
        "filament_z_hop": [
          "nil",
          "nil"
        ],
        "filament_z_hop_types": [
          "nil",
          "nil"
        ],
        "long_retractions_when_ec": [
          "1",
          "1"
        ],
        "nozzle_temperature": [
          "240",
          "240"
        ],
        "nozzle_temperature_initial_layer": [
          "240",
          "240"
        ],
        "retraction_distances_when_ec": [
          "0",
          "0"
        ],
        "compatible_printers": [
          "Bambu Lab H2D 0.4 nozzle",
          "Bambu Lab H2D 0.6 nozzle",
          "Bambu Lab H2D 0.8 nozzle"
        ],
        "filament_start_gcode": [
          "; filament start gcode\n"
        ],
        "filament_end_gcode": [
          "; filament end gcode \n"
        ]
      }
    }
  }
};

/**
 * Get the filament ID for a given material type
 * @param materialType The type of material (e.g., "PLA Basic", "ABS")
 * @returns The filament ID or null if not found
 */
export function getFilamentId(materialType: string): string | null {
    const profile = FILAMENT_MAPPINGS[materialType.trim()];
    return profile ? profile.filament_id : null;
}

/**
 * Get a reasonable default filament_id for a broad material family (e.g., "PLA", "PETG", "ABS").
 * Preference order:
 * 1) Exact materialType match (case-insensitive)
 * 2) Bambu Lab profile where materialType starts with family + ' ', preferring "Basic" when available
 * 3) Any profile where materialType starts with family + ' '
 * 4) Fallback table of common families
 * Returns empty string if no match found.
 */
export function getDefaultFilamentIdForMaterialType(materialType: string): string {
    const needle = materialType.trim().toUpperCase();
    if (!needle) return "";

    // 1) Exact materialType match
    for (const [fid, profile] of Object.entries(FILAMENT_MAPPINGS)) {
        if (profile.materialType.toUpperCase() === needle) return fid;
    }

    // 2) Bambu Lab startsWith(family + ' '), prefer "Basic"
    const bambuStarts = Object.entries(FILAMENT_MAPPINGS)
        .filter(([, p]) => p.vendor === 'Bambu Lab' && p.materialType.toUpperCase().startsWith(needle + ' '));
    if (bambuStarts.length) {
        const basic = bambuStarts.find(([, p]) => /\bBASIC\b/i.test(p.materialType));
        if (basic) return basic[0];
        // No Basic variant found in Bambu Lab, fall through to try Generic
    }

    // 3) Try Generic vendor if no Bambu Lab Basic found
    const genericMatch = Object.entries(FILAMENT_MAPPINGS)
        .find(([, p]) => p.vendor === 'Generic' && p.materialType.toUpperCase() === 'GENERIC ' + needle);
    if (genericMatch) return genericMatch[0];

    // 4) Any other vendor startsWith(family + ' ') (only if no Bambu Lab variants at all)
    if (!bambuStarts.length) {
        const anyStarts = Object.entries(FILAMENT_MAPPINGS)
            .find(([, p]) => p.materialType.toUpperCase().startsWith(needle + ' '));
        if (anyStarts) return anyStarts[0];
    }

    // 4) Fallback map for common families
    const FALLBACK_TYPE_TO_ID: Record<string, string> = {
        'PLA': 'GFA00',
        'PETG': 'GFG00',
        'ABS': 'GFB00',
        'ASA': 'GFB01',
        'PC': 'GFC00',
        'TPU': 'GFU01',
        'PVA': 'GFS04'
    };
    const fallbackId = FALLBACK_TYPE_TO_ID[needle];
    if (fallbackId && Object.prototype.hasOwnProperty.call(FILAMENT_MAPPINGS, fallbackId)) {
        return fallbackId;
    }

    return "";
}

/**
 * Get all settings for a material type and printer model
 * @param materialType The type of material (e.g., "PLA Basic", "ABS")
 * @param printerModel The printer model (e.g., "X1C", "A1")
 * @returns Combined settings (base + model specific) or null if not found
 */
export function getMaterialSettings(materialType: string, printerModel: string): any | null {
    const normalizedMaterial = materialType.trim();
    const normalizedPrinter = printerModel.replace("BBL ", "").trim();

    const profile = FILAMENT_MAPPINGS[normalizedMaterial];
    if (!profile) return null;

    const modelSettings = profile.model_settings[normalizedPrinter];
    if (!modelSettings) return null;

    return {
        ...profile.base_settings,
        ...modelSettings,
        filament_id: profile.filament_id,
        vendor: profile.vendor
    };
}

/**
 * List all compatible materials for a given printer model
 * @param printerModel The printer model (e.g., "X1C", "A1")
 * @returns Array of compatible material types
 */
export function getCompatibleMaterials(printerModel: string): string[] {
    const normalizedPrinter = printerModel.replace("BBL ", "").trim();
    
    return Object.entries(FILAMENT_MAPPINGS)
        .filter(([_, profile]) => normalizedPrinter in profile.model_settings)
        .map(([materialType]) => materialType);
}

/**
 * Get all supported printer models
 * @returns Array of supported printer models
 */
export function getSupportedPrinters(): string[] {
    const printers = new Set<string>();
    
    Object.values(FILAMENT_MAPPINGS).forEach(profile => {
        Object.keys(profile.model_settings).forEach(printer => {
            printers.add(printer);
        });
    });
    
    return Array.from(printers);
}

/**
 * Check if a material type exists in the mapping
 * @param materialType The material type to check
 * @returns boolean indicating if the material type exists
 */
export function isMaterialTypeSupported(materialType: string): boolean {
    return materialType.trim() in FILAMENT_MAPPINGS;
}

/**
 * Get the vendor for a given material type
 * @param materialType The material type
 * @returns The vendor name or null if material type not found
 */
export function getMaterialVendor(materialType: string): string | null {
    const profile = FILAMENT_MAPPINGS[materialType.trim()];
    return profile ? profile.vendor : null;
}

/**
 * Get base settings for a material type
 * @param materialType The type of material (e.g., "PLA Basic", "ABS")
 * @returns Base settings or null if not found
 */
export function getBaseSettings(materialType: string): any | null {
    const profile = FILAMENT_MAPPINGS[materialType.trim()];
    return profile ? profile.base_settings : null;
}

/**
 * Get settings for a material type and printer model, with fallback to defaults
 * @param materialType The type of material (e.g., "PLA Basic", "ABS")
 * @param printerModel The printer model (e.g., "X1C", "A1")
 * @returns Combined settings (model-specific + base) or null if material not found
 */
export function getFilamentSettings(materialType: string, printerModel: string): any | null {
    const normalizedMaterial = materialType.trim();
    const normalizedPrinter = printerModel.replace("BBL ", "").trim();

    const profile = FILAMENT_MAPPINGS[normalizedMaterial];
    if (!profile) return null;

    // Start with base settings
    const settings = {
        filament_id: profile.filament_id,
        vendor: profile.vendor,
        ...profile.base_settings
    };

    // If model-specific settings exist, override base settings
    const modelSettings = profile.model_settings[normalizedPrinter];
    if (modelSettings) {
        return {
            ...settings,
            ...modelSettings
        };
    }

    return settings;
}

/**
 * Check if model-specific settings exist for a material and printer combination
 * @param materialType The type of material (e.g., "PLA Basic", "ABS")
 * @param printerModel The printer model (e.g., "X1C", "A1")
 * @returns boolean indicating if model-specific settings exist
 */
export function hasModelSpecificSettings(materialType: string, printerModel: string): boolean {
    const normalizedMaterial = materialType.trim();
    const normalizedPrinter = printerModel.replace("BBL ", "").trim();

    const profile = FILAMENT_MAPPINGS[normalizedMaterial];
    return profile ? normalizedPrinter in profile.model_settings : false;
}

/**
 * Get a specific setting value for a material and printer combination
 * @param materialType The type of material (e.g., "PLA Basic", "ABS")
 * @param printerModel The printer model (e.g., "X1C", "A1")
 * @param settingKey The setting key to retrieve
 * @returns The setting value or null if not found
 */
export function getFilamentSetting(materialType: string, printerModel: string, settingKey: string): any | null {
    const settings = getFilamentSettings(materialType, printerModel);
    if (!settings) return null;

    return settings[settingKey] ?? null;
}

/**
 * Get all available setting keys for a material type
 * @param materialType The type of material (e.g., "PLA Basic", "ABS")
 * @returns Array of setting keys or empty array if material not found
 */
export function getAvailableSettings(materialType: string): string[] {
    const profile = FILAMENT_MAPPINGS[materialType.trim()];
    if (!profile) return [];

    const baseKeys = Object.keys(profile.base_settings);
    const modelKeys = new Set<string>();

    // Collect all unique setting keys from model-specific settings
    Object.values(profile.model_settings).forEach(modelSettings => {
        Object.keys(modelSettings).forEach(key => modelKeys.add(key));
    });

    return [...new Set([...baseKeys, ...modelKeys])];
}